var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3137.827,
    height: 1881.769,
    viewBox: "0 0 3137.827 1881.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742",
    x: 0,
    y: 382.447,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-2",
    x: 251.528,
    y: 347.098,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-3",
    x: 503.057,
    y: 311.747,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-4",
    x: 754.584,
    y: 276.397,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-5",
    x: 35.35,
    y: 633.976,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-6",
    x: 286.878,
    y: 598.626,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-7",
    x: 491.275,
    y: 516.092,
    width: 330.415,
    height: 330.415,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0561fc",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-8",
    x: 789.935,
    y: 527.926,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-9",
    x: 70.7,
    y: 885.504,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-10",
    x: 144.983,
    y: 1393.409,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-11",
    x: 322.228,
    y: 850.154,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-12",
    x: 396.511,
    y: 1358.06,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-13",
    x: 573.756,
    y: 814.804,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-14",
    x: 648.039,
    y: 1322.709,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-15",
    x: 825.654,
    y: 779.719,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-16",
    x: 899.937,
    y: 1287.624,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-17",
    x: 180.472,
    y: 1645.928,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-18",
    x: 431.88,
    y: 1610.093,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-19",
    x: 683.528,
    y: 1575.228,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-20",
    x: 935.314,
    y: 1539.34,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-20"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-21",
    x: 983.336,
    y: 244.249,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-21"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-21"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1744",
    x: 1187.918,
    y: 161.799,
    width: 330.415,
    height: 330.415,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur-22"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0561fc",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-22"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-22",
    x: 1486.393,
    y: 173.549,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-23"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-23"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-23",
    x: 1737.92,
    y: 138.198,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-24"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-24"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-24",
    x: 1018.686,
    y: 495.777,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-25"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-25"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-25",
    x: 1270.215,
    y: 460.427,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-26"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-26"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-26",
    x: 1773.271,
    y: 389.727,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-27"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-27"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1746",
    x: 1006.864,
    y: 700.23,
    width: 330.415,
    height: 330.415,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur-28"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0561fc",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-28"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-27",
    x: 1128.319,
    y: 1255.211,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-29"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-29"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-28",
    x: 1521.743,
    y: 425.077,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-30"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-30"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-29",
    x: 1305.565,
    y: 711.955,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-31"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-31"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-30",
    x: 1379.848,
    y: 1219.86,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-32"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-32"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-31",
    x: 1557.092,
    y: 676.605,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-33"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-33"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-32",
    x: 1631.375,
    y: 1184.511,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-34"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-34"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-33",
    x: 1808.99,
    y: 641.52,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-35"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-35"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-34",
    x: 1883.273,
    y: 1149.425,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-36"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-36"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-35",
    x: 1163.809,
    y: 1507.729,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-37"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-37"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-36",
    x: 1415.216,
    y: 1471.894,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-38"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-38"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-37",
    x: 1666.864,
    y: 1437.029,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-39"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-39"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-38",
    x: 1918.65,
    y: 1401.141,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-40"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-40"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-39",
    x: 1966.672,
    y: 106.05,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-41"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-41"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-40",
    x: 2218.201,
    y: 70.7,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-42"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-42"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-41",
    x: 2469.729,
    y: 35.35,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-43"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-43"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-42",
    x: 2721.257,
    y: 0,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-44"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-44"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1745",
    x: 1954.736,
    y: 310.312,
    width: 330.415,
    height: 330.415,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur-45"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0561fc",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-45"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-43",
    x: 2253.551,
    y: 322.229,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-46"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-46"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-44",
    x: 2457.948,
    y: 239.694,
    width: 330.416,
    height: 330.415,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur-47"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0561fc",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-47"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-45",
    x: 2756.607,
    y: 251.528,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-48"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-48"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-46",
    x: 2037.372,
    y: 609.106,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-49"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-49"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-47",
    x: 2111.655,
    y: 1117.012,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-50"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-50"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-48",
    x: 2288.901,
    y: 573.757,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-51"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-51"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-49",
    x: 2363.184,
    y: 1081.662,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-52"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-52"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-50",
    x: 2540.428,
    y: 538.406,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-53"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-53"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-51",
    x: 2614.712,
    y: 1046.312,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-54"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-54"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-52",
    x: 2792.327,
    y: 503.321,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-55"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-55"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-53",
    x: 2866.61,
    y: 1011.227,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-56"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-56"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-54",
    x: 2147.145,
    y: 1369.53,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-57"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-57"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-55",
    x: 2398.552,
    y: 1333.695,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-58"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-58"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-56",
    x: 2650.201,
    y: 1298.83,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-59"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-59"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-57",
    x: 2901.986,
    y: 1262.942,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-60"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-60"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-58",
    x: 109.606,
    y: 1141.693,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-61"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-61"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-59",
    x: 361.135,
    y: 1106.344,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-62"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-62"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-60",
    x: 612.663,
    y: 1070.993,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-63"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-63"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-61",
    x: 864.191,
    y: 1035.644,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-64"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-64"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-62",
    x: 1092.943,
    y: 1003.495,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-65"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-65"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-63",
    x: 1344.471,
    y: 968.145,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-66"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-66"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-64",
    x: 1595.999,
    y: 932.795,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-67"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-67"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1743",
    x: 1800.193,
    y: 850.185,
    width: 330.415,
    height: 330.415,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur-68"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0561fc",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-68"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-65",
    x: 2076.279,
    y: 865.296,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-69"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-69"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-66",
    x: 2327.807,
    y: 829.946,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-70"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-70"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-67",
    x: 2579.336,
    y: 794.596,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-71"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-71"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1742-68",
    x: 2830.864,
    y: 759.246,
    width: 235.841,
    height: 235.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-72"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#545454",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-72"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16281",
    "data-name": "Group 16281",
    transform: "translate(6290.5 11238.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8903",
    "data-name": "Group 8903",
    transform: "translate(-6283.248 -10821.79) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, 50.87, -414.08)",
    filter: "url(#Rectangle_1742)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-69",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(7.5 417.16) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8893",
    "data-name": "Group 8893",
    transform: "translate(29.241 33.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691",
    "data-name": "Path 3691",
    d: "M122.642,91.188a20.076,20.076,0,0,0-25.8-19.266,22.878,22.878,0,0,0-40.8-5.863,10.413,10.413,0,0,0-15.76,8.947v.821a17.836,17.836,0,0,0,1.044,35.3v.082H104.56v-.082a20.1,20.1,0,0,0,18.082-19.935Z",
    transform: "translate(-3.032 -2.068)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1670",
    "data-name": "Rectangle 1670",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692",
    "data-name": "Path 3692",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671",
    "data-name": "Rectangle 1671",
    width: 7.88,
    height: 12.125,
    transform: "translate(6.473 48.161)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672",
    "data-name": "Rectangle 1672",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693",
    "data-name": "Path 3693",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673",
    "data-name": "Rectangle 1673",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674",
    "data-name": "Rectangle 1674",
    width: 22.796,
    height: 14.212,
    transform: "translate(114.778 46.072)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675",
    "data-name": "Rectangle 1675",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694",
    "data-name": "Path 3694",
    d: "M117.384,55.162a3,3,0,1,1-3-3,3,3,0,0,1,3,3Z",
    transform: "translate(11.795 -2.721)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676",
    "data-name": "Rectangle 1676",
    width: 42.825,
    height: 35.754,
    transform: "translate(49.498 93.237)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677",
    "data-name": "Rectangle 1677",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678",
    "data-name": "Rectangle 1678",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679",
    "data-name": "Rectangle 1679",
    width: 38.943,
    height: 6.004,
    transform: "translate(51.443 24.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680",
    "data-name": "Rectangle 1680",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681",
    "data-name": "Rectangle 1681",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294",
    "data-name": "Line 294",
    y2: 17.355,
    transform: "translate(70.91 36.469)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695",
    "data-name": "Path 3695",
    d: "M115.461,61.41v6.52L105.13,78.5",
    transform: "translate(10.715 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696",
    "data-name": "Path 3696",
    d: "M15.22,61.41v6.52L29.808,82.858",
    transform: "translate(-4.807 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697",
    "data-name": "Path 3697",
    d: "M81.083,102.009a17.59,17.59,0,0,0-24.883,0",
    transform: "translate(2.267 4.993)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698",
    "data-name": "Path 3698",
    d: "M76.88,106.03a12.383,12.383,0,0,0-17.59,0",
    transform: "translate(2.802 5.945)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    d: "M71.934,109.763a6.3,6.3,0,0,0-8.924,0",
    transform: "translate(3.443 6.904)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    d: "M69.083,113.269a1.982,1.982,0,1,1-1.976-1.83A1.982,1.982,0,0,1,69.083,113.269Z",
    transform: "translate(3.809 7.512)",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-2",
    "data-name": "Group 8903",
    transform: "translate(-6031.533 -10857.166) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -203.32, -414.08)",
    filter: "url(#Rectangle_1742-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-70",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(259.03 381.81) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2._Cloud_Solution",
    "data-name": "2._Cloud_Solution",
    transform: "translate(33.006 33.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    "data-name": "Path 3701",
    d: "M120.19,55.26A23.6,23.6,0,0,0,89.93,32.63,26.88,26.88,0,0,0,42,25.71,12.24,12.24,0,0,0,23.51,36.22c0,.33,0,.65,0,1a21,21,0,0,0,1.2,41.57v.09H99v-.11a23.61,23.61,0,0,0,21.19-23.51Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1683",
    "data-name": "Rectangle 1683",
    width: 49.59,
    height: 75.46,
    rx: 4.54,
    transform: "translate(38.2 49.54)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684",
    "data-name": "Rectangle 1684",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 58.11)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1685",
    "data-name": "Rectangle 1685",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 74.28)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1686",
    "data-name": "Rectangle 1686",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 90.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687",
    "data-name": "Rectangle 1687",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 106.63)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702",
    "data-name": "Path 3702",
    d: "M124.2,9.91a16.77,16.77,0,0,0-23.71,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3703",
    "data-name": "Path 3703",
    d: "M120.7,14.65a11.82,11.82,0,0,0-16.71,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3704",
    "data-name": "Path 3704",
    d: "M116.6,19.12a6,6,0,0,0-8.51,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    "data-name": "Path 3705",
    d: "M114.23,23a1.89,1.89,0,1,1-1.88-1.88A1.89,1.89,0,0,1,114.23,23Z",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-3",
    "data-name": "Group 8903",
    transform: "translate(-5779.814 -10892.543) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -457.51, -414.08)",
    filter: "url(#Rectangle_1742-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-71",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(510.56 346.46) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_5._Smart_Metering",
    "data-name": "5._Smart_Metering",
    transform: "translate(32.28 33.126)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1691",
    "data-name": "Rectangle 1691",
    width: 82.05,
    height: 84.73,
    rx: 3,
    transform: "translate(9.58 8.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1692",
    "data-name": "Rectangle 1692",
    width: 82.05,
    height: 84.73,
    rx: 3,
    transform: "translate(9.58 8.94)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_315",
    "data-name": "Line 315",
    x2: 82.05,
    transform: "translate(9.58 27.3)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    d: "M27.13,18.12a3.71,3.71,0,1,1-3.71-3.71,3.71,3.71,0,0,1,3.71,3.71Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    "data-name": "Path 3723",
    d: "M39,18.12a3.71,3.71,0,1,1-3.71-3.71A3.71,3.71,0,0,1,39,18.12Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724",
    "data-name": "Path 3724",
    d: "M81.51,18.12a3.71,3.71,0,0,1-3.71,3.71H62.46a3.71,3.71,0,0,1,0-7.42H77.8A3.71,3.71,0,0,1,81.51,18.12Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_316",
    "data-name": "Line 316",
    x2: 19.29,
    transform: "translate(19.71 40.94)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    x2: 37.27,
    transform: "translate(19.71 53.97)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318",
    "data-name": "Line 318",
    x2: 37.27,
    transform: "translate(19.71 67)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319",
    "data-name": "Line 319",
    x2: 37.27,
    transform: "translate(19.71 80.03)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1693",
    "data-name": "Rectangle 1693",
    width: 5.82,
    height: 8.86,
    transform: "translate(52.26 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1694",
    "data-name": "Rectangle 1694",
    width: 5.82,
    height: 8.86,
    transform: "translate(52.26 73.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1695",
    "data-name": "Rectangle 1695",
    width: 49.47,
    height: 52.84,
    transform: "translate(64.52 53.56)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1696",
    "data-name": "Rectangle 1696",
    width: 33.84,
    height: 13.1,
    transform: "translate(72.33 86.86)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1697",
    "data-name": "Rectangle 1697",
    width: 62.33,
    height: 56.21,
    transform: "translate(58.08 37.39)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1698",
    "data-name": "Rectangle 1698",
    width: 48.52,
    height: 42.39,
    transform: "translate(64.99 44.3)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_973",
    "data-name": "Ellipse 973",
    cx: 4.53,
    cy: 4.53,
    r: 4.53,
    transform: "translate(74.42 70.92)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_974",
    "data-name": "Ellipse 974",
    cx: 4.53,
    cy: 4.53,
    r: 4.53,
    transform: "translate(95.02 70.92)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1699",
    "data-name": "Rectangle 1699",
    width: 33.84,
    height: 9.15,
    transform: "translate(72.33 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_320",
    "data-name": "Line 320",
    y2: 9.14,
    transform: "translate(80.79 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321",
    "data-name": "Line 321",
    y2: 9.14,
    transform: "translate(89.25 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322",
    "data-name": "Line 322",
    y2: 9.14,
    transform: "translate(97.71 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725",
    "data-name": "Path 3725",
    d: "M41.18,120.85c-1,.12-1.5-.58-2.08-1.19a4.73,4.73,0,0,0-5.74-1.06,5.17,5.17,0,0,0-1.69,1.46,2.21,2.21,0,0,1-3,.71A18.12,18.12,0,0,1,24,118a2.09,2.09,0,0,1-.69-2.75,4.8,4.8,0,0,0-3.76-6.68,2.14,2.14,0,0,1-2.11-2,14.54,14.54,0,0,1,.13-6.09,2.16,2.16,0,0,1,2-1.76,4.76,4.76,0,0,0,4-6.36,2.2,2.2,0,0,1,.89-2.93A17.65,17.65,0,0,1,28.57,87a2.24,2.24,0,0,1,3.08.65,4.79,4.79,0,0,0,5.09,1.46A4.69,4.69,0,0,0,39,87.63,2.21,2.21,0,0,1,42,87a18.57,18.57,0,0,1,4.74,2.8,2.23,2.23,0,0,1,.78,2.61c-.94,3.22.58,5.75,3.85,6.44,1.18.25,1.74,1.12,2,2.81a16.28,16.28,0,0,1-.17,5.07,2.2,2.2,0,0,1-2,2,4.82,4.82,0,0,0-3.79,6.55,2,2,0,0,1-.7,2.61,17.9,17.9,0,0,1-4.79,2.86,2.2,2.2,0,0,1-.74.1ZM35.3,109.94a6.2,6.2,0,1,0-6.1-6,6.11,6.11,0,0,0,6.1,6Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_975",
    "data-name": "Ellipse 975",
    cx: 7.4,
    cy: 7.4,
    r: 7.4,
    transform: "translate(26.802 109.998) rotate(-80.78)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M104.08,12.13l-3.89,7.3,6.06.07-3.03,7.39",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-4",
    "data-name": "Group 8903",
    transform: "translate(-5528.099 -10927.919) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -711.7, -414.08)",
    filter: "url(#Rectangle_1742-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-72",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(762.08 311.11) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_9._Railways",
    "data-name": "9._Railways",
    transform: "translate(32.771 31.637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1708",
    "data-name": "Rectangle 1708",
    width: 80.23,
    height: 60.67,
    rx: 3,
    transform: "translate(44.1 7.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1709",
    "data-name": "Rectangle 1709",
    width: 80.23,
    height: 60.67,
    rx: 3,
    transform: "translate(44.1 7.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_341",
    "data-name": "Line 341",
    x2: 80.23,
    transform: "translate(44.1 20.58)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    "data-name": "Path 3748",
    d: "M56.66,14A2.66,2.66,0,1,1,54,11.35,2.66,2.66,0,0,1,56.66,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    d: "M65.16,14a2.66,2.66,0,1,1-2.65-2.65A2.66,2.66,0,0,1,65.16,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750",
    "data-name": "Path 3750",
    d: "M117.08,14a2.66,2.66,0,0,1-2.66,2.66H96.28a2.66,2.66,0,1,1,0-5.31h18.14A2.66,2.66,0,0,1,117.08,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_342",
    "data-name": "Line 342",
    x2: 13.81,
    transform: "translate(51.35 30.34)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343",
    "data-name": "Line 343",
    x2: 26.69,
    transform: "translate(51.35 39.67)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_344",
    "data-name": "Line 344",
    x2: 26.69,
    transform: "translate(51.35 49)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_345",
    "data-name": "Line 345",
    x2: 26.69,
    transform: "translate(51.35 58.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710",
    "data-name": "Rectangle 1710",
    width: 27.99,
    height: 27.99,
    transform: "translate(89.09 30.34)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751",
    "data-name": "Path 3751",
    d: "M106.51,104.38a5.82,5.82,0,0,1-5.82,5.82h-69a5.82,5.82,0,0,1-5.82-5.82V41.16A11.64,11.64,0,0,1,37.46,29.52H94.87a11.64,11.64,0,0,1,11.64,11.64Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752",
    "data-name": "Path 3752",
    d: "M31.95,125l6.35-14.8H94.03l6.36,14.8",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_346",
    "data-name": "Line 346",
    x2: 62.08,
    transform: "translate(35.13 118.22)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    "data-name": "Path 3753",
    d: "M42.11,44.72H90.23a5.18,5.18,0,0,1,5.18,5.18V60.83a2.59,2.59,0,0,1-2.59,2.59H39.52a2.59,2.59,0,0,1-2.59-2.59V49.89A5.18,5.18,0,0,1,42.11,44.72Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_347",
    "data-name": "Line 347",
    x2: 43.39,
    transform: "translate(44.47 59.93)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348",
    "data-name": "Line 348",
    x2: 12.12,
    transform: "translate(60.11 91.27)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    d: "M50.5,91.27a6.79,6.79,0,1,1-6.79-6.78,6.79,6.79,0,0,1,6.79,6.78Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    d: "M95.4,91.27a6.78,6.78,0,1,1-6.78-6.78A6.78,6.78,0,0,1,95.4,91.27Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756",
    "data-name": "Path 3756",
    d: "M50.5,91.27a6.79,6.79,0,1,1-6.79-6.78,6.79,6.79,0,0,1,6.79,6.78Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    "data-name": "Path 3757",
    d: "M95.4,91.27a6.78,6.78,0,1,1-6.78-6.78A6.78,6.78,0,0,1,95.4,91.27Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    "data-name": "Path 3758",
    d: "M29.44,13.68a17.33,17.33,0,0,0-24.54,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    "data-name": "Path 3759",
    d: "M26.08,18.56a12.58,12.58,0,0,0-17.82,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    "data-name": "Path 3760",
    d: "M22.73,23.25a7.85,7.85,0,0,0-11.12,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    "data-name": "Path 3761",
    d: "M19.81,27.8a2.64,2.64,0,1,1-2.64-2.64,2.64,2.64,0,0,1,2.64,2.64Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349",
    "data-name": "Line 349",
    y2: 18.7,
    transform: "translate(66.17 44.72)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-5",
    "data-name": "Group 8903",
    transform: "translate(-6247.872 -10570.073) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, 50.87, -668.27)",
    filter: "url(#Rectangle_1742-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-73",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(42.85 668.69) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3._E-Mobility",
    "data-name": "3._E-Mobility",
    transform: "translate(32.1 32.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    "data-name": "Path 3706",
    d: "M49.39,83.21l27.26,8.32,3.14,5.65v13.2H14.16V83.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_970",
    "data-name": "Ellipse 970",
    cx: 34.99,
    cy: 34.99,
    r: 34.99,
    transform: "translate(47.42 10.24)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3707",
    "data-name": "Path 3707",
    d: "M99,39.06a1.12,1.12,0,0,0-1-.57H83.32l2.47-18.83a1.126,1.126,0,0,0-2.06-.74L65.84,50.25a1.12,1.12,0,0,0,.37,1.55,1.18,1.18,0,0,0,.59.16H81.28l-2,18.87a1.12,1.12,0,0,0,2.07.69L99,40.19a1.11,1.11,0,0,0,0-1.13Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3708",
    "data-name": "Path 3708",
    d: "M99,39.06a1.12,1.12,0,0,0-1-.57H83.32l2.47-18.83a1.126,1.126,0,0,0-2.06-.74L65.84,50.25a1.12,1.12,0,0,0,.37,1.55,1.18,1.18,0,0,0,.59.16H81.28l-2,18.87a1.12,1.12,0,0,0,2.07.69L99,40.19a1.11,1.11,0,0,0,0-1.13Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3709",
    "data-name": "Path 3709",
    d: "M49.39,83.21s19.94,5.32,24.7,7.4a9.81,9.81,0,0,1,5.7,6.16v13.61H71.1",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3710",
    "data-name": "Path 3710",
    d: "M14.16,110.38H49.25",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3711",
    "data-name": "Path 3711",
    d: "M14.14,71.08A73.81,73.81,0,0,1,33.8,75.46a84,84,0,0,1,15.59,7.75H14.16",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_295",
    "data-name": "Line 295",
    x2: 8.51,
    transform: "translate(19.1 90.61)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3712",
    "data-name": "Path 3712",
    d: "M71.22,108.72a11.28,11.28,0,0,1-.12,1.66,11.05,11.05,0,0,1-21.85,0,11.281,11.281,0,0,1-.12-1.66,11.045,11.045,0,1,1,22.09,0Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3713",
    "data-name": "Path 3713",
    d: "M65.3,108.72a6.488,6.488,0,0,1,0,.77,5.13,5.13,0,0,1-10.14,0,4.9,4.9,0,0,1-.06-.77,5.13,5.13,0,0,1,10.25,0Z",
    fill: "#c5e1f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-6",
    "data-name": "Group 8903",
    transform: "translate(-5996.156 -10605.449) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -203.32, -668.27)",
    filter: "url(#Rectangle_1742-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-74",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(294.38 633.34) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4._Solar___Wind",
    "data-name": "4._Solar_&_Wind",
    transform: "translate(33.012 32.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3714",
    "data-name": "Path 3714",
    d: "M94.29,61.43A21,21,0,1,1,113.6,32.31",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3715",
    "data-name": "Path 3715",
    d: "M107.64,30.54l6,2.14,2.03-5.7",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3716",
    "data-name": "Path 3716",
    d: "M97.46,40.47a3.17,3.17,0,1,1-2.6-3.124A3.16,3.16,0,0,1,97.46,40.47Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_971",
    "data-name": "Ellipse 971",
    cx: 3.28,
    cy: 16.13,
    rx: 3.28,
    ry: 16.13,
    transform: "translate(91.01 5.06)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3717",
    "data-name": "Path 3717",
    d: "M75.94,47.28a40.74,40.74,0,0,1,15.61-5.22A40.51,40.51,0,0,1,79.22,53a40.31,40.31,0,0,1-15.6,5.22A40.72,40.72,0,0,1,75.94,47.28Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3718",
    "data-name": "Path 3718",
    d: "M109.35,53A40.51,40.51,0,0,1,97,42.06a41.25,41.25,0,0,1,28,16.12A40.31,40.31,0,0,1,109.35,53Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    "data-name": "Path 3719",
    d: "M97,124.93H91.63l1-81.74a3.14,3.14,0,0,0,3.24,0Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3747",
    "data-name": "Path 3747",
    d: "M119.91,0H0",
    transform: "translate(5.04 124.93)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    "data-name": "Path 3720",
    d: "M68.92,112.82H45.05l9.92-18.68H78.84Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_297",
    "data-name": "Line 297",
    y1: 18.68,
    x2: 9.93,
    transform: "translate(60.96 94.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_298",
    "data-name": "Line 298",
    y1: 18.68,
    x2: 9.92,
    transform: "translate(53.01 94.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_299",
    "data-name": "Line 299",
    x1: 23.88,
    transform: "translate(48.35 106.6)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_300",
    "data-name": "Line 300",
    x1: 23.87,
    transform: "translate(51.68 100.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1688",
    "data-name": "Rectangle 1688",
    width: 4.94,
    height: 12.1,
    transform: "translate(59.48 112.82)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_301",
    "data-name": "Line 301",
    y2: 4.98,
    transform: "translate(21.49 34.15)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302",
    "data-name": "Line 302",
    y2: 4.97,
    transform: "translate(21.49 5.07)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_303",
    "data-name": "Line 303",
    x2: 2.85,
    y2: 4.08,
    transform: "translate(28.41 31.97)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_304",
    "data-name": "Line 304",
    x2: 2.85,
    y2: 4.07,
    transform: "translate(11.73 8.15)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_305",
    "data-name": "Line 305",
    x2: 4.68,
    y2: 1.7,
    transform: "translate(32.82 26.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    x2: 4.68,
    y2: 1.7,
    transform: "translate(5.49 16.27)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    y1: 1.29,
    x2: 4.81,
    transform: "translate(33.14 17.69)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_308",
    "data-name": "Line 308",
    y1: 1.29,
    x2: 4.81,
    transform: "translate(5.04 25.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_309",
    "data-name": "Line 309",
    y1: 3.81,
    x2: 3.2,
    transform: "translate(29.24 9.05)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_310",
    "data-name": "Line 310",
    y1: 3.82,
    x2: 3.2,
    transform: "translate(10.55 31.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_972",
    "data-name": "Ellipse 972",
    cx: 7.74,
    cy: 7.74,
    r: 7.74,
    transform: "translate(12.185 27.856) rotate(-76.72)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3721",
    "data-name": "Path 3721",
    d: "M35.55,112.82H11.68L21.6,94.14H45.47Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_311",
    "data-name": "Line 311",
    y1: 18.68,
    x2: 9.92,
    transform: "translate(27.59 94.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_312",
    "data-name": "Line 312",
    y1: 18.68,
    x2: 9.92,
    transform: "translate(19.63 94.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_313",
    "data-name": "Line 313",
    x1: 23.87,
    transform: "translate(14.98 106.6)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_314",
    "data-name": "Line 314",
    x1: 23.87,
    transform: "translate(18.31 100.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1689",
    "data-name": "Rectangle 1689",
    width: 4.94,
    height: 12.1,
    transform: "translate(26.1 112.82)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-7",
    "data-name": "Group 8903",
    transform: "translate(-5761.725 -10653.854) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -442.2, -652.96)",
    filter: "url(#Rectangle_1742-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-75",
    "data-name": "Rectangle 1742",
    width: 226.143,
    height: 226.143,
    rx: 14,
    transform: "translate(528.78 585.06) rotate(-8)",
    fill: "#0561fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8893-2",
    "data-name": "Group 8893",
    transform: "translate(33.168 39.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691-2",
    "data-name": "Path 3691",
    d: "M137.85,96.706a23.219,23.219,0,0,0-29.837-22.283A26.46,26.46,0,0,0,60.83,67.642,12.043,12.043,0,0,0,42.6,77.99c0,.326,0,.637,0,.949a20.628,20.628,0,0,0,1.207,40.822v.095h73.128v-.095A23.246,23.246,0,0,0,137.85,96.706Z",
    transform: "translate(0.486 6.367)",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1670-2",
    "data-name": "Rectangle 1670",
    width: 24.1,
    height: 21.727,
    transform: "translate(0 47.997)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692-2",
    "data-name": "Path 3692",
    d: "M30.44,48.57H6.34L18.4,36.5Z",
    transform: "translate(-6.34 -0.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671-2",
    "data-name": "Rectangle 1671",
    width: 9.114,
    height: 14.023,
    transform: "translate(7.486 55.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672-2",
    "data-name": "Rectangle 1672",
    width: 24.1,
    height: 21.727,
    transform: "translate(0 47.997)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693-2",
    "data-name": "Path 3693",
    d: "M30.44,48.57H6.34L18.4,36.5Z",
    transform: "translate(-6.34 -0.56)",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673-2",
    "data-name": "Rectangle 1673",
    width: 26.365,
    height: 43.806,
    transform: "translate(132.748 25.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674-2",
    "data-name": "Rectangle 1674",
    width: 26.365,
    height: 16.437,
    transform: "translate(132.748 53.285)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675-2",
    "data-name": "Rectangle 1675",
    width: 26.365,
    height: 43.806,
    transform: "translate(132.748 25.918)",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694-2",
    "data-name": "Path 3694",
    d: "M118.324,55.632a3.472,3.472,0,1,1-3.472-3.472,3.472,3.472,0,0,1,3.472,3.472Z",
    transform: "translate(31.079 5.019)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676-2",
    "data-name": "Rectangle 1676",
    width: 49.529,
    height: 41.351,
    transform: "translate(57.247 107.835)",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677-2",
    "data-name": "Rectangle 1677",
    width: 23.395,
    height: 6.944,
    transform: "translate(70.321 35.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678-2",
    "data-name": "Rectangle 1678",
    width: 45.04,
    height: 35.235,
    transform: "translate(59.497 0)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679-2",
    "data-name": "Rectangle 1679",
    width: 45.04,
    height: 6.944,
    transform: "translate(59.497 28.278)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680-2",
    "data-name": "Rectangle 1680",
    width: 45.04,
    height: 35.235,
    transform: "translate(59.497 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681-2",
    "data-name": "Rectangle 1681",
    width: 23.395,
    height: 6.944,
    transform: "translate(70.321 35.236)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294-2",
    "data-name": "Line 294",
    y2: 20.072,
    transform: "translate(82.012 42.178)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695-2",
    "data-name": "Path 3695",
    d: "M117.078,61.41v7.541L105.13,81.17",
    transform: "translate(28.852 8.314)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696-2",
    "data-name": "Path 3696",
    d: "M15.22,61.41v7.541L32.091,86.215",
    transform: "translate(-3.177 8.314)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697-2",
    "data-name": "Path 3697",
    d: "M84.979,102.816a20.343,20.343,0,0,0-28.779,0",
    transform: "translate(11.421 20.938)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698-2",
    "data-name": "Path 3698",
    d: "M79.633,106.6a14.322,14.322,0,0,0-20.343,0",
    transform: "translate(12.523 22.902)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699-2",
    "data-name": "Path 3699",
    d: "M73.331,110.053a7.283,7.283,0,0,0-10.321,0",
    transform: "translate(13.847 24.879)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700-2",
    "data-name": "Path 3700",
    d: "M69.7,113.556a2.292,2.292,0,1,1-2.285-2.116A2.292,2.292,0,0,1,69.7,113.556Z",
    transform: "translate(14.601 26.136)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-8",
    "data-name": "Group 8903",
    transform: "translate(-5492.723 -10676.202) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -711.7, -668.27)",
    filter: "url(#Rectangle_1742-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-76",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(797.43 562.64) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_32._IP_Core-FPGA",
    "data-name": "32._IP Core-FPGA",
    transform: "translate(32.381 32.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3689",
    "data-name": "Path 3689",
    d: "M19.86,19.86v90.28h90.28V19.86ZM94.94,94.93H35.06V35.07H94.94Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1667",
    "data-name": "Rectangle 1667",
    width: 90.27,
    height: 90.27,
    transform: "translate(19.86 19.86)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270",
    "data-name": "Line 270",
    y1: 12.57,
    transform: "translate(36.59 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271",
    "data-name": "Line 271",
    y1: 12.57,
    transform: "translate(50.79 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_272",
    "data-name": "Line 272",
    y1: 12.57,
    transform: "translate(65 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_273",
    "data-name": "Line 273",
    y1: 12.57,
    transform: "translate(79.21 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_274",
    "data-name": "Line 274",
    y1: 12.57,
    transform: "translate(93.41 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_275",
    "data-name": "Line 275",
    y1: 12.57,
    transform: "translate(36.59 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_276",
    "data-name": "Line 276",
    y1: 12.57,
    transform: "translate(50.79 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_277",
    "data-name": "Line 277",
    y1: 12.57,
    transform: "translate(65 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278",
    "data-name": "Line 278",
    y1: 12.57,
    transform: "translate(79.21 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_279",
    "data-name": "Line 279",
    y1: 12.57,
    transform: "translate(93.41 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_280",
    "data-name": "Line 280",
    x2: 12.57,
    transform: "translate(110.14 36.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_281",
    "data-name": "Line 281",
    x2: 12.57,
    transform: "translate(110.14 50.79)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282",
    "data-name": "Line 282",
    x2: 12.57,
    transform: "translate(110.14 65)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    x2: 12.57,
    transform: "translate(110.14 79.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    x2: 12.57,
    transform: "translate(110.14 93.41)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285",
    "data-name": "Line 285",
    x2: 12.57,
    transform: "translate(7.29 36.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286",
    "data-name": "Line 286",
    x2: 12.57,
    transform: "translate(7.29 50.79)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_287",
    "data-name": "Line 287",
    x2: 12.57,
    transform: "translate(7.29 65)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_288",
    "data-name": "Line 288",
    x2: 12.57,
    transform: "translate(7.29 79.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_289",
    "data-name": "Line 289",
    x2: 12.57,
    transform: "translate(7.29 93.41)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1668",
    "data-name": "Rectangle 1668",
    width: 59.87,
    height: 59.87,
    transform: "translate(35.06 35.06)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_290",
    "data-name": "Line 290",
    y2: 17.13,
    transform: "translate(49.2 77.81)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_967",
    "data-name": "Ellipse 967",
    cx: 6.39,
    cy: 6.39,
    r: 6.39,
    transform: "translate(42.81 71.42)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    "data-name": "Path 3690",
    d: "M76.47,65H57.19V51.82H35.06",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_291",
    "data-name": "Line 291",
    y2: 32.53,
    transform: "translate(76.47 35.06)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_292",
    "data-name": "Line 292",
    y2: 27.35,
    transform: "translate(76.47 67.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_293",
    "data-name": "Line 293",
    x1: 18.47,
    transform: "translate(76.47 84.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_968",
    "data-name": "Ellipse 968",
    cx: 6.39,
    cy: 6.39,
    r: 6.39,
    transform: "translate(50.8 45.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_969",
    "data-name": "Ellipse 969",
    cx: 6.39,
    cy: 6.39,
    r: 6.39,
    transform: "translate(70.08 58.61)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-9",
    "data-name": "Group 8903",
    transform: "translate(-6212.495 -10318.357) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, 50.87, -922.46)",
    filter: "url(#Rectangle_1742-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-77",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(78.2 920.22) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7._Home_Automation",
    "data-name": "7._Home_Automation",
    transform: "translate(33.091 32.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M109.71,75.32V125H85.95V75.32h.11l2.72,2.73h8.43l-2.73-2.73Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3728",
    "data-name": "Path 3728",
    d: "M44.1,75.32V125H20.34V75.32H35.59l-2.71,2.73H41.3l2.71-2.73Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701",
    "data-name": "Rectangle 1701",
    width: 9.51,
    height: 9.51,
    transform: "translate(93.07 95.4)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702",
    "data-name": "Rectangle 1702",
    width: 9.51,
    height: 9.51,
    transform: "translate(27.47 95.4)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3729",
    "data-name": "Path 3729",
    d: "M85.95,75.21V125H44.1V75.22l6.01-6.05,3.56-3.59L65.02,54.23,76.34,65.57l3.58,3.59Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3730",
    "data-name": "Path 3730",
    d: "M69.75,78.65H60.23V73.89A4.76,4.76,0,0,1,65,69.13h0a4.76,4.76,0,0,1,4.76,4.76Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1703",
    "data-name": "Rectangle 1703",
    width: 19.18,
    height: 31.68,
    transform: "translate(55.4 93.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323",
    "data-name": "Line 323",
    x2: 111.7,
    transform: "translate(9.15 125)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731",
    "data-name": "Path 3731",
    d: "M115.85,75.32H94.48l-6.17-6.19h.02L69.89,50.67H91.24l18.44,18.46h.02v.03Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3732",
    "data-name": "Path 3732",
    d: "M41.69,69.13h.05l-6.15,6.19H14.13l6.19-6.19L38.76,50.67H60.15Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733",
    "data-name": "Path 3733",
    d: "M109.71,69.13v.02l-.02-.02Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324",
    "data-name": "Line 324",
    x1: 0.01,
    transform: "translate(109.7 75.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734",
    "data-name": "Path 3734",
    d: "M97.21,78.05H88.78l-2.72-2.73-.11-.11-6.03-6.05-3.58-3.59L65.02,54.23,53.67,65.58l-3.56,3.59L44.1,75.22l-.09.1L41.3,78.05H32.88l2.71-2.73,6.15-6.19,7.71-7.76L65.02,45.81,80.56,61.35l7.75,7.78,6.17,6.19Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325",
    "data-name": "Line 325",
    y2: 1.96,
    transform: "translate(60.09 108.18)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_326",
    "data-name": "Line 326",
    x1: 21.35,
    transform: "translate(30.57 58.89)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327",
    "data-name": "Line 327",
    x1: 21.35,
    transform: "translate(22.29 67.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328",
    "data-name": "Line 328",
    x2: 21.35,
    transform: "translate(78.02 58.89)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329",
    "data-name": "Line 329",
    x2: 21.35,
    transform: "translate(86.3 67.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735",
    "data-name": "Path 3735",
    d: "M83,12.46a25.49,25.49,0,0,0-36,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736",
    "data-name": "Path 3736",
    d: "M78.08,17.4a18.49,18.49,0,0,0-26.18,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    d: "M73.15,22.32a11.54,11.54,0,0,0-16.32,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    "data-name": "Path 3738",
    d: "M68.87,28.53A3.88,3.88,0,1,1,65,24.66,3.88,3.88,0,0,1,68.87,28.53Z",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8909",
    "data-name": "Group 8909",
    transform: "translate(-6138.212 -9810.452) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, 48, -1435.76)",
    filter: "url(#Rectangle_1742-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-78",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(152.48 1428.12) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7._Home_Automation-2",
    "data-name": "7._Home_Automation",
    transform: "translate(33.091 32.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3727-2",
    "data-name": "Path 3727",
    d: "M109.71,75.32V125H85.95V75.32h.11l2.72,2.73h8.43l-2.73-2.73Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3728-2",
    "data-name": "Path 3728",
    d: "M44.1,75.32V125H20.34V75.32H35.59l-2.71,2.73H41.3l2.71-2.73Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701-2",
    "data-name": "Rectangle 1701",
    width: 9.51,
    height: 9.51,
    transform: "translate(93.07 95.4)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702-2",
    "data-name": "Rectangle 1702",
    width: 9.51,
    height: 9.51,
    transform: "translate(27.47 95.4)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3729-2",
    "data-name": "Path 3729",
    d: "M85.95,75.21V125H44.1V75.22l6.01-6.05,3.56-3.59L65.02,54.23,76.34,65.57l3.58,3.59Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3730-2",
    "data-name": "Path 3730",
    d: "M69.75,78.65H60.23V73.89A4.76,4.76,0,0,1,65,69.13h0a4.76,4.76,0,0,1,4.76,4.76Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1703-2",
    "data-name": "Rectangle 1703",
    width: 19.18,
    height: 31.68,
    transform: "translate(55.4 93.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323-2",
    "data-name": "Line 323",
    x2: 111.7,
    transform: "translate(9.15 125)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731-2",
    "data-name": "Path 3731",
    d: "M115.85,75.32H94.48l-6.17-6.19h.02L69.89,50.67H91.24l18.44,18.46h.02v.03Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3732-2",
    "data-name": "Path 3732",
    d: "M41.69,69.13h.05l-6.15,6.19H14.13l6.19-6.19L38.76,50.67H60.15Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733-2",
    "data-name": "Path 3733",
    d: "M109.71,69.13v.02l-.02-.02Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324-2",
    "data-name": "Line 324",
    x1: 0.01,
    transform: "translate(109.7 75.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734-2",
    "data-name": "Path 3734",
    d: "M97.21,78.05H88.78l-2.72-2.73-.11-.11-6.03-6.05-3.58-3.59L65.02,54.23,53.67,65.58l-3.56,3.59L44.1,75.22l-.09.1L41.3,78.05H32.88l2.71-2.73,6.15-6.19,7.71-7.76L65.02,45.81,80.56,61.35l7.75,7.78,6.17,6.19Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325-2",
    "data-name": "Line 325",
    y2: 1.96,
    transform: "translate(60.09 108.18)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_326-2",
    "data-name": "Line 326",
    x1: 21.35,
    transform: "translate(30.57 58.89)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327-2",
    "data-name": "Line 327",
    x1: 21.35,
    transform: "translate(22.29 67.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328-2",
    "data-name": "Line 328",
    x2: 21.35,
    transform: "translate(78.02 58.89)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329-2",
    "data-name": "Line 329",
    x2: 21.35,
    transform: "translate(86.3 67.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735-2",
    "data-name": "Path 3735",
    d: "M83,12.46a25.49,25.49,0,0,0-36,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736-2",
    "data-name": "Path 3736",
    d: "M78.08,17.4a18.49,18.49,0,0,0-26.18,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737-2",
    "data-name": "Path 3737",
    d: "M73.15,22.32a11.54,11.54,0,0,0-16.32,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738-2",
    "data-name": "Path 3738",
    d: "M68.87,28.53A3.88,3.88,0,1,1,65,24.66,3.88,3.88,0,0,1,68.87,28.53Z",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-10",
    "data-name": "Group 8903",
    transform: "translate(-5960.78 -10353.733) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -203.32, -922.46)",
    filter: "url(#Rectangle_1742-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-79",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(329.73 884.87) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_12._Digital_Signage",
    "data-name": "12._Digital Signage",
    transform: "translate(40.192 32.677)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711",
    "data-name": "Rectangle 1711",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712",
    "data-name": "Rectangle 1712",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350",
    "data-name": "Line 350",
    x2: 85.52,
    transform: "translate(2.86 18.02)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762",
    "data-name": "Path 3762",
    d: "M16.25,11a2.83,2.83,0,1,1-.825-2.008A2.84,2.84,0,0,1,16.25,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    "data-name": "Path 3763",
    d: "M25.31,11a2.83,2.83,0,1,1-.825-2.008A2.83,2.83,0,0,1,25.31,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    d: "M80.65,11a2.83,2.83,0,0,1-2.83,2.83H58.48a2.83,2.83,0,1,1,0-5.66H77.82A2.83,2.83,0,0,1,80.65,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351",
    "data-name": "Line 351",
    x2: 14.73,
    transform: "translate(10.58 28.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352",
    "data-name": "Line 352",
    x2: 28.45,
    transform: "translate(10.58 38.38)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353",
    "data-name": "Line 353",
    x2: 28.45,
    transform: "translate(10.58 48.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354",
    "data-name": "Line 354",
    x2: 28.45,
    transform: "translate(10.58 58.27)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713",
    "data-name": "Rectangle 1713",
    width: 29.84,
    height: 29.84,
    transform: "translate(50.81 28.43)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715",
    "data-name": "Rectangle 1715",
    width: 45.28,
    height: 67.63,
    transform: "translate(67.01 28.74)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716",
    "data-name": "Rectangle 1716",
    width: 45.28,
    height: 7.5,
    transform: "translate(67.01 118.18)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717",
    "data-name": "Rectangle 1717",
    width: 10.84,
    height: 21.81,
    transform: "translate(84.23 96.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    "data-name": "Path 3765",
    d: "M89.61,76.09a13.53,13.53,0,1,1,13.57-13.51A13.53,13.53,0,0,1,89.61,76.09Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    "data-name": "Path 3766",
    d: "M86.27,62.55v-4a1,1,0,0,1,.45-1,.93.93,0,0,1,1,.13l6.4,4c.78.49.77,1.17,0,1.65l-6.4,4c-.33.2-.71.4-1,.11a1.53,1.53,0,0,1-.44-.93C86.24,65.23,86.27,63.89,86.27,62.55Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8910",
    "data-name": "Group 8910",
    transform: "translate(-5886.497 -9845.828) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -206.19, -1435.76)",
    filter: "url(#Rectangle_1742-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-80",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(404.01 1392.77) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_12._Digital_Signage-2",
    "data-name": "12._Digital Signage",
    transform: "translate(40.192 32.677)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711-2",
    "data-name": "Rectangle 1711",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712-2",
    "data-name": "Rectangle 1712",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350-2",
    "data-name": "Line 350",
    x2: 85.52,
    transform: "translate(2.86 18.02)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762-2",
    "data-name": "Path 3762",
    d: "M16.25,11a2.83,2.83,0,1,1-.825-2.008A2.84,2.84,0,0,1,16.25,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763-2",
    "data-name": "Path 3763",
    d: "M25.31,11a2.83,2.83,0,1,1-.825-2.008A2.83,2.83,0,0,1,25.31,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764-2",
    "data-name": "Path 3764",
    d: "M80.65,11a2.83,2.83,0,0,1-2.83,2.83H58.48a2.83,2.83,0,1,1,0-5.66H77.82A2.83,2.83,0,0,1,80.65,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351-2",
    "data-name": "Line 351",
    x2: 14.73,
    transform: "translate(10.58 28.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352-2",
    "data-name": "Line 352",
    x2: 28.45,
    transform: "translate(10.58 38.38)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353-2",
    "data-name": "Line 353",
    x2: 28.45,
    transform: "translate(10.58 48.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354-2",
    "data-name": "Line 354",
    x2: 28.45,
    transform: "translate(10.58 58.27)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713-2",
    "data-name": "Rectangle 1713",
    width: 29.84,
    height: 29.84,
    transform: "translate(50.81 28.43)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715-2",
    "data-name": "Rectangle 1715",
    width: 45.28,
    height: 67.63,
    transform: "translate(67.01 28.74)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716-2",
    "data-name": "Rectangle 1716",
    width: 45.28,
    height: 7.5,
    transform: "translate(67.01 118.18)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717-2",
    "data-name": "Rectangle 1717",
    width: 10.84,
    height: 21.81,
    transform: "translate(84.23 96.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765-2",
    "data-name": "Path 3765",
    d: "M89.61,76.09a13.53,13.53,0,1,1,13.57-13.51A13.53,13.53,0,0,1,89.61,76.09Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766-2",
    "data-name": "Path 3766",
    d: "M86.27,62.55v-4a1,1,0,0,1,.45-1,.93.93,0,0,1,1,.13l6.4,4c.78.49.77,1.17,0,1.65l-6.4,4c-.33.2-.71.4-1,.11a1.53,1.53,0,0,1-.44-.93C86.24,65.23,86.27,63.89,86.27,62.55Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-11",
    "data-name": "Group 8903",
    transform: "translate(-5709.062 -10389.11) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -457.51, -922.46)",
    filter: "url(#Rectangle_1742-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-81",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(581.26 849.52) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_73._APIs-SDK_for_real-time_tracking",
    "data-name": "73._APIs-SDK for real-time tracking",
    transform: "translate(32.95 32.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3767",
    "data-name": "Path 3767",
    d: "M37.08,96.63l18.09,18.09H66.19",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    y1: 20.64,
    transform: "translate(19.04 49.71)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768",
    "data-name": "Path 3768",
    d: "M35.91,52.88V22.71H28.05",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769",
    "data-name": "Path 3769",
    d: "M83.2,96.63v10.91H99.16",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M100.08,46.93c.22-2.56-.33-4-2-4.77a7.13,7.13,0,0,1-4.39-9.08,6.8,6.8,0,0,1,.82-1.64,3.39,3.39,0,0,0-.32-4.1,28.22,28.22,0,0,0-6.06-5.64,3.3,3.3,0,0,0-4.63-.05,7,7,0,0,1-3.83,1.46,7.22,7.22,0,0,1-7-3.79,3.33,3.33,0,0,0-4.3-1.94,26.67,26.67,0,0,0-6.93,2.15,3.33,3.33,0,0,0-2.25,4A7.19,7.19,0,0,1,53,31.62a7.44,7.44,0,0,1-1.7,0,3.26,3.26,0,0,0-3.5,1.93,22,22,0,0,0-2.16,8.94,3.23,3.23,0,0,0,2.45,3.64,7.21,7.21,0,0,1,3.38,11,3.14,3.14,0,0,0,.13,4.26,26.89,26.89,0,0,0,6.07,5.64,3.33,3.33,0,0,0,4.6-.03,7.77,7.77,0,0,1,2.95-1.59,7.12,7.12,0,0,1,8.12,3.42c.65,1.08,1.19,2.27,2.67,2.42a3.52,3.52,0,0,0,1.17.08,26.8,26.8,0,0,0,8-2.69A3.07,3.07,0,0,0,87,65a7.26,7.26,0,0,1,6-8.34,6.91,6.91,0,0,1,1.7-.08,3.34,3.34,0,0,0,3.54-2.27A26,26,0,0,0,100.08,46.93ZM70.82,53.29a7.639,7.639,0,1,1,0,.02Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770",
    "data-name": "Path 3770",
    d: "M111,77.16A19.47,19.47,0,0,0,86,58.48a22.17,22.17,0,0,0-39.54-5.71,10.1,10.1,0,0,0-15.28,8.67c0,.27,0,.54,0,.8a17.3,17.3,0,0,0,1,34.31v.08H93.43v-.1A19.47,19.47,0,0,0,111,77.16Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_976",
    "data-name": "Ellipse 976",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(15.76 16.58)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_977",
    "data-name": "Ellipse 977",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(12.91 44.58)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_978",
    "data-name": "Ellipse 978",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(64.62 108.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_979",
    "data-name": "Ellipse 979",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(90.37 101.41)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_980",
    "data-name": "Ellipse 980",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(104.83 30.36)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_981",
    "data-name": "Ellipse 981",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(94.58 9.15)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_356",
    "data-name": "Line 356",
    y2: 33.21,
    transform: "translate(110.96 42.62)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771",
    "data-name": "Path 3771",
    d: "M33.13,82h-5l-.85,2.41h-2L29.54,72.6h2.25L36,84.43H34Zm-.55-1.58L30.66,75l-1.93,5.49Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772",
    "data-name": "Path 3772",
    d: "M45.69,77.84a3.23,3.23,0,0,1-1.36,1.3,5.09,5.09,0,0,1-2.4.5H39.79v4.79H37.85V72.62h4.08a5.06,5.06,0,0,1,2.31.47,3.34,3.34,0,0,1,1.41,1.26,3.48,3.48,0,0,1,.46,1.79A3.62,3.62,0,0,1,45.69,77.84Zm-2.11-.29a1.82,1.82,0,0,0,.54-1.41c0-1.3-.73-1.94-2.19-1.94H39.79v3.86h2.14a2.33,2.33,0,0,0,1.65-.51Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773",
    "data-name": "Path 3773",
    d: "M49.9,72.62V84.43H48V72.62Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3774",
    "data-name": "Path 3774",
    d: "M53.87,84.18a3.49,3.49,0,0,1-1.38-1.08,2.8,2.8,0,0,1-.55-1.54h2a1.33,1.33,0,0,0,.57,1,2,2,0,0,0,1.3.4,2.17,2.17,0,0,0,1.26-.31,1,1,0,0,0,.45-.81.82.82,0,0,0-.5-.78,8.811,8.811,0,0,0-1.59-.56,17.249,17.249,0,0,1-1.71-.56,3.06,3.06,0,0,1-1.15-.84,2.18,2.18,0,0,1-.48-1.48,2.25,2.25,0,0,1,.44-1.36,2.87,2.87,0,0,1,1.26-1,4.7,4.7,0,0,1,1.9-.36,3.9,3.9,0,0,1,2.57.81,2.89,2.89,0,0,1,1,2.2H57.38a1.35,1.35,0,0,0-.51-1,1.89,1.89,0,0,0-1.24-.38,2,2,0,0,0-1.17.29.9.9,0,0,0-.41.77.83.83,0,0,0,.27.63,2,2,0,0,0,.66.4l1.16.36a13.061,13.061,0,0,1,1.67.55,3,3,0,0,1,1.13.83,2.15,2.15,0,0,1,.5,1.44A2.45,2.45,0,0,1,59,83.24a3,3,0,0,1-1.25,1,4.81,4.81,0,0,1-1.9.35,4.67,4.67,0,0,1-1.98-.41Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775",
    "data-name": "Path 3775",
    d: "M72.5,84.17A3.54,3.54,0,0,1,71,83a3,3,0,0,1-.55-1.79h2.08a1.88,1.88,0,0,0,.6,1.26,2.15,2.15,0,0,0,1.51.5,2.31,2.31,0,0,0,1.57-.49,1.58,1.58,0,0,0,.56-1.25,1.37,1.37,0,0,0-.35-1,2.33,2.33,0,0,0-.87-.58,11.84,11.84,0,0,0-1.44-.44,14.24,14.24,0,0,1-1.88-.62,3.14,3.14,0,0,1-1.23-1,2.86,2.86,0,0,1-.51-1.77A3.14,3.14,0,0,1,71,74.06a3.22,3.22,0,0,1,1.43-1.18,5.22,5.22,0,0,1,2.13-.41,4.44,4.44,0,0,1,2.81.86,3.16,3.16,0,0,1,1.22,2.36H76.46a1.54,1.54,0,0,0-.62-1.1,2.24,2.24,0,0,0-1.48-.46,2.1,2.1,0,0,0-1.36.42,1.5,1.5,0,0,0-.53,1.23,1.24,1.24,0,0,0,.33.89,2.24,2.24,0,0,0,.85.55,12.09,12.09,0,0,0,1.39.45,14.749,14.749,0,0,1,1.92.64,3.28,3.28,0,0,1,1.26,1,2.92,2.92,0,0,1,.52,1.8,3.16,3.16,0,0,1-.49,1.7,3.47,3.47,0,0,1-1.41,1.29,4.71,4.71,0,0,1-2.19.48,5.49,5.49,0,0,1-2.15-.41Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3776",
    "data-name": "Path 3776",
    d: "M88.22,73.35a5.17,5.17,0,0,1,2.19,2.08,6.2,6.2,0,0,1,.78,3.16,6.06,6.06,0,0,1-.78,3.13,5.09,5.09,0,0,1-2.19,2,7.41,7.41,0,0,1-3.32.7H81V72.63h3.9A7.28,7.28,0,0,1,88.22,73.35Zm-.13,8.41a4.32,4.32,0,0,0,1.1-3.17,4.45,4.45,0,0,0-1.1-3.22,4.22,4.22,0,0,0-3.19-1.16H83v8.67h1.9a4.32,4.32,0,0,0,3.19-1.12Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777",
    "data-name": "Path 3777",
    d: "M99.64,84.46l-4.59-5.29v5.29H93.11V72.63h1.94V78l4.6-5.4h2.44l-5.15,5.92,5.23,5.91Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    "data-name": "Line 357",
    y2: 14.17,
    transform: "translate(65 71.44)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8913",
    "data-name": "Group 8913",
    transform: "translate(-5634.778 -9881.205) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -460.38, -1435.76)",
    filter: "url(#Rectangle_1742-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-82",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(655.54 1357.42) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_73._APIs-SDK_for_real-time_tracking-2",
    "data-name": "73._APIs-SDK for real-time tracking",
    transform: "translate(32.95 32.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3767-2",
    "data-name": "Path 3767",
    d: "M37.08,96.63l18.09,18.09H66.19",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355-2",
    "data-name": "Line 355",
    y1: 20.64,
    transform: "translate(19.04 49.71)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768-2",
    "data-name": "Path 3768",
    d: "M35.91,52.88V22.71H28.05",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769-2",
    "data-name": "Path 3769",
    d: "M83.2,96.63v10.91H99.16",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-2",
    "data-name": "Path 926",
    d: "M100.08,46.93c.22-2.56-.33-4-2-4.77a7.13,7.13,0,0,1-4.39-9.08,6.8,6.8,0,0,1,.82-1.64,3.39,3.39,0,0,0-.32-4.1,28.22,28.22,0,0,0-6.06-5.64,3.3,3.3,0,0,0-4.63-.05,7,7,0,0,1-3.83,1.46,7.22,7.22,0,0,1-7-3.79,3.33,3.33,0,0,0-4.3-1.94,26.67,26.67,0,0,0-6.93,2.15,3.33,3.33,0,0,0-2.25,4A7.19,7.19,0,0,1,53,31.62a7.44,7.44,0,0,1-1.7,0,3.26,3.26,0,0,0-3.5,1.93,22,22,0,0,0-2.16,8.94,3.23,3.23,0,0,0,2.45,3.64,7.21,7.21,0,0,1,3.38,11,3.14,3.14,0,0,0,.13,4.26,26.89,26.89,0,0,0,6.07,5.64,3.33,3.33,0,0,0,4.6-.03,7.77,7.77,0,0,1,2.95-1.59,7.12,7.12,0,0,1,8.12,3.42c.65,1.08,1.19,2.27,2.67,2.42a3.52,3.52,0,0,0,1.17.08,26.8,26.8,0,0,0,8-2.69A3.07,3.07,0,0,0,87,65a7.26,7.26,0,0,1,6-8.34,6.91,6.91,0,0,1,1.7-.08,3.34,3.34,0,0,0,3.54-2.27A26,26,0,0,0,100.08,46.93ZM70.82,53.29a7.639,7.639,0,1,1,0,.02Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770-2",
    "data-name": "Path 3770",
    d: "M111,77.16A19.47,19.47,0,0,0,86,58.48a22.17,22.17,0,0,0-39.54-5.71,10.1,10.1,0,0,0-15.28,8.67c0,.27,0,.54,0,.8a17.3,17.3,0,0,0,1,34.31v.08H93.43v-.1A19.47,19.47,0,0,0,111,77.16Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_976-2",
    "data-name": "Ellipse 976",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(15.76 16.58)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_977-2",
    "data-name": "Ellipse 977",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(12.91 44.58)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_978-2",
    "data-name": "Ellipse 978",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(64.62 108.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_979-2",
    "data-name": "Ellipse 979",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(90.37 101.41)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_980-2",
    "data-name": "Ellipse 980",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(104.83 30.36)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_981-2",
    "data-name": "Ellipse 981",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(94.58 9.15)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_356-2",
    "data-name": "Line 356",
    y2: 33.21,
    transform: "translate(110.96 42.62)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771-2",
    "data-name": "Path 3771",
    d: "M33.13,82h-5l-.85,2.41h-2L29.54,72.6h2.25L36,84.43H34Zm-.55-1.58L30.66,75l-1.93,5.49Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772-2",
    "data-name": "Path 3772",
    d: "M45.69,77.84a3.23,3.23,0,0,1-1.36,1.3,5.09,5.09,0,0,1-2.4.5H39.79v4.79H37.85V72.62h4.08a5.06,5.06,0,0,1,2.31.47,3.34,3.34,0,0,1,1.41,1.26,3.48,3.48,0,0,1,.46,1.79A3.62,3.62,0,0,1,45.69,77.84Zm-2.11-.29a1.82,1.82,0,0,0,.54-1.41c0-1.3-.73-1.94-2.19-1.94H39.79v3.86h2.14a2.33,2.33,0,0,0,1.65-.51Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773-2",
    "data-name": "Path 3773",
    d: "M49.9,72.62V84.43H48V72.62Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3774-2",
    "data-name": "Path 3774",
    d: "M53.87,84.18a3.49,3.49,0,0,1-1.38-1.08,2.8,2.8,0,0,1-.55-1.54h2a1.33,1.33,0,0,0,.57,1,2,2,0,0,0,1.3.4,2.17,2.17,0,0,0,1.26-.31,1,1,0,0,0,.45-.81.82.82,0,0,0-.5-.78,8.811,8.811,0,0,0-1.59-.56,17.249,17.249,0,0,1-1.71-.56,3.06,3.06,0,0,1-1.15-.84,2.18,2.18,0,0,1-.48-1.48,2.25,2.25,0,0,1,.44-1.36,2.87,2.87,0,0,1,1.26-1,4.7,4.7,0,0,1,1.9-.36,3.9,3.9,0,0,1,2.57.81,2.89,2.89,0,0,1,1,2.2H57.38a1.35,1.35,0,0,0-.51-1,1.89,1.89,0,0,0-1.24-.38,2,2,0,0,0-1.17.29.9.9,0,0,0-.41.77.83.83,0,0,0,.27.63,2,2,0,0,0,.66.4l1.16.36a13.061,13.061,0,0,1,1.67.55,3,3,0,0,1,1.13.83,2.15,2.15,0,0,1,.5,1.44A2.45,2.45,0,0,1,59,83.24a3,3,0,0,1-1.25,1,4.81,4.81,0,0,1-1.9.35,4.67,4.67,0,0,1-1.98-.41Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775-2",
    "data-name": "Path 3775",
    d: "M72.5,84.17A3.54,3.54,0,0,1,71,83a3,3,0,0,1-.55-1.79h2.08a1.88,1.88,0,0,0,.6,1.26,2.15,2.15,0,0,0,1.51.5,2.31,2.31,0,0,0,1.57-.49,1.58,1.58,0,0,0,.56-1.25,1.37,1.37,0,0,0-.35-1,2.33,2.33,0,0,0-.87-.58,11.84,11.84,0,0,0-1.44-.44,14.24,14.24,0,0,1-1.88-.62,3.14,3.14,0,0,1-1.23-1,2.86,2.86,0,0,1-.51-1.77A3.14,3.14,0,0,1,71,74.06a3.22,3.22,0,0,1,1.43-1.18,5.22,5.22,0,0,1,2.13-.41,4.44,4.44,0,0,1,2.81.86,3.16,3.16,0,0,1,1.22,2.36H76.46a1.54,1.54,0,0,0-.62-1.1,2.24,2.24,0,0,0-1.48-.46,2.1,2.1,0,0,0-1.36.42,1.5,1.5,0,0,0-.53,1.23,1.24,1.24,0,0,0,.33.89,2.24,2.24,0,0,0,.85.55,12.09,12.09,0,0,0,1.39.45,14.749,14.749,0,0,1,1.92.64,3.28,3.28,0,0,1,1.26,1,2.92,2.92,0,0,1,.52,1.8,3.16,3.16,0,0,1-.49,1.7,3.47,3.47,0,0,1-1.41,1.29,4.71,4.71,0,0,1-2.19.48,5.49,5.49,0,0,1-2.15-.41Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3776-2",
    "data-name": "Path 3776",
    d: "M88.22,73.35a5.17,5.17,0,0,1,2.19,2.08,6.2,6.2,0,0,1,.78,3.16,6.06,6.06,0,0,1-.78,3.13,5.09,5.09,0,0,1-2.19,2,7.41,7.41,0,0,1-3.32.7H81V72.63h3.9A7.28,7.28,0,0,1,88.22,73.35Zm-.13,8.41a4.32,4.32,0,0,0,1.1-3.17,4.45,4.45,0,0,0-1.1-3.22,4.22,4.22,0,0,0-3.19-1.16H83v8.67h1.9a4.32,4.32,0,0,0,3.19-1.12Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777-2",
    "data-name": "Path 3777",
    d: "M99.64,84.46l-4.59-5.29v5.29H93.11V72.63h1.94V78l4.6-5.4h2.44l-5.15,5.92,5.23,5.91Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357-2",
    "data-name": "Line 357",
    y2: 14.17,
    transform: "translate(65 71.44)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-12",
    "data-name": "Group 8903",
    transform: "translate(-5457.347 -10424.486) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -711.7, -922.46)",
    filter: "url(#Rectangle_1742-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-83",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(833.15 814.43) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_74._Easy_to_integrate",
    "data-name": "74._Easy to integrate",
    transform: "translate(32.765 32.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3778",
    "data-name": "Path 3778",
    d: "M34.43,39.74V21.44h68.78v87.12H34.43V94.55",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-3",
    "data-name": "Path 926",
    d: "M59.07,83.33c1.89-.26,2.88-.88,3.16-2.21a5.35,5.35,0,0,1,6-4.66,4.52,4.52,0,0,1,1.31.34,2.59,2.59,0,0,0,3-.9,20.77,20.77,0,0,0,3.14-5.33,2.46,2.46,0,0,0-.69-3.39,5.47,5.47,0,0,1-.04-8.32,2.5,2.5,0,0,0,.73-3.46,21.46,21.46,0,0,0-2.69-4.72,2.48,2.48,0,0,0-3.28-1,5.41,5.41,0,0,1-6.92-3.24,6,6,0,0,1-.28-1.25,2.43,2.43,0,0,0-2-2.25,16.13,16.13,0,0,0-6.88-.13,2.36,2.36,0,0,0-2,1.29V58.28a6.77,6.77,0,0,1,5-2.21,6.9,6.9,0,1,1,0,13.79,7,7,0,0,1-4.94-2.19V82.13a2.48,2.48,0,0,0,1.79,1,19.85,19.85,0,0,0,5.59.2Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    "data-name": "Path 3779",
    d: "M51.57,39.75c0,2.26-1.85,4.31-4.86,5.81a28.3,28.3,0,0,1-12.28,2.51,28.3,28.3,0,0,1-12.28-2.51c-3-1.5-4.86-3.55-4.86-5.81,0-4.6,7.67-8.33,17.14-8.33S51.57,35.15,51.57,39.75Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3780",
    "data-name": "Path 3780",
    d: "M51.57,51.37V63c0,2.25-1.86,4.3-4.87,5.81a28.29,28.29,0,0,1-12.27,2.51A28.29,28.29,0,0,1,22.16,68.8c-3-1.51-4.87-3.56-4.87-5.81V51.37c0,2.26,1.85,4.31,4.86,5.81a28.3,28.3,0,0,0,12.28,2.51,28.3,28.3,0,0,0,12.28-2.51C49.72,55.68,51.57,53.63,51.57,51.37Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3781",
    "data-name": "Path 3781",
    d: "M51.57,39.75V51.37c0,2.26-1.85,4.31-4.86,5.81a28.3,28.3,0,0,1-12.28,2.51,28.3,28.3,0,0,1-12.28-2.51c-3-1.5-4.86-3.55-4.86-5.81V39.75c0,2.26,1.85,4.31,4.86,5.81a28.3,28.3,0,0,0,12.28,2.51,28.3,28.3,0,0,0,12.28-2.51C49.72,44.06,51.57,42,51.57,39.75Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3782",
    "data-name": "Path 3782",
    d: "M51.57,63V74.61c0,2.25-1.86,4.3-4.87,5.81a28.29,28.29,0,0,1-12.27,2.51,28.29,28.29,0,0,1-12.27-2.51c-3-1.51-4.87-3.56-4.87-5.81V63c0,2.25,1.86,4.3,4.87,5.81a28.29,28.29,0,0,0,12.27,2.51A28.29,28.29,0,0,0,46.7,68.8C49.71,67.29,51.57,65.24,51.57,63Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783",
    "data-name": "Path 3783",
    d: "M51.57,74.61V86.23c0,4.59-7.67,8.32-17.14,8.32s-17.14-3.73-17.14-8.32V74.61c0,2.25,1.86,4.3,4.87,5.81a28.29,28.29,0,0,0,12.27,2.51A28.29,28.29,0,0,0,46.7,80.42C49.71,78.91,51.57,76.86,51.57,74.61Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1720",
    "data-name": "Rectangle 1720",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 31.42)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1721",
    "data-name": "Rectangle 1721",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 57.82)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1722",
    "data-name": "Rectangle 1722",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 84.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_358",
    "data-name": "Line 358",
    x2: 4.85,
    transform: "translate(101.13 90.39)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359",
    "data-name": "Line 359",
    x2: 4.85,
    transform: "translate(101.13 96.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_360",
    "data-name": "Line 360",
    x2: 4.85,
    transform: "translate(101.13 64)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361",
    "data-name": "Line 361",
    x2: 4.85,
    transform: "translate(101.13 69.93)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_362",
    "data-name": "Line 362",
    x2: 4.85,
    transform: "translate(101.13 37.6)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363",
    "data-name": "Line 363",
    x2: 4.85,
    transform: "translate(101.13 43.54)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_982",
    "data-name": "Ellipse 982",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(62.69 15.31)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_983",
    "data-name": "Ellipse 983",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(62.69 102.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8914",
    "data-name": "Group 8914",
    transform: "translate(-5383.063 -9916.581) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -714.57, -1435.76)",
    filter: "url(#Rectangle_1742-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-84",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(907.44 1322.34) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_74._Easy_to_integrate-2",
    "data-name": "74._Easy to integrate",
    transform: "translate(32.765 32.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3778-2",
    "data-name": "Path 3778",
    d: "M34.43,39.74V21.44h68.78v87.12H34.43V94.55",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-4",
    "data-name": "Path 926",
    d: "M59.07,83.33c1.89-.26,2.88-.88,3.16-2.21a5.35,5.35,0,0,1,6-4.66,4.52,4.52,0,0,1,1.31.34,2.59,2.59,0,0,0,3-.9,20.77,20.77,0,0,0,3.14-5.33,2.46,2.46,0,0,0-.69-3.39,5.47,5.47,0,0,1-.04-8.32,2.5,2.5,0,0,0,.73-3.46,21.46,21.46,0,0,0-2.69-4.72,2.48,2.48,0,0,0-3.28-1,5.41,5.41,0,0,1-6.92-3.24,6,6,0,0,1-.28-1.25,2.43,2.43,0,0,0-2-2.25,16.13,16.13,0,0,0-6.88-.13,2.36,2.36,0,0,0-2,1.29V58.28a6.77,6.77,0,0,1,5-2.21,6.9,6.9,0,1,1,0,13.79,7,7,0,0,1-4.94-2.19V82.13a2.48,2.48,0,0,0,1.79,1,19.85,19.85,0,0,0,5.59.2Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779-2",
    "data-name": "Path 3779",
    d: "M51.57,39.75c0,2.26-1.85,4.31-4.86,5.81a28.3,28.3,0,0,1-12.28,2.51,28.3,28.3,0,0,1-12.28-2.51c-3-1.5-4.86-3.55-4.86-5.81,0-4.6,7.67-8.33,17.14-8.33S51.57,35.15,51.57,39.75Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3780-2",
    "data-name": "Path 3780",
    d: "M51.57,51.37V63c0,2.25-1.86,4.3-4.87,5.81a28.29,28.29,0,0,1-12.27,2.51A28.29,28.29,0,0,1,22.16,68.8c-3-1.51-4.87-3.56-4.87-5.81V51.37c0,2.26,1.85,4.31,4.86,5.81a28.3,28.3,0,0,0,12.28,2.51,28.3,28.3,0,0,0,12.28-2.51C49.72,55.68,51.57,53.63,51.57,51.37Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3781-2",
    "data-name": "Path 3781",
    d: "M51.57,39.75V51.37c0,2.26-1.85,4.31-4.86,5.81a28.3,28.3,0,0,1-12.28,2.51,28.3,28.3,0,0,1-12.28-2.51c-3-1.5-4.86-3.55-4.86-5.81V39.75c0,2.26,1.85,4.31,4.86,5.81a28.3,28.3,0,0,0,12.28,2.51,28.3,28.3,0,0,0,12.28-2.51C49.72,44.06,51.57,42,51.57,39.75Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3782-2",
    "data-name": "Path 3782",
    d: "M51.57,63V74.61c0,2.25-1.86,4.3-4.87,5.81a28.29,28.29,0,0,1-12.27,2.51,28.29,28.29,0,0,1-12.27-2.51c-3-1.51-4.87-3.56-4.87-5.81V63c0,2.25,1.86,4.3,4.87,5.81a28.29,28.29,0,0,0,12.27,2.51A28.29,28.29,0,0,0,46.7,68.8C49.71,67.29,51.57,65.24,51.57,63Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783-2",
    "data-name": "Path 3783",
    d: "M51.57,74.61V86.23c0,4.59-7.67,8.32-17.14,8.32s-17.14-3.73-17.14-8.32V74.61c0,2.25,1.86,4.3,4.87,5.81a28.29,28.29,0,0,0,12.27,2.51A28.29,28.29,0,0,0,46.7,80.42C49.71,78.91,51.57,76.86,51.57,74.61Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1720-2",
    "data-name": "Rectangle 1720",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 31.42)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1721-2",
    "data-name": "Rectangle 1721",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 57.82)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1722-2",
    "data-name": "Rectangle 1722",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 84.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_358-2",
    "data-name": "Line 358",
    x2: 4.85,
    transform: "translate(101.13 90.39)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359-2",
    "data-name": "Line 359",
    x2: 4.85,
    transform: "translate(101.13 96.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_360-2",
    "data-name": "Line 360",
    x2: 4.85,
    transform: "translate(101.13 64)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361-2",
    "data-name": "Line 361",
    x2: 4.85,
    transform: "translate(101.13 69.93)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_362-2",
    "data-name": "Line 362",
    x2: 4.85,
    transform: "translate(101.13 37.6)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363-2",
    "data-name": "Line 363",
    x2: 4.85,
    transform: "translate(101.13 43.54)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_982-2",
    "data-name": "Ellipse 982",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(62.69 15.31)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_983-2",
    "data-name": "Ellipse 983",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(62.69 102.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8911",
    "data-name": "Group 8911",
    transform: "translate(-6102.836 -9558.736) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, 48, -1689.95)",
    filter: "url(#Rectangle_1742-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-85",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(187.97 1680.64) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_75._Scalable_Solutions",
    "data-name": "75._Scalable Solutions",
    transform: "translate(32.451 33.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3784",
    "data-name": "Path 3784",
    d: "M18.21,41.35V24.88H121.7v78.41H18.21V90.67",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3785",
    "data-name": "Path 3785",
    d: "M59.8,41.36V24.88h61.9v78.41H59.8V90.67",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-5",
    "data-name": "Path 926",
    d: "M82.33,79c1.56-.21,2.37-.72,2.6-1.82a4.41,4.41,0,0,1,4.9-3.83,3.66,3.66,0,0,1,1.08.28,2.14,2.14,0,0,0,2.44-.74,17.18,17.18,0,0,0,2.58-4.39,2,2,0,0,0-.57-2.79A4.27,4.27,0,0,1,94,63.6a4.46,4.46,0,0,1,1.36-4.72,2.06,2.06,0,0,0,.6-2.85,17.819,17.819,0,0,0-2.21-3.89A2,2,0,0,0,91,51.33a4.45,4.45,0,0,1-5.69-2.67,5.911,5.911,0,0,1-.23-1,2,2,0,0,0-1.62-1.85,13.18,13.18,0,0,0-5.66-.11,2,2,0,0,0-1.65,1.06V58.4a5.58,5.58,0,0,1,4.09-1.82,5.68,5.68,0,1,1-4.09,9.55V78a2,2,0,0,0,1.47.85,15.75,15.75,0,0,0,4.71.15Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3786",
    "data-name": "Path 3786",
    d: "M75.23,41.36c0,2-1.67,3.88-4.38,5.23a25.53,25.53,0,0,1-11,2.26,25.53,25.53,0,0,1-11-2.26c-2.71-1.35-4.37-3.2-4.37-5.23,0-4.14,6.9-7.5,15.42-7.5S75.23,37.22,75.23,41.36Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3787",
    "data-name": "Path 3787",
    d: "M75.23,51.82V62.27c0,2-1.68,3.87-4.39,5.23a25.37,25.37,0,0,1-11,2.26,25.37,25.37,0,0,1-11-2.26c-2.71-1.36-4.38-3.2-4.38-5.23V51.82c0,2,1.66,3.87,4.37,5.22a25.39,25.39,0,0,0,11,2.26,25.39,25.39,0,0,0,11-2.26C73.56,55.69,75.23,53.85,75.23,51.82Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3788",
    "data-name": "Path 3788",
    d: "M75.23,41.36V51.82c0,2-1.67,3.87-4.38,5.22a25.39,25.39,0,0,1-11,2.26,25.39,25.39,0,0,1-11-2.26c-2.71-1.35-4.37-3.19-4.37-5.22V41.36c0,2,1.66,3.88,4.37,5.23a25.53,25.53,0,0,0,11,2.26,25.53,25.53,0,0,0,11-2.26C73.56,45.24,75.23,43.39,75.23,41.36Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3789",
    "data-name": "Path 3789",
    d: "M75.23,62.27V72.73c0,2-1.68,3.87-4.39,5.23a25.52,25.52,0,0,1-11,2.26,25.52,25.52,0,0,1-11-2.26c-2.71-1.36-4.38-3.21-4.38-5.23V62.27c0,2,1.67,3.87,4.38,5.23a25.37,25.37,0,0,0,11,2.26,25.37,25.37,0,0,0,11-2.26C73.55,66.14,75.23,64.3,75.23,62.27Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3790",
    "data-name": "Path 3790",
    d: "M75.23,72.73V83.19c0,4.13-6.91,7.48-15.43,7.48s-15.42-3.35-15.42-7.48V72.73c0,2,1.67,3.87,4.38,5.23a25.52,25.52,0,0,0,11,2.26,25.52,25.52,0,0,0,11-2.26C73.55,76.6,75.23,74.75,75.23,72.73Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3791",
    "data-name": "Path 3791",
    d: "M33.64,41.36c0,2-1.67,3.88-4.38,5.23a25.53,25.53,0,0,1-11,2.26,25.53,25.53,0,0,1-11-2.26c-2.71-1.35-4.37-3.2-4.37-5.23,0-4.14,6.9-7.5,15.42-7.5S33.64,37.22,33.64,41.36Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3792",
    "data-name": "Path 3792",
    d: "M33.64,51.82V62.27c0,2-1.68,3.87-4.39,5.23a25.37,25.37,0,0,1-11,2.26,25.37,25.37,0,0,1-11-2.26c-2.71-1.36-4.38-3.2-4.38-5.23V51.82c0,2,1.66,3.87,4.37,5.22A25.39,25.39,0,0,0,18.21,59.3,25.39,25.39,0,0,0,29.26,57C32,55.69,33.64,53.85,33.64,51.82Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3793",
    "data-name": "Path 3793",
    d: "M33.64,41.36V51.82c0,2-1.67,3.87-4.38,5.22a25.39,25.39,0,0,1-11,2.26A25.39,25.39,0,0,1,7.16,57c-2.71-1.35-4.37-3.19-4.37-5.22V41.36c0,2,1.66,3.88,4.37,5.23a25.53,25.53,0,0,0,11.05,2.26,25.53,25.53,0,0,0,11.05-2.26C32,45.24,33.64,43.39,33.64,41.36Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3794",
    "data-name": "Path 3794",
    d: "M33.64,62.27V72.73c0,2-1.68,3.87-4.39,5.23a25.52,25.52,0,0,1-11,2.26A25.52,25.52,0,0,1,7.17,78c-2.71-1.36-4.38-3.21-4.38-5.23V62.27c0,2,1.67,3.87,4.38,5.23a25.37,25.37,0,0,0,11,2.26,25.37,25.37,0,0,0,11-2.26C32,66.14,33.64,64.3,33.64,62.27Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    "data-name": "Path 3795",
    d: "M33.64,72.73V83.19c0,4.13-6.91,7.48-15.43,7.48S2.79,87.32,2.79,83.19V72.73c0,2,1.67,3.87,4.38,5.23a25.52,25.52,0,0,0,11,2.26,25.52,25.52,0,0,0,11-2.26C32,76.6,33.64,74.75,33.64,72.73Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1725",
    "data-name": "Rectangle 1725",
    width: 16.47,
    height: 16.47,
    transform: "translate(112.79 94.17) rotate(90)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1726",
    "data-name": "Rectangle 1726",
    width: 16.47,
    height: 16.47,
    transform: "translate(89.04 94.16) rotate(90)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_364",
    "data-name": "Line 364",
    y2: 4.36,
    transform: "translate(83.48 100.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_365",
    "data-name": "Line 365",
    y2: 4.36,
    transform: "translate(78.14 100.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_366",
    "data-name": "Line 366",
    y2: 4.36,
    transform: "translate(107.23 100.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_367",
    "data-name": "Line 367",
    y2: 4.36,
    transform: "translate(101.89 100.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_984",
    "data-name": "Ellipse 984",
    cx: 5.51,
    cy: 5.51,
    r: 5.51,
    transform: "translate(85.24 19.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_985",
    "data-name": "Ellipse 985",
    cx: 5.51,
    cy: 5.51,
    r: 5.51,
    transform: "translate(102.75 19.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3796",
    "data-name": "Path 3796",
    d: "M121.7,83.85a5.5,5.5,0,0,1-5.49-5V50.4a5.438,5.438,0,0,1,0-.57,5.52,5.52,0,1,1,11,0V78.84a5.51,5.51,0,0,1-5.51,5.01Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8912",
    "data-name": "Group 8912",
    transform: "translate(-5851.12 -9594.112) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -206.19, -1689.95)",
    filter: "url(#Rectangle_1742-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-86",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(439.38 1644.81) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_76._Developer-friendly_features",
    "data-name": "76._Developer-friendly features",
    transform: "translate(32.765 32.94)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_986",
    "data-name": "Ellipse 986",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(95.32 4.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_368",
    "data-name": "Line 368",
    y2: 33.21,
    transform: "translate(101.45 16.63)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    d: "M21,106.2l13.83,13.83h8.42",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_987",
    "data-name": "Ellipse 987",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(43.25 113.9)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_369",
    "data-name": "Line 369",
    y1: 20.65,
    transform: "translate(79.06 8.91)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_988",
    "data-name": "Ellipse 988",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(72.93 3.49)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    "data-name": "Path 3798",
    d: "M45.52,40.78V10.62H37.66",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_989",
    "data-name": "Ellipse 989",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(25.38 4.49)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1729",
    "data-name": "Rectangle 1729",
    width: 112.05,
    height: 84.73,
    rx: 3,
    transform: "translate(8.97 22.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1730",
    "data-name": "Rectangle 1730",
    width: 112.05,
    height: 84.73,
    rx: 3,
    transform: "translate(8.97 22.64)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_370",
    "data-name": "Line 370",
    x2: 112.06,
    transform: "translate(8.97 41)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    d: "M26.52,31.82a3.71,3.71,0,1,1-3.71-3.71A3.71,3.71,0,0,1,26.52,31.82Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    "data-name": "Path 3800",
    d: "M38.4,31.82a3.72,3.72,0,1,1-3.71-3.71,3.72,3.72,0,0,1,3.71,3.71Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_371",
    "data-name": "Line 371",
    x2: 19.3,
    transform: "translate(19.1 54.63)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_372",
    "data-name": "Line 372",
    x2: 35.27,
    transform: "translate(19.1 67.67)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_373",
    "data-name": "Line 373",
    x2: 35.27,
    transform: "translate(19.1 80.7)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_374",
    "data-name": "Line 374",
    x2: 35.27,
    transform: "translate(19.1 93.73)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M76.79,92.72l-1-7.26H69.06l-1,7.26h-5.4l6-37.08h7.89l6,37.08Zm-7-12.29H75l-2.65-18.7Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M85.37,92.72V55.64H94c5.78,0,8.69,3.07,8.69,9.16v3.66c0,6.09-2.91,9.16-8.69,9.16H91.2v15.1ZM91.2,72.33H94c1.91,0,2.86-1,2.86-3.5v-4.4c0-2.54-1-3.49-2.86-3.49H91.2Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M105.76,92.72V55.64h5.83V92.72Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804",
    "data-name": "Path 3804",
    d: "M69.8,109.1v10.91H85.75",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_990",
    "data-name": "Ellipse 990",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(76.97 113.88)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_991",
    "data-name": "Ellipse 991",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(102.55 113.88)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8915",
    "data-name": "Group 8915",
    transform: "translate(-5599.402 -9629.489) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -460.38, -1689.95)",
    filter: "url(#Rectangle_1742-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-87",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(691.03 1609.94) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_12._Digital_Signage-3",
    "data-name": "12._Digital Signage",
    transform: "translate(40 32.487)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711-3",
    "data-name": "Rectangle 1711",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712-3",
    "data-name": "Rectangle 1712",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350-3",
    "data-name": "Line 350",
    x2: 85.52,
    transform: "translate(2.86 18.02)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762-3",
    "data-name": "Path 3762",
    d: "M16.25,11a2.83,2.83,0,1,1-.825-2.008A2.84,2.84,0,0,1,16.25,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763-3",
    "data-name": "Path 3763",
    d: "M25.31,11a2.83,2.83,0,1,1-.825-2.008A2.83,2.83,0,0,1,25.31,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764-3",
    "data-name": "Path 3764",
    d: "M80.65,11a2.83,2.83,0,0,1-2.83,2.83H58.48a2.83,2.83,0,1,1,0-5.66H77.82A2.83,2.83,0,0,1,80.65,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351-3",
    "data-name": "Line 351",
    x2: 14.73,
    transform: "translate(10.58 28.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352-3",
    "data-name": "Line 352",
    x2: 28.45,
    transform: "translate(10.58 38.38)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353-3",
    "data-name": "Line 353",
    x2: 28.45,
    transform: "translate(10.58 48.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354-3",
    "data-name": "Line 354",
    x2: 28.45,
    transform: "translate(10.58 58.27)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713-3",
    "data-name": "Rectangle 1713",
    width: 29.84,
    height: 29.84,
    transform: "translate(50.81 28.43)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715-3",
    "data-name": "Rectangle 1715",
    width: 45.28,
    height: 67.63,
    transform: "translate(67.01 28.74)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716-3",
    "data-name": "Rectangle 1716",
    width: 45.28,
    height: 7.5,
    transform: "translate(67.01 118.18)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717-3",
    "data-name": "Rectangle 1717",
    width: 10.84,
    height: 21.81,
    transform: "translate(84.23 96.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765-3",
    "data-name": "Path 3765",
    d: "M89.61,76.09a13.53,13.53,0,1,1,13.57-13.51A13.53,13.53,0,0,1,89.61,76.09Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766-3",
    "data-name": "Path 3766",
    d: "M86.27,62.55v-4a1,1,0,0,1,.45-1,.93.93,0,0,1,1,.13l6.4,4c.78.49.77,1.17,0,1.65l-6.4,4c-.33.2-.71.4-1,.11a1.53,1.53,0,0,1-.44-.93C86.24,65.23,86.27,63.89,86.27,62.55Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8916",
    "data-name": "Group 8916",
    transform: "translate(-5347.687 -9664.865) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -714.57, -1689.95)",
    filter: "url(#Rectangle_1742-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-88",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(942.81 1574.05) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8893-3",
    "data-name": "Group 8893",
    transform: "translate(28.678 33.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691-3",
    "data-name": "Path 3691",
    d: "M122.642,91.188a20.076,20.076,0,0,0-25.8-19.266,22.878,22.878,0,0,0-40.8-5.863,10.413,10.413,0,0,0-15.76,8.947v.821a17.836,17.836,0,0,0,1.044,35.3v.082H104.56v-.082a20.1,20.1,0,0,0,18.082-19.935Z",
    transform: "translate(-3.032 -2.068)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1670-3",
    "data-name": "Rectangle 1670",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692-3",
    "data-name": "Path 3692",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671-3",
    "data-name": "Rectangle 1671",
    width: 7.88,
    height: 12.125,
    transform: "translate(6.473 48.161)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672-3",
    "data-name": "Rectangle 1672",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693-3",
    "data-name": "Path 3693",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673-3",
    "data-name": "Rectangle 1673",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674-3",
    "data-name": "Rectangle 1674",
    width: 22.796,
    height: 14.212,
    transform: "translate(114.778 46.072)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675-3",
    "data-name": "Rectangle 1675",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694-3",
    "data-name": "Path 3694",
    d: "M117.384,55.162a3,3,0,1,1-3-3,3,3,0,0,1,3,3Z",
    transform: "translate(11.795 -2.721)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676-3",
    "data-name": "Rectangle 1676",
    width: 42.825,
    height: 35.754,
    transform: "translate(49.498 93.237)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677-3",
    "data-name": "Rectangle 1677",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678-3",
    "data-name": "Rectangle 1678",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679-3",
    "data-name": "Rectangle 1679",
    width: 38.943,
    height: 6.004,
    transform: "translate(51.443 24.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680-3",
    "data-name": "Rectangle 1680",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681-3",
    "data-name": "Rectangle 1681",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294-3",
    "data-name": "Line 294",
    y2: 17.355,
    transform: "translate(70.91 36.469)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695-3",
    "data-name": "Path 3695",
    d: "M115.461,61.41v6.52L105.13,78.5",
    transform: "translate(10.715 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696-3",
    "data-name": "Path 3696",
    d: "M15.22,61.41v6.52L29.808,82.858",
    transform: "translate(-4.807 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697-3",
    "data-name": "Path 3697",
    d: "M81.083,102.009a17.59,17.59,0,0,0-24.883,0",
    transform: "translate(2.267 4.993)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698-3",
    "data-name": "Path 3698",
    d: "M76.88,106.03a12.383,12.383,0,0,0-17.59,0",
    transform: "translate(2.802 5.945)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699-3",
    "data-name": "Path 3699",
    d: "M71.934,109.763a6.3,6.3,0,0,0-8.924,0",
    transform: "translate(3.443 6.904)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700-3",
    "data-name": "Path 3700",
    d: "M69.083,113.269a1.982,1.982,0,1,1-1.976-1.83A1.982,1.982,0,0,1,69.083,113.269Z",
    transform: "translate(3.809 7.512)",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-13",
    "data-name": "Group 8903",
    transform: "translate(-5299.912 -10959.988) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -942.13, -414.08)",
    filter: "url(#Rectangle_1742-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-89",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(990.84 278.96) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8893-4",
    "data-name": "Group 8893",
    transform: "translate(29.241 33.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691-4",
    "data-name": "Path 3691",
    d: "M122.642,91.188a20.076,20.076,0,0,0-25.8-19.266,22.878,22.878,0,0,0-40.8-5.863,10.413,10.413,0,0,0-15.76,8.947v.821a17.836,17.836,0,0,0,1.044,35.3v.082H104.56v-.082a20.1,20.1,0,0,0,18.082-19.935Z",
    transform: "translate(-3.032 -2.068)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1670-4",
    "data-name": "Rectangle 1670",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692-4",
    "data-name": "Path 3692",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671-4",
    "data-name": "Rectangle 1671",
    width: 7.88,
    height: 12.125,
    transform: "translate(6.473 48.161)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672-4",
    "data-name": "Rectangle 1672",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693-4",
    "data-name": "Path 3693",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673-4",
    "data-name": "Rectangle 1673",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674-4",
    "data-name": "Rectangle 1674",
    width: 22.796,
    height: 14.212,
    transform: "translate(114.778 46.072)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675-4",
    "data-name": "Rectangle 1675",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694-4",
    "data-name": "Path 3694",
    d: "M117.384,55.162a3,3,0,1,1-3-3,3,3,0,0,1,3,3Z",
    transform: "translate(11.795 -2.721)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676-4",
    "data-name": "Rectangle 1676",
    width: 42.825,
    height: 35.754,
    transform: "translate(49.498 93.237)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677-4",
    "data-name": "Rectangle 1677",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678-4",
    "data-name": "Rectangle 1678",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679-4",
    "data-name": "Rectangle 1679",
    width: 38.943,
    height: 6.004,
    transform: "translate(51.443 24.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680-4",
    "data-name": "Rectangle 1680",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681-4",
    "data-name": "Rectangle 1681",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294-4",
    "data-name": "Line 294",
    y2: 17.355,
    transform: "translate(70.91 36.469)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695-4",
    "data-name": "Path 3695",
    d: "M115.461,61.41v6.52L105.13,78.5",
    transform: "translate(10.715 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696-4",
    "data-name": "Path 3696",
    d: "M15.22,61.41v6.52L29.808,82.858",
    transform: "translate(-4.807 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697-4",
    "data-name": "Path 3697",
    d: "M81.083,102.009a17.59,17.59,0,0,0-24.883,0",
    transform: "translate(2.267 4.993)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698-4",
    "data-name": "Path 3698",
    d: "M76.88,106.03a12.383,12.383,0,0,0-17.59,0",
    transform: "translate(2.802 5.945)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699-4",
    "data-name": "Path 3699",
    d: "M71.934,109.763a6.3,6.3,0,0,0-8.924,0",
    transform: "translate(3.443 6.904)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700-4",
    "data-name": "Path 3700",
    d: "M69.083,113.269a1.982,1.982,0,1,1-1.976-1.83A1.982,1.982,0,0,1,69.083,113.269Z",
    transform: "translate(3.809 7.512)",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-14",
    "data-name": "Group 8903",
    transform: "translate(-5048.196 -10995.365) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1196.32, -414.08)",
    filter: "url(#Rectangle_1744)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1744-2",
    "data-name": "Rectangle 1744",
    width: 226.143,
    height: 226.143,
    rx: 14,
    transform: "translate(1225.42 230.77) rotate(-8)",
    fill: "#0561fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2._Cloud_Solution-2",
    "data-name": "2._Cloud_Solution",
    transform: "translate(33.006 33.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3701-2",
    "data-name": "Path 3701",
    d: "M120.19,55.26A23.6,23.6,0,0,0,89.93,32.63,26.88,26.88,0,0,0,42,25.71,12.24,12.24,0,0,0,23.51,36.22c0,.33,0,.65,0,1a21,21,0,0,0,1.2,41.57v.09H99v-.11a23.61,23.61,0,0,0,21.19-23.51Z",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1683-2",
    "data-name": "Rectangle 1683",
    width: 49.59,
    height: 75.46,
    rx: 4.54,
    transform: "translate(38.2 49.54)",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684-2",
    "data-name": "Rectangle 1684",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 58.11)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1685-2",
    "data-name": "Rectangle 1685",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 74.28)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1686-2",
    "data-name": "Rectangle 1686",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 90.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687-2",
    "data-name": "Rectangle 1687",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 106.63)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702-2",
    "data-name": "Path 3702",
    d: "M124.2,9.91a16.77,16.77,0,0,0-23.71,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3703-2",
    "data-name": "Path 3703",
    d: "M120.7,14.65a11.82,11.82,0,0,0-16.71,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3704-2",
    "data-name": "Path 3704",
    d: "M116.6,19.12a6,6,0,0,0-8.51,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3705-2",
    "data-name": "Path 3705",
    d: "M114.23,23a1.89,1.89,0,1,1-1.88-1.88A1.89,1.89,0,0,1,114.23,23Z",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-15",
    "data-name": "Group 8903",
    transform: "translate(-4796.479 -11030.741) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1450.51, -414.08)",
    filter: "url(#Rectangle_1742-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-90",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1493.89 208.26) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_5._Smart_Metering-2",
    "data-name": "5._Smart_Metering",
    transform: "translate(32.28 33.126)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1691-2",
    "data-name": "Rectangle 1691",
    width: 82.05,
    height: 84.73,
    rx: 3,
    transform: "translate(9.58 8.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1692-2",
    "data-name": "Rectangle 1692",
    width: 82.05,
    height: 84.73,
    rx: 3,
    transform: "translate(9.58 8.94)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_315-2",
    "data-name": "Line 315",
    x2: 82.05,
    transform: "translate(9.58 27.3)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722-2",
    "data-name": "Path 3722",
    d: "M27.13,18.12a3.71,3.71,0,1,1-3.71-3.71,3.71,3.71,0,0,1,3.71,3.71Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723-2",
    "data-name": "Path 3723",
    d: "M39,18.12a3.71,3.71,0,1,1-3.71-3.71A3.71,3.71,0,0,1,39,18.12Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724-2",
    "data-name": "Path 3724",
    d: "M81.51,18.12a3.71,3.71,0,0,1-3.71,3.71H62.46a3.71,3.71,0,0,1,0-7.42H77.8A3.71,3.71,0,0,1,81.51,18.12Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_316-2",
    "data-name": "Line 316",
    x2: 19.29,
    transform: "translate(19.71 40.94)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317-2",
    "data-name": "Line 317",
    x2: 37.27,
    transform: "translate(19.71 53.97)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318-2",
    "data-name": "Line 318",
    x2: 37.27,
    transform: "translate(19.71 67)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319-2",
    "data-name": "Line 319",
    x2: 37.27,
    transform: "translate(19.71 80.03)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1693-2",
    "data-name": "Rectangle 1693",
    width: 5.82,
    height: 8.86,
    transform: "translate(52.26 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1694-2",
    "data-name": "Rectangle 1694",
    width: 5.82,
    height: 8.86,
    transform: "translate(52.26 73.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1695-2",
    "data-name": "Rectangle 1695",
    width: 49.47,
    height: 52.84,
    transform: "translate(64.52 53.56)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1696-2",
    "data-name": "Rectangle 1696",
    width: 33.84,
    height: 13.1,
    transform: "translate(72.33 86.86)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1697-2",
    "data-name": "Rectangle 1697",
    width: 62.33,
    height: 56.21,
    transform: "translate(58.08 37.39)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1698-2",
    "data-name": "Rectangle 1698",
    width: 48.52,
    height: 42.39,
    transform: "translate(64.99 44.3)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_973-2",
    "data-name": "Ellipse 973",
    cx: 4.53,
    cy: 4.53,
    r: 4.53,
    transform: "translate(74.42 70.92)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_974-2",
    "data-name": "Ellipse 974",
    cx: 4.53,
    cy: 4.53,
    r: 4.53,
    transform: "translate(95.02 70.92)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1699-2",
    "data-name": "Rectangle 1699",
    width: 33.84,
    height: 9.15,
    transform: "translate(72.33 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_320-2",
    "data-name": "Line 320",
    y2: 9.14,
    transform: "translate(80.79 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321-2",
    "data-name": "Line 321",
    y2: 9.14,
    transform: "translate(89.25 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322-2",
    "data-name": "Line 322",
    y2: 9.14,
    transform: "translate(97.71 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725-2",
    "data-name": "Path 3725",
    d: "M41.18,120.85c-1,.12-1.5-.58-2.08-1.19a4.73,4.73,0,0,0-5.74-1.06,5.17,5.17,0,0,0-1.69,1.46,2.21,2.21,0,0,1-3,.71A18.12,18.12,0,0,1,24,118a2.09,2.09,0,0,1-.69-2.75,4.8,4.8,0,0,0-3.76-6.68,2.14,2.14,0,0,1-2.11-2,14.54,14.54,0,0,1,.13-6.09,2.16,2.16,0,0,1,2-1.76,4.76,4.76,0,0,0,4-6.36,2.2,2.2,0,0,1,.89-2.93A17.65,17.65,0,0,1,28.57,87a2.24,2.24,0,0,1,3.08.65,4.79,4.79,0,0,0,5.09,1.46A4.69,4.69,0,0,0,39,87.63,2.21,2.21,0,0,1,42,87a18.57,18.57,0,0,1,4.74,2.8,2.23,2.23,0,0,1,.78,2.61c-.94,3.22.58,5.75,3.85,6.44,1.18.25,1.74,1.12,2,2.81a16.28,16.28,0,0,1-.17,5.07,2.2,2.2,0,0,1-2,2,4.82,4.82,0,0,0-3.79,6.55,2,2,0,0,1-.7,2.61,17.9,17.9,0,0,1-4.79,2.86,2.2,2.2,0,0,1-.74.1ZM35.3,109.94a6.2,6.2,0,1,0-6.1-6,6.11,6.11,0,0,0,6.1,6Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_975-2",
    "data-name": "Ellipse 975",
    cx: 7.4,
    cy: 7.4,
    r: 7.4,
    transform: "translate(26.802 109.998) rotate(-80.78)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726-2",
    "data-name": "Path 3726",
    d: "M104.08,12.13l-3.89,7.3,6.06.07-3.03,7.39",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-16",
    "data-name": "Group 8903",
    transform: "translate(-4544.763 -11066.118) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1704.7, -414.08)",
    filter: "url(#Rectangle_1742-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-91",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1745.42 172.91) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_9._Railways-2",
    "data-name": "9._Railways",
    transform: "translate(32.771 31.637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1708-2",
    "data-name": "Rectangle 1708",
    width: 80.23,
    height: 60.67,
    rx: 3,
    transform: "translate(44.1 7.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1709-2",
    "data-name": "Rectangle 1709",
    width: 80.23,
    height: 60.67,
    rx: 3,
    transform: "translate(44.1 7.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_341-2",
    "data-name": "Line 341",
    x2: 80.23,
    transform: "translate(44.1 20.58)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748-2",
    "data-name": "Path 3748",
    d: "M56.66,14A2.66,2.66,0,1,1,54,11.35,2.66,2.66,0,0,1,56.66,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749-2",
    "data-name": "Path 3749",
    d: "M65.16,14a2.66,2.66,0,1,1-2.65-2.65A2.66,2.66,0,0,1,65.16,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750-2",
    "data-name": "Path 3750",
    d: "M117.08,14a2.66,2.66,0,0,1-2.66,2.66H96.28a2.66,2.66,0,1,1,0-5.31h18.14A2.66,2.66,0,0,1,117.08,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_342-2",
    "data-name": "Line 342",
    x2: 13.81,
    transform: "translate(51.35 30.34)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343-2",
    "data-name": "Line 343",
    x2: 26.69,
    transform: "translate(51.35 39.67)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_344-2",
    "data-name": "Line 344",
    x2: 26.69,
    transform: "translate(51.35 49)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_345-2",
    "data-name": "Line 345",
    x2: 26.69,
    transform: "translate(51.35 58.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710-2",
    "data-name": "Rectangle 1710",
    width: 27.99,
    height: 27.99,
    transform: "translate(89.09 30.34)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751-2",
    "data-name": "Path 3751",
    d: "M106.51,104.38a5.82,5.82,0,0,1-5.82,5.82h-69a5.82,5.82,0,0,1-5.82-5.82V41.16A11.64,11.64,0,0,1,37.46,29.52H94.87a11.64,11.64,0,0,1,11.64,11.64Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752-2",
    "data-name": "Path 3752",
    d: "M31.95,125l6.35-14.8H94.03l6.36,14.8",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_346-2",
    "data-name": "Line 346",
    x2: 62.08,
    transform: "translate(35.13 118.22)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753-2",
    "data-name": "Path 3753",
    d: "M42.11,44.72H90.23a5.18,5.18,0,0,1,5.18,5.18V60.83a2.59,2.59,0,0,1-2.59,2.59H39.52a2.59,2.59,0,0,1-2.59-2.59V49.89A5.18,5.18,0,0,1,42.11,44.72Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_347-2",
    "data-name": "Line 347",
    x2: 43.39,
    transform: "translate(44.47 59.93)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348-2",
    "data-name": "Line 348",
    x2: 12.12,
    transform: "translate(60.11 91.27)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754-2",
    "data-name": "Path 3754",
    d: "M50.5,91.27a6.79,6.79,0,1,1-6.79-6.78,6.79,6.79,0,0,1,6.79,6.78Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755-2",
    "data-name": "Path 3755",
    d: "M95.4,91.27a6.78,6.78,0,1,1-6.78-6.78A6.78,6.78,0,0,1,95.4,91.27Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756-2",
    "data-name": "Path 3756",
    d: "M50.5,91.27a6.79,6.79,0,1,1-6.79-6.78,6.79,6.79,0,0,1,6.79,6.78Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757-2",
    "data-name": "Path 3757",
    d: "M95.4,91.27a6.78,6.78,0,1,1-6.78-6.78A6.78,6.78,0,0,1,95.4,91.27Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758-2",
    "data-name": "Path 3758",
    d: "M29.44,13.68a17.33,17.33,0,0,0-24.54,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759-2",
    "data-name": "Path 3759",
    d: "M26.08,18.56a12.58,12.58,0,0,0-17.82,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760-2",
    "data-name": "Path 3760",
    d: "M22.73,23.25a7.85,7.85,0,0,0-11.12,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761-2",
    "data-name": "Path 3761",
    d: "M19.81,27.8a2.64,2.64,0,1,1-2.64-2.64,2.64,2.64,0,0,1,2.64,2.64Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349-2",
    "data-name": "Line 349",
    y2: 18.7,
    transform: "translate(66.17 44.72)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-17",
    "data-name": "Group 8903",
    transform: "translate(-5264.535 -10708.271) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -942.13, -668.27)",
    filter: "url(#Rectangle_1742-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-92",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1026.19 530.49) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3._E-Mobility-2",
    "data-name": "3._E-Mobility",
    transform: "translate(32.1 32.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3706-2",
    "data-name": "Path 3706",
    d: "M49.39,83.21l27.26,8.32,3.14,5.65v13.2H14.16V83.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_970-2",
    "data-name": "Ellipse 970",
    cx: 34.99,
    cy: 34.99,
    r: 34.99,
    transform: "translate(47.42 10.24)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3707-2",
    "data-name": "Path 3707",
    d: "M99,39.06a1.12,1.12,0,0,0-1-.57H83.32l2.47-18.83a1.126,1.126,0,0,0-2.06-.74L65.84,50.25a1.12,1.12,0,0,0,.37,1.55,1.18,1.18,0,0,0,.59.16H81.28l-2,18.87a1.12,1.12,0,0,0,2.07.69L99,40.19a1.11,1.11,0,0,0,0-1.13Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3708-2",
    "data-name": "Path 3708",
    d: "M99,39.06a1.12,1.12,0,0,0-1-.57H83.32l2.47-18.83a1.126,1.126,0,0,0-2.06-.74L65.84,50.25a1.12,1.12,0,0,0,.37,1.55,1.18,1.18,0,0,0,.59.16H81.28l-2,18.87a1.12,1.12,0,0,0,2.07.69L99,40.19a1.11,1.11,0,0,0,0-1.13Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3709-2",
    "data-name": "Path 3709",
    d: "M49.39,83.21s19.94,5.32,24.7,7.4a9.81,9.81,0,0,1,5.7,6.16v13.61H71.1",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3710-2",
    "data-name": "Path 3710",
    d: "M14.16,110.38H49.25",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3711-2",
    "data-name": "Path 3711",
    d: "M14.14,71.08A73.81,73.81,0,0,1,33.8,75.46a84,84,0,0,1,15.59,7.75H14.16",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_295-2",
    "data-name": "Line 295",
    x2: 8.51,
    transform: "translate(19.1 90.61)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3712-2",
    "data-name": "Path 3712",
    d: "M71.22,108.72a11.28,11.28,0,0,1-.12,1.66,11.05,11.05,0,0,1-21.85,0,11.281,11.281,0,0,1-.12-1.66,11.045,11.045,0,1,1,22.09,0Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3713-2",
    "data-name": "Path 3713",
    d: "M65.3,108.72a6.488,6.488,0,0,1,0,.77,5.13,5.13,0,0,1-10.14,0,4.9,4.9,0,0,1-.06-.77,5.13,5.13,0,0,1,10.25,0Z",
    fill: "#c5e1f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-18",
    "data-name": "Group 8903",
    transform: "translate(-5012.82 -10743.648) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1196.32, -668.27)",
    filter: "url(#Rectangle_1742-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-93",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1277.71 495.14) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4._Solar___Wind-2",
    "data-name": "4._Solar_&_Wind",
    transform: "translate(33.012 32.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3714-2",
    "data-name": "Path 3714",
    d: "M94.29,61.43A21,21,0,1,1,113.6,32.31",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3715-2",
    "data-name": "Path 3715",
    d: "M107.64,30.54l6,2.14,2.03-5.7",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3716-2",
    "data-name": "Path 3716",
    d: "M97.46,40.47a3.17,3.17,0,1,1-2.6-3.124A3.16,3.16,0,0,1,97.46,40.47Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_971-2",
    "data-name": "Ellipse 971",
    cx: 3.28,
    cy: 16.13,
    rx: 3.28,
    ry: 16.13,
    transform: "translate(91.01 5.06)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3717-2",
    "data-name": "Path 3717",
    d: "M75.94,47.28a40.74,40.74,0,0,1,15.61-5.22A40.51,40.51,0,0,1,79.22,53a40.31,40.31,0,0,1-15.6,5.22A40.72,40.72,0,0,1,75.94,47.28Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3718-2",
    "data-name": "Path 3718",
    d: "M109.35,53A40.51,40.51,0,0,1,97,42.06a41.25,41.25,0,0,1,28,16.12A40.31,40.31,0,0,1,109.35,53Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3719-2",
    "data-name": "Path 3719",
    d: "M97,124.93H91.63l1-81.74a3.14,3.14,0,0,0,3.24,0Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3747-2",
    "data-name": "Path 3747",
    d: "M119.91,0H0",
    transform: "translate(5.04 124.93)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3720-2",
    "data-name": "Path 3720",
    d: "M68.92,112.82H45.05l9.92-18.68H78.84Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_297-2",
    "data-name": "Line 297",
    y1: 18.68,
    x2: 9.93,
    transform: "translate(60.96 94.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_298-2",
    "data-name": "Line 298",
    y1: 18.68,
    x2: 9.92,
    transform: "translate(53.01 94.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_299-2",
    "data-name": "Line 299",
    x1: 23.88,
    transform: "translate(48.35 106.6)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_300-2",
    "data-name": "Line 300",
    x1: 23.87,
    transform: "translate(51.68 100.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1688-2",
    "data-name": "Rectangle 1688",
    width: 4.94,
    height: 12.1,
    transform: "translate(59.48 112.82)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_301-2",
    "data-name": "Line 301",
    y2: 4.98,
    transform: "translate(21.49 34.15)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302-2",
    "data-name": "Line 302",
    y2: 4.97,
    transform: "translate(21.49 5.07)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_303-2",
    "data-name": "Line 303",
    x2: 2.85,
    y2: 4.08,
    transform: "translate(28.41 31.97)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_304-2",
    "data-name": "Line 304",
    x2: 2.85,
    y2: 4.07,
    transform: "translate(11.73 8.15)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_305-2",
    "data-name": "Line 305",
    x2: 4.68,
    y2: 1.7,
    transform: "translate(32.82 26.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306-2",
    "data-name": "Line 306",
    x2: 4.68,
    y2: 1.7,
    transform: "translate(5.49 16.27)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307-2",
    "data-name": "Line 307",
    y1: 1.29,
    x2: 4.81,
    transform: "translate(33.14 17.69)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_308-2",
    "data-name": "Line 308",
    y1: 1.29,
    x2: 4.81,
    transform: "translate(5.04 25.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_309-2",
    "data-name": "Line 309",
    y1: 3.81,
    x2: 3.2,
    transform: "translate(29.24 9.05)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_310-2",
    "data-name": "Line 310",
    y1: 3.82,
    x2: 3.2,
    transform: "translate(10.55 31.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_972-2",
    "data-name": "Ellipse 972",
    cx: 7.74,
    cy: 7.74,
    r: 7.74,
    transform: "translate(12.185 27.856) rotate(-76.72)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3721-2",
    "data-name": "Path 3721",
    d: "M35.55,112.82H11.68L21.6,94.14H45.47Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_311-2",
    "data-name": "Line 311",
    y1: 18.68,
    x2: 9.92,
    transform: "translate(27.59 94.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_312-2",
    "data-name": "Line 312",
    y1: 18.68,
    x2: 9.92,
    transform: "translate(19.63 94.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_313-2",
    "data-name": "Line 313",
    x1: 23.87,
    transform: "translate(14.98 106.6)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_314-2",
    "data-name": "Line 314",
    x1: 23.87,
    transform: "translate(18.31 100.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1689-2",
    "data-name": "Rectangle 1689",
    width: 4.94,
    height: 12.1,
    transform: "translate(26.1 112.82)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-19",
    "data-name": "Group 8903",
    transform: "translate(-4509.387 -10814.401) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1704.7, -668.27)",
    filter: "url(#Rectangle_1742-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-94",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1780.77 424.44) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_32._IP_Core-FPGA-2",
    "data-name": "32._IP Core-FPGA",
    transform: "translate(32.381 32.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3689-2",
    "data-name": "Path 3689",
    d: "M19.86,19.86v90.28h90.28V19.86ZM94.94,94.93H35.06V35.07H94.94Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1667-2",
    "data-name": "Rectangle 1667",
    width: 90.27,
    height: 90.27,
    transform: "translate(19.86 19.86)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270-2",
    "data-name": "Line 270",
    y1: 12.57,
    transform: "translate(36.59 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271-2",
    "data-name": "Line 271",
    y1: 12.57,
    transform: "translate(50.79 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_272-2",
    "data-name": "Line 272",
    y1: 12.57,
    transform: "translate(65 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_273-2",
    "data-name": "Line 273",
    y1: 12.57,
    transform: "translate(79.21 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_274-2",
    "data-name": "Line 274",
    y1: 12.57,
    transform: "translate(93.41 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_275-2",
    "data-name": "Line 275",
    y1: 12.57,
    transform: "translate(36.59 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_276-2",
    "data-name": "Line 276",
    y1: 12.57,
    transform: "translate(50.79 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_277-2",
    "data-name": "Line 277",
    y1: 12.57,
    transform: "translate(65 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278-2",
    "data-name": "Line 278",
    y1: 12.57,
    transform: "translate(79.21 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_279-2",
    "data-name": "Line 279",
    y1: 12.57,
    transform: "translate(93.41 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_280-2",
    "data-name": "Line 280",
    x2: 12.57,
    transform: "translate(110.14 36.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_281-2",
    "data-name": "Line 281",
    x2: 12.57,
    transform: "translate(110.14 50.79)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282-2",
    "data-name": "Line 282",
    x2: 12.57,
    transform: "translate(110.14 65)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283-2",
    "data-name": "Line 283",
    x2: 12.57,
    transform: "translate(110.14 79.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284-2",
    "data-name": "Line 284",
    x2: 12.57,
    transform: "translate(110.14 93.41)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285-2",
    "data-name": "Line 285",
    x2: 12.57,
    transform: "translate(7.29 36.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286-2",
    "data-name": "Line 286",
    x2: 12.57,
    transform: "translate(7.29 50.79)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_287-2",
    "data-name": "Line 287",
    x2: 12.57,
    transform: "translate(7.29 65)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_288-2",
    "data-name": "Line 288",
    x2: 12.57,
    transform: "translate(7.29 79.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_289-2",
    "data-name": "Line 289",
    x2: 12.57,
    transform: "translate(7.29 93.41)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1668-2",
    "data-name": "Rectangle 1668",
    width: 59.87,
    height: 59.87,
    transform: "translate(35.06 35.06)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_290-2",
    "data-name": "Line 290",
    y2: 17.13,
    transform: "translate(49.2 77.81)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_967-2",
    "data-name": "Ellipse 967",
    cx: 6.39,
    cy: 6.39,
    r: 6.39,
    transform: "translate(42.81 71.42)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3690-2",
    "data-name": "Path 3690",
    d: "M76.47,65H57.19V51.82H35.06",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_291-2",
    "data-name": "Line 291",
    y2: 32.53,
    transform: "translate(76.47 35.06)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_292-2",
    "data-name": "Line 292",
    y2: 27.35,
    transform: "translate(76.47 67.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_293-2",
    "data-name": "Line 293",
    x1: 18.47,
    transform: "translate(76.47 84.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_968-2",
    "data-name": "Ellipse 968",
    cx: 6.39,
    cy: 6.39,
    r: 6.39,
    transform: "translate(50.8 45.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_969-2",
    "data-name": "Ellipse 969",
    cx: 6.39,
    cy: 6.39,
    r: 6.39,
    transform: "translate(70.08 58.61)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-20",
    "data-name": "Group 8903",
    transform: "translate(-5229.159 -10456.556) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -942.13, -922.46)",
    filter: "url(#Rectangle_1746)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1746-2",
    "data-name": "Rectangle 1746",
    width: 226.143,
    height: 226.143,
    rx: 14,
    transform: "translate(1044.36 769.2) rotate(-8)",
    fill: "#0561fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7._Home_Automation-3",
    "data-name": "7._Home_Automation",
    transform: "translate(33.091 32.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3727-3",
    "data-name": "Path 3727",
    d: "M109.71,75.32V125H85.95V75.32h.11l2.72,2.73h8.43l-2.73-2.73Z",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3728-3",
    "data-name": "Path 3728",
    d: "M44.1,75.32V125H20.34V75.32H35.59l-2.71,2.73H41.3l2.71-2.73Z",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701-3",
    "data-name": "Rectangle 1701",
    width: 9.51,
    height: 9.51,
    transform: "translate(93.07 95.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702-3",
    "data-name": "Rectangle 1702",
    width: 9.51,
    height: 9.51,
    transform: "translate(27.47 95.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3729-3",
    "data-name": "Path 3729",
    d: "M85.95,75.21V125H44.1V75.22l6.01-6.05,3.56-3.59L65.02,54.23,76.34,65.57l3.58,3.59Z",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3730-3",
    "data-name": "Path 3730",
    d: "M69.75,78.65H60.23V73.89A4.76,4.76,0,0,1,65,69.13h0a4.76,4.76,0,0,1,4.76,4.76Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1703-3",
    "data-name": "Rectangle 1703",
    width: 19.18,
    height: 31.68,
    transform: "translate(55.4 93.32)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323-3",
    "data-name": "Line 323",
    x2: 111.7,
    transform: "translate(9.15 125)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731-3",
    "data-name": "Path 3731",
    d: "M115.85,75.32H94.48l-6.17-6.19h.02L69.89,50.67H91.24l18.44,18.46h.02v.03Z",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3732-3",
    "data-name": "Path 3732",
    d: "M41.69,69.13h.05l-6.15,6.19H14.13l6.19-6.19L38.76,50.67H60.15Z",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733-3",
    "data-name": "Path 3733",
    d: "M109.71,69.13v.02l-.02-.02Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324-3",
    "data-name": "Line 324",
    x1: 0.01,
    transform: "translate(109.7 75.32)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734-3",
    "data-name": "Path 3734",
    d: "M97.21,78.05H88.78l-2.72-2.73-.11-.11-6.03-6.05-3.58-3.59L65.02,54.23,53.67,65.58l-3.56,3.59L44.1,75.22l-.09.1L41.3,78.05H32.88l2.71-2.73,6.15-6.19,7.71-7.76L65.02,45.81,80.56,61.35l7.75,7.78,6.17,6.19Z",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325-3",
    "data-name": "Line 325",
    y2: 1.96,
    transform: "translate(60.09 108.18)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_326-3",
    "data-name": "Line 326",
    x1: 21.35,
    transform: "translate(30.57 58.89)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327-3",
    "data-name": "Line 327",
    x1: 21.35,
    transform: "translate(22.29 67.1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328-3",
    "data-name": "Line 328",
    x2: 21.35,
    transform: "translate(78.02 58.89)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329-3",
    "data-name": "Line 329",
    x2: 21.35,
    transform: "translate(86.3 67.1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735-3",
    "data-name": "Path 3735",
    d: "M83,12.46a25.49,25.49,0,0,0-36,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736-3",
    "data-name": "Path 3736",
    d: "M78.08,17.4a18.49,18.49,0,0,0-26.18,0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737-3",
    "data-name": "Path 3737",
    d: "M73.15,22.32a11.54,11.54,0,0,0-16.32,0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738-3",
    "data-name": "Path 3738",
    d: "M68.87,28.53A3.88,3.88,0,1,1,65,24.66,3.88,3.88,0,0,1,68.87,28.53Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8921",
    "data-name": "Group 8921",
    transform: "translate(-5154.876 -9948.65) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -945, -1435.76)",
    filter: "url(#Rectangle_1742-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-95",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1135.82 1289.92) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7._Home_Automation-4",
    "data-name": "7._Home_Automation",
    transform: "translate(33.091 32.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3727-4",
    "data-name": "Path 3727",
    d: "M109.71,75.32V125H85.95V75.32h.11l2.72,2.73h8.43l-2.73-2.73Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3728-4",
    "data-name": "Path 3728",
    d: "M44.1,75.32V125H20.34V75.32H35.59l-2.71,2.73H41.3l2.71-2.73Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701-4",
    "data-name": "Rectangle 1701",
    width: 9.51,
    height: 9.51,
    transform: "translate(93.07 95.4)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702-4",
    "data-name": "Rectangle 1702",
    width: 9.51,
    height: 9.51,
    transform: "translate(27.47 95.4)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3729-4",
    "data-name": "Path 3729",
    d: "M85.95,75.21V125H44.1V75.22l6.01-6.05,3.56-3.59L65.02,54.23,76.34,65.57l3.58,3.59Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3730-4",
    "data-name": "Path 3730",
    d: "M69.75,78.65H60.23V73.89A4.76,4.76,0,0,1,65,69.13h0a4.76,4.76,0,0,1,4.76,4.76Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1703-4",
    "data-name": "Rectangle 1703",
    width: 19.18,
    height: 31.68,
    transform: "translate(55.4 93.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323-4",
    "data-name": "Line 323",
    x2: 111.7,
    transform: "translate(9.15 125)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731-4",
    "data-name": "Path 3731",
    d: "M115.85,75.32H94.48l-6.17-6.19h.02L69.89,50.67H91.24l18.44,18.46h.02v.03Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3732-4",
    "data-name": "Path 3732",
    d: "M41.69,69.13h.05l-6.15,6.19H14.13l6.19-6.19L38.76,50.67H60.15Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733-4",
    "data-name": "Path 3733",
    d: "M109.71,69.13v.02l-.02-.02Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324-4",
    "data-name": "Line 324",
    x1: 0.01,
    transform: "translate(109.7 75.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734-4",
    "data-name": "Path 3734",
    d: "M97.21,78.05H88.78l-2.72-2.73-.11-.11-6.03-6.05-3.58-3.59L65.02,54.23,53.67,65.58l-3.56,3.59L44.1,75.22l-.09.1L41.3,78.05H32.88l2.71-2.73,6.15-6.19,7.71-7.76L65.02,45.81,80.56,61.35l7.75,7.78,6.17,6.19Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325-4",
    "data-name": "Line 325",
    y2: 1.96,
    transform: "translate(60.09 108.18)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_326-4",
    "data-name": "Line 326",
    x1: 21.35,
    transform: "translate(30.57 58.89)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327-4",
    "data-name": "Line 327",
    x1: 21.35,
    transform: "translate(22.29 67.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328-4",
    "data-name": "Line 328",
    x2: 21.35,
    transform: "translate(78.02 58.89)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329-4",
    "data-name": "Line 329",
    x2: 21.35,
    transform: "translate(86.3 67.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735-4",
    "data-name": "Path 3735",
    d: "M83,12.46a25.49,25.49,0,0,0-36,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736-4",
    "data-name": "Path 3736",
    d: "M78.08,17.4a18.49,18.49,0,0,0-26.18,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737-4",
    "data-name": "Path 3737",
    d: "M73.15,22.32a11.54,11.54,0,0,0-16.32,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738-4",
    "data-name": "Path 3738",
    d: "M68.87,28.53A3.88,3.88,0,1,1,65,24.66,3.88,3.88,0,0,1,68.87,28.53Z",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8908",
    "data-name": "Group 8908",
    transform: "translate(-4761.453 -10778.784) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1450.13, -668.46)",
    filter: "url(#Rectangle_1742-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-96",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1529.24 459.79) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7._Home_Automation-5",
    "data-name": "7._Home_Automation",
    transform: "translate(33.091 32.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3727-5",
    "data-name": "Path 3727",
    d: "M109.71,75.32V125H85.95V75.32h.11l2.72,2.73h8.43l-2.73-2.73Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3728-5",
    "data-name": "Path 3728",
    d: "M44.1,75.32V125H20.34V75.32H35.59l-2.71,2.73H41.3l2.71-2.73Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701-5",
    "data-name": "Rectangle 1701",
    width: 9.51,
    height: 9.51,
    transform: "translate(93.07 95.4)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702-5",
    "data-name": "Rectangle 1702",
    width: 9.51,
    height: 9.51,
    transform: "translate(27.47 95.4)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3729-5",
    "data-name": "Path 3729",
    d: "M85.95,75.21V125H44.1V75.22l6.01-6.05,3.56-3.59L65.02,54.23,76.34,65.57l3.58,3.59Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3730-5",
    "data-name": "Path 3730",
    d: "M69.75,78.65H60.23V73.89A4.76,4.76,0,0,1,65,69.13h0a4.76,4.76,0,0,1,4.76,4.76Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1703-5",
    "data-name": "Rectangle 1703",
    width: 19.18,
    height: 31.68,
    transform: "translate(55.4 93.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323-5",
    "data-name": "Line 323",
    x2: 111.7,
    transform: "translate(9.15 125)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731-5",
    "data-name": "Path 3731",
    d: "M115.85,75.32H94.48l-6.17-6.19h.02L69.89,50.67H91.24l18.44,18.46h.02v.03Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3732-5",
    "data-name": "Path 3732",
    d: "M41.69,69.13h.05l-6.15,6.19H14.13l6.19-6.19L38.76,50.67H60.15Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733-5",
    "data-name": "Path 3733",
    d: "M109.71,69.13v.02l-.02-.02Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324-5",
    "data-name": "Line 324",
    x1: 0.01,
    transform: "translate(109.7 75.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734-5",
    "data-name": "Path 3734",
    d: "M97.21,78.05H88.78l-2.72-2.73-.11-.11-6.03-6.05-3.58-3.59L65.02,54.23,53.67,65.58l-3.56,3.59L44.1,75.22l-.09.1L41.3,78.05H32.88l2.71-2.73,6.15-6.19,7.71-7.76L65.02,45.81,80.56,61.35l7.75,7.78,6.17,6.19Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325-5",
    "data-name": "Line 325",
    y2: 1.96,
    transform: "translate(60.09 108.18)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_326-5",
    "data-name": "Line 326",
    x1: 21.35,
    transform: "translate(30.57 58.89)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327-5",
    "data-name": "Line 327",
    x1: 21.35,
    transform: "translate(22.29 67.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328-5",
    "data-name": "Line 328",
    x2: 21.35,
    transform: "translate(78.02 58.89)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329-5",
    "data-name": "Line 329",
    x2: 21.35,
    transform: "translate(86.3 67.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735-5",
    "data-name": "Path 3735",
    d: "M83,12.46a25.49,25.49,0,0,0-36,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736-5",
    "data-name": "Path 3736",
    d: "M78.08,17.4a18.49,18.49,0,0,0-26.18,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737-5",
    "data-name": "Path 3737",
    d: "M73.15,22.32a11.54,11.54,0,0,0-16.32,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738-5",
    "data-name": "Path 3738",
    d: "M68.87,28.53A3.88,3.88,0,1,1,65,24.66,3.88,3.88,0,0,1,68.87,28.53Z",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-21",
    "data-name": "Group 8903",
    transform: "translate(-4977.443 -10491.933) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1196.32, -922.46)",
    filter: "url(#Rectangle_1742-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-97",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1313.06 746.67) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_12._Digital_Signage-4",
    "data-name": "12._Digital Signage",
    transform: "translate(40.192 32.677)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711-4",
    "data-name": "Rectangle 1711",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712-4",
    "data-name": "Rectangle 1712",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350-4",
    "data-name": "Line 350",
    x2: 85.52,
    transform: "translate(2.86 18.02)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762-4",
    "data-name": "Path 3762",
    d: "M16.25,11a2.83,2.83,0,1,1-.825-2.008A2.84,2.84,0,0,1,16.25,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763-4",
    "data-name": "Path 3763",
    d: "M25.31,11a2.83,2.83,0,1,1-.825-2.008A2.83,2.83,0,0,1,25.31,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764-4",
    "data-name": "Path 3764",
    d: "M80.65,11a2.83,2.83,0,0,1-2.83,2.83H58.48a2.83,2.83,0,1,1,0-5.66H77.82A2.83,2.83,0,0,1,80.65,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351-4",
    "data-name": "Line 351",
    x2: 14.73,
    transform: "translate(10.58 28.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352-4",
    "data-name": "Line 352",
    x2: 28.45,
    transform: "translate(10.58 38.38)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353-4",
    "data-name": "Line 353",
    x2: 28.45,
    transform: "translate(10.58 48.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354-4",
    "data-name": "Line 354",
    x2: 28.45,
    transform: "translate(10.58 58.27)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713-4",
    "data-name": "Rectangle 1713",
    width: 29.84,
    height: 29.84,
    transform: "translate(50.81 28.43)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715-4",
    "data-name": "Rectangle 1715",
    width: 45.28,
    height: 67.63,
    transform: "translate(67.01 28.74)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716-4",
    "data-name": "Rectangle 1716",
    width: 45.28,
    height: 7.5,
    transform: "translate(67.01 118.18)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717-4",
    "data-name": "Rectangle 1717",
    width: 10.84,
    height: 21.81,
    transform: "translate(84.23 96.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765-4",
    "data-name": "Path 3765",
    d: "M89.61,76.09a13.53,13.53,0,1,1,13.57-13.51A13.53,13.53,0,0,1,89.61,76.09Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766-4",
    "data-name": "Path 3766",
    d: "M86.27,62.55v-4a1,1,0,0,1,.45-1,.93.93,0,0,1,1,.13l6.4,4c.78.49.77,1.17,0,1.65l-6.4,4c-.33.2-.71.4-1,.11a1.53,1.53,0,0,1-.44-.93C86.24,65.23,86.27,63.89,86.27,62.55Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8924",
    "data-name": "Group 8924",
    transform: "translate(-4903.16 -9984.027) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1199.19, -1435.76)",
    filter: "url(#Rectangle_1742-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-98",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1387.35 1254.57) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_12._Digital_Signage-5",
    "data-name": "12._Digital Signage",
    transform: "translate(40.192 32.677)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711-5",
    "data-name": "Rectangle 1711",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712-5",
    "data-name": "Rectangle 1712",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350-5",
    "data-name": "Line 350",
    x2: 85.52,
    transform: "translate(2.86 18.02)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762-5",
    "data-name": "Path 3762",
    d: "M16.25,11a2.83,2.83,0,1,1-.825-2.008A2.84,2.84,0,0,1,16.25,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763-5",
    "data-name": "Path 3763",
    d: "M25.31,11a2.83,2.83,0,1,1-.825-2.008A2.83,2.83,0,0,1,25.31,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764-5",
    "data-name": "Path 3764",
    d: "M80.65,11a2.83,2.83,0,0,1-2.83,2.83H58.48a2.83,2.83,0,1,1,0-5.66H77.82A2.83,2.83,0,0,1,80.65,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351-5",
    "data-name": "Line 351",
    x2: 14.73,
    transform: "translate(10.58 28.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352-5",
    "data-name": "Line 352",
    x2: 28.45,
    transform: "translate(10.58 38.38)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353-5",
    "data-name": "Line 353",
    x2: 28.45,
    transform: "translate(10.58 48.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354-5",
    "data-name": "Line 354",
    x2: 28.45,
    transform: "translate(10.58 58.27)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713-5",
    "data-name": "Rectangle 1713",
    width: 29.84,
    height: 29.84,
    transform: "translate(50.81 28.43)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715-5",
    "data-name": "Rectangle 1715",
    width: 45.28,
    height: 67.63,
    transform: "translate(67.01 28.74)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716-5",
    "data-name": "Rectangle 1716",
    width: 45.28,
    height: 7.5,
    transform: "translate(67.01 118.18)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717-5",
    "data-name": "Rectangle 1717",
    width: 10.84,
    height: 21.81,
    transform: "translate(84.23 96.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765-5",
    "data-name": "Path 3765",
    d: "M89.61,76.09a13.53,13.53,0,1,1,13.57-13.51A13.53,13.53,0,0,1,89.61,76.09Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766-5",
    "data-name": "Path 3766",
    d: "M86.27,62.55v-4a1,1,0,0,1,.45-1,.93.93,0,0,1,1,.13l6.4,4c.78.49.77,1.17,0,1.65l-6.4,4c-.33.2-.71.4-1,.11a1.53,1.53,0,0,1-.44-.93C86.24,65.23,86.27,63.89,86.27,62.55Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-22",
    "data-name": "Group 8903",
    transform: "translate(-4725.726 -10527.309) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1450.51, -922.46)",
    filter: "url(#Rectangle_1742-31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-99",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1564.59 711.32) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_73._APIs-SDK_for_real-time_tracking-3",
    "data-name": "73._APIs-SDK for real-time tracking",
    transform: "translate(32.95 32.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3767-3",
    "data-name": "Path 3767",
    d: "M37.08,96.63l18.09,18.09H66.19",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355-3",
    "data-name": "Line 355",
    y1: 20.64,
    transform: "translate(19.04 49.71)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768-3",
    "data-name": "Path 3768",
    d: "M35.91,52.88V22.71H28.05",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769-3",
    "data-name": "Path 3769",
    d: "M83.2,96.63v10.91H99.16",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-6",
    "data-name": "Path 926",
    d: "M100.08,46.93c.22-2.56-.33-4-2-4.77a7.13,7.13,0,0,1-4.39-9.08,6.8,6.8,0,0,1,.82-1.64,3.39,3.39,0,0,0-.32-4.1,28.22,28.22,0,0,0-6.06-5.64,3.3,3.3,0,0,0-4.63-.05,7,7,0,0,1-3.83,1.46,7.22,7.22,0,0,1-7-3.79,3.33,3.33,0,0,0-4.3-1.94,26.67,26.67,0,0,0-6.93,2.15,3.33,3.33,0,0,0-2.25,4A7.19,7.19,0,0,1,53,31.62a7.44,7.44,0,0,1-1.7,0,3.26,3.26,0,0,0-3.5,1.93,22,22,0,0,0-2.16,8.94,3.23,3.23,0,0,0,2.45,3.64,7.21,7.21,0,0,1,3.38,11,3.14,3.14,0,0,0,.13,4.26,26.89,26.89,0,0,0,6.07,5.64,3.33,3.33,0,0,0,4.6-.03,7.77,7.77,0,0,1,2.95-1.59,7.12,7.12,0,0,1,8.12,3.42c.65,1.08,1.19,2.27,2.67,2.42a3.52,3.52,0,0,0,1.17.08,26.8,26.8,0,0,0,8-2.69A3.07,3.07,0,0,0,87,65a7.26,7.26,0,0,1,6-8.34,6.91,6.91,0,0,1,1.7-.08,3.34,3.34,0,0,0,3.54-2.27A26,26,0,0,0,100.08,46.93ZM70.82,53.29a7.639,7.639,0,1,1,0,.02Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770-3",
    "data-name": "Path 3770",
    d: "M111,77.16A19.47,19.47,0,0,0,86,58.48a22.17,22.17,0,0,0-39.54-5.71,10.1,10.1,0,0,0-15.28,8.67c0,.27,0,.54,0,.8a17.3,17.3,0,0,0,1,34.31v.08H93.43v-.1A19.47,19.47,0,0,0,111,77.16Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_976-3",
    "data-name": "Ellipse 976",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(15.76 16.58)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_977-3",
    "data-name": "Ellipse 977",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(12.91 44.58)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_978-3",
    "data-name": "Ellipse 978",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(64.62 108.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_979-3",
    "data-name": "Ellipse 979",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(90.37 101.41)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_980-3",
    "data-name": "Ellipse 980",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(104.83 30.36)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_981-3",
    "data-name": "Ellipse 981",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(94.58 9.15)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_356-3",
    "data-name": "Line 356",
    y2: 33.21,
    transform: "translate(110.96 42.62)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771-3",
    "data-name": "Path 3771",
    d: "M33.13,82h-5l-.85,2.41h-2L29.54,72.6h2.25L36,84.43H34Zm-.55-1.58L30.66,75l-1.93,5.49Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772-3",
    "data-name": "Path 3772",
    d: "M45.69,77.84a3.23,3.23,0,0,1-1.36,1.3,5.09,5.09,0,0,1-2.4.5H39.79v4.79H37.85V72.62h4.08a5.06,5.06,0,0,1,2.31.47,3.34,3.34,0,0,1,1.41,1.26,3.48,3.48,0,0,1,.46,1.79A3.62,3.62,0,0,1,45.69,77.84Zm-2.11-.29a1.82,1.82,0,0,0,.54-1.41c0-1.3-.73-1.94-2.19-1.94H39.79v3.86h2.14a2.33,2.33,0,0,0,1.65-.51Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773-3",
    "data-name": "Path 3773",
    d: "M49.9,72.62V84.43H48V72.62Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3774-3",
    "data-name": "Path 3774",
    d: "M53.87,84.18a3.49,3.49,0,0,1-1.38-1.08,2.8,2.8,0,0,1-.55-1.54h2a1.33,1.33,0,0,0,.57,1,2,2,0,0,0,1.3.4,2.17,2.17,0,0,0,1.26-.31,1,1,0,0,0,.45-.81.82.82,0,0,0-.5-.78,8.811,8.811,0,0,0-1.59-.56,17.249,17.249,0,0,1-1.71-.56,3.06,3.06,0,0,1-1.15-.84,2.18,2.18,0,0,1-.48-1.48,2.25,2.25,0,0,1,.44-1.36,2.87,2.87,0,0,1,1.26-1,4.7,4.7,0,0,1,1.9-.36,3.9,3.9,0,0,1,2.57.81,2.89,2.89,0,0,1,1,2.2H57.38a1.35,1.35,0,0,0-.51-1,1.89,1.89,0,0,0-1.24-.38,2,2,0,0,0-1.17.29.9.9,0,0,0-.41.77.83.83,0,0,0,.27.63,2,2,0,0,0,.66.4l1.16.36a13.061,13.061,0,0,1,1.67.55,3,3,0,0,1,1.13.83,2.15,2.15,0,0,1,.5,1.44A2.45,2.45,0,0,1,59,83.24a3,3,0,0,1-1.25,1,4.81,4.81,0,0,1-1.9.35,4.67,4.67,0,0,1-1.98-.41Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775-3",
    "data-name": "Path 3775",
    d: "M72.5,84.17A3.54,3.54,0,0,1,71,83a3,3,0,0,1-.55-1.79h2.08a1.88,1.88,0,0,0,.6,1.26,2.15,2.15,0,0,0,1.51.5,2.31,2.31,0,0,0,1.57-.49,1.58,1.58,0,0,0,.56-1.25,1.37,1.37,0,0,0-.35-1,2.33,2.33,0,0,0-.87-.58,11.84,11.84,0,0,0-1.44-.44,14.24,14.24,0,0,1-1.88-.62,3.14,3.14,0,0,1-1.23-1,2.86,2.86,0,0,1-.51-1.77A3.14,3.14,0,0,1,71,74.06a3.22,3.22,0,0,1,1.43-1.18,5.22,5.22,0,0,1,2.13-.41,4.44,4.44,0,0,1,2.81.86,3.16,3.16,0,0,1,1.22,2.36H76.46a1.54,1.54,0,0,0-.62-1.1,2.24,2.24,0,0,0-1.48-.46,2.1,2.1,0,0,0-1.36.42,1.5,1.5,0,0,0-.53,1.23,1.24,1.24,0,0,0,.33.89,2.24,2.24,0,0,0,.85.55,12.09,12.09,0,0,0,1.39.45,14.749,14.749,0,0,1,1.92.64,3.28,3.28,0,0,1,1.26,1,2.92,2.92,0,0,1,.52,1.8,3.16,3.16,0,0,1-.49,1.7,3.47,3.47,0,0,1-1.41,1.29,4.71,4.71,0,0,1-2.19.48,5.49,5.49,0,0,1-2.15-.41Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3776-3",
    "data-name": "Path 3776",
    d: "M88.22,73.35a5.17,5.17,0,0,1,2.19,2.08,6.2,6.2,0,0,1,.78,3.16,6.06,6.06,0,0,1-.78,3.13,5.09,5.09,0,0,1-2.19,2,7.41,7.41,0,0,1-3.32.7H81V72.63h3.9A7.28,7.28,0,0,1,88.22,73.35Zm-.13,8.41a4.32,4.32,0,0,0,1.1-3.17,4.45,4.45,0,0,0-1.1-3.22,4.22,4.22,0,0,0-3.19-1.16H83v8.67h1.9a4.32,4.32,0,0,0,3.19-1.12Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777-3",
    "data-name": "Path 3777",
    d: "M99.64,84.46l-4.59-5.29v5.29H93.11V72.63h1.94V78l4.6-5.4h2.44l-5.15,5.92,5.23,5.91Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357-3",
    "data-name": "Line 357",
    y2: 14.17,
    transform: "translate(65 71.44)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8927",
    "data-name": "Group 8927",
    transform: "translate(-4651.442 -10019.403) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1453.38, -1435.76)",
    filter: "url(#Rectangle_1742-32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-100",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1638.88 1219.22) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_73._APIs-SDK_for_real-time_tracking-4",
    "data-name": "73._APIs-SDK for real-time tracking",
    transform: "translate(32.95 32.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3767-4",
    "data-name": "Path 3767",
    d: "M37.08,96.63l18.09,18.09H66.19",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355-4",
    "data-name": "Line 355",
    y1: 20.64,
    transform: "translate(19.04 49.71)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768-4",
    "data-name": "Path 3768",
    d: "M35.91,52.88V22.71H28.05",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769-4",
    "data-name": "Path 3769",
    d: "M83.2,96.63v10.91H99.16",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-7",
    "data-name": "Path 926",
    d: "M100.08,46.93c.22-2.56-.33-4-2-4.77a7.13,7.13,0,0,1-4.39-9.08,6.8,6.8,0,0,1,.82-1.64,3.39,3.39,0,0,0-.32-4.1,28.22,28.22,0,0,0-6.06-5.64,3.3,3.3,0,0,0-4.63-.05,7,7,0,0,1-3.83,1.46,7.22,7.22,0,0,1-7-3.79,3.33,3.33,0,0,0-4.3-1.94,26.67,26.67,0,0,0-6.93,2.15,3.33,3.33,0,0,0-2.25,4A7.19,7.19,0,0,1,53,31.62a7.44,7.44,0,0,1-1.7,0,3.26,3.26,0,0,0-3.5,1.93,22,22,0,0,0-2.16,8.94,3.23,3.23,0,0,0,2.45,3.64,7.21,7.21,0,0,1,3.38,11,3.14,3.14,0,0,0,.13,4.26,26.89,26.89,0,0,0,6.07,5.64,3.33,3.33,0,0,0,4.6-.03,7.77,7.77,0,0,1,2.95-1.59,7.12,7.12,0,0,1,8.12,3.42c.65,1.08,1.19,2.27,2.67,2.42a3.52,3.52,0,0,0,1.17.08,26.8,26.8,0,0,0,8-2.69A3.07,3.07,0,0,0,87,65a7.26,7.26,0,0,1,6-8.34,6.91,6.91,0,0,1,1.7-.08,3.34,3.34,0,0,0,3.54-2.27A26,26,0,0,0,100.08,46.93ZM70.82,53.29a7.639,7.639,0,1,1,0,.02Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770-4",
    "data-name": "Path 3770",
    d: "M111,77.16A19.47,19.47,0,0,0,86,58.48a22.17,22.17,0,0,0-39.54-5.71,10.1,10.1,0,0,0-15.28,8.67c0,.27,0,.54,0,.8a17.3,17.3,0,0,0,1,34.31v.08H93.43v-.1A19.47,19.47,0,0,0,111,77.16Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_976-4",
    "data-name": "Ellipse 976",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(15.76 16.58)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_977-4",
    "data-name": "Ellipse 977",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(12.91 44.58)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_978-4",
    "data-name": "Ellipse 978",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(64.62 108.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_979-4",
    "data-name": "Ellipse 979",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(90.37 101.41)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_980-4",
    "data-name": "Ellipse 980",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(104.83 30.36)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_981-4",
    "data-name": "Ellipse 981",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(94.58 9.15)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_356-4",
    "data-name": "Line 356",
    y2: 33.21,
    transform: "translate(110.96 42.62)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771-4",
    "data-name": "Path 3771",
    d: "M33.13,82h-5l-.85,2.41h-2L29.54,72.6h2.25L36,84.43H34Zm-.55-1.58L30.66,75l-1.93,5.49Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772-4",
    "data-name": "Path 3772",
    d: "M45.69,77.84a3.23,3.23,0,0,1-1.36,1.3,5.09,5.09,0,0,1-2.4.5H39.79v4.79H37.85V72.62h4.08a5.06,5.06,0,0,1,2.31.47,3.34,3.34,0,0,1,1.41,1.26,3.48,3.48,0,0,1,.46,1.79A3.62,3.62,0,0,1,45.69,77.84Zm-2.11-.29a1.82,1.82,0,0,0,.54-1.41c0-1.3-.73-1.94-2.19-1.94H39.79v3.86h2.14a2.33,2.33,0,0,0,1.65-.51Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773-4",
    "data-name": "Path 3773",
    d: "M49.9,72.62V84.43H48V72.62Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3774-4",
    "data-name": "Path 3774",
    d: "M53.87,84.18a3.49,3.49,0,0,1-1.38-1.08,2.8,2.8,0,0,1-.55-1.54h2a1.33,1.33,0,0,0,.57,1,2,2,0,0,0,1.3.4,2.17,2.17,0,0,0,1.26-.31,1,1,0,0,0,.45-.81.82.82,0,0,0-.5-.78,8.811,8.811,0,0,0-1.59-.56,17.249,17.249,0,0,1-1.71-.56,3.06,3.06,0,0,1-1.15-.84,2.18,2.18,0,0,1-.48-1.48,2.25,2.25,0,0,1,.44-1.36,2.87,2.87,0,0,1,1.26-1,4.7,4.7,0,0,1,1.9-.36,3.9,3.9,0,0,1,2.57.81,2.89,2.89,0,0,1,1,2.2H57.38a1.35,1.35,0,0,0-.51-1,1.89,1.89,0,0,0-1.24-.38,2,2,0,0,0-1.17.29.9.9,0,0,0-.41.77.83.83,0,0,0,.27.63,2,2,0,0,0,.66.4l1.16.36a13.061,13.061,0,0,1,1.67.55,3,3,0,0,1,1.13.83,2.15,2.15,0,0,1,.5,1.44A2.45,2.45,0,0,1,59,83.24a3,3,0,0,1-1.25,1,4.81,4.81,0,0,1-1.9.35,4.67,4.67,0,0,1-1.98-.41Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775-4",
    "data-name": "Path 3775",
    d: "M72.5,84.17A3.54,3.54,0,0,1,71,83a3,3,0,0,1-.55-1.79h2.08a1.88,1.88,0,0,0,.6,1.26,2.15,2.15,0,0,0,1.51.5,2.31,2.31,0,0,0,1.57-.49,1.58,1.58,0,0,0,.56-1.25,1.37,1.37,0,0,0-.35-1,2.33,2.33,0,0,0-.87-.58,11.84,11.84,0,0,0-1.44-.44,14.24,14.24,0,0,1-1.88-.62,3.14,3.14,0,0,1-1.23-1,2.86,2.86,0,0,1-.51-1.77A3.14,3.14,0,0,1,71,74.06a3.22,3.22,0,0,1,1.43-1.18,5.22,5.22,0,0,1,2.13-.41,4.44,4.44,0,0,1,2.81.86,3.16,3.16,0,0,1,1.22,2.36H76.46a1.54,1.54,0,0,0-.62-1.1,2.24,2.24,0,0,0-1.48-.46,2.1,2.1,0,0,0-1.36.42,1.5,1.5,0,0,0-.53,1.23,1.24,1.24,0,0,0,.33.89,2.24,2.24,0,0,0,.85.55,12.09,12.09,0,0,0,1.39.45,14.749,14.749,0,0,1,1.92.64,3.28,3.28,0,0,1,1.26,1,2.92,2.92,0,0,1,.52,1.8,3.16,3.16,0,0,1-.49,1.7,3.47,3.47,0,0,1-1.41,1.29,4.71,4.71,0,0,1-2.19.48,5.49,5.49,0,0,1-2.15-.41Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3776-4",
    "data-name": "Path 3776",
    d: "M88.22,73.35a5.17,5.17,0,0,1,2.19,2.08,6.2,6.2,0,0,1,.78,3.16,6.06,6.06,0,0,1-.78,3.13,5.09,5.09,0,0,1-2.19,2,7.41,7.41,0,0,1-3.32.7H81V72.63h3.9A7.28,7.28,0,0,1,88.22,73.35Zm-.13,8.41a4.32,4.32,0,0,0,1.1-3.17,4.45,4.45,0,0,0-1.1-3.22,4.22,4.22,0,0,0-3.19-1.16H83v8.67h1.9a4.32,4.32,0,0,0,3.19-1.12Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777-4",
    "data-name": "Path 3777",
    d: "M99.64,84.46l-4.59-5.29v5.29H93.11V72.63h1.94V78l4.6-5.4h2.44l-5.15,5.92,5.23,5.91Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357-4",
    "data-name": "Line 357",
    y2: 14.17,
    transform: "translate(65 71.44)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-23",
    "data-name": "Group 8903",
    transform: "translate(-4474.011 -10562.686) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1704.7, -922.46)",
    filter: "url(#Rectangle_1742-33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-101",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1816.49 676.23) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_74._Easy_to_integrate-3",
    "data-name": "74._Easy to integrate",
    transform: "translate(32.765 32.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3778-3",
    "data-name": "Path 3778",
    d: "M34.43,39.74V21.44h68.78v87.12H34.43V94.55",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-8",
    "data-name": "Path 926",
    d: "M59.07,83.33c1.89-.26,2.88-.88,3.16-2.21a5.35,5.35,0,0,1,6-4.66,4.52,4.52,0,0,1,1.31.34,2.59,2.59,0,0,0,3-.9,20.77,20.77,0,0,0,3.14-5.33,2.46,2.46,0,0,0-.69-3.39,5.47,5.47,0,0,1-.04-8.32,2.5,2.5,0,0,0,.73-3.46,21.46,21.46,0,0,0-2.69-4.72,2.48,2.48,0,0,0-3.28-1,5.41,5.41,0,0,1-6.92-3.24,6,6,0,0,1-.28-1.25,2.43,2.43,0,0,0-2-2.25,16.13,16.13,0,0,0-6.88-.13,2.36,2.36,0,0,0-2,1.29V58.28a6.77,6.77,0,0,1,5-2.21,6.9,6.9,0,1,1,0,13.79,7,7,0,0,1-4.94-2.19V82.13a2.48,2.48,0,0,0,1.79,1,19.85,19.85,0,0,0,5.59.2Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779-3",
    "data-name": "Path 3779",
    d: "M51.57,39.75c0,2.26-1.85,4.31-4.86,5.81a28.3,28.3,0,0,1-12.28,2.51,28.3,28.3,0,0,1-12.28-2.51c-3-1.5-4.86-3.55-4.86-5.81,0-4.6,7.67-8.33,17.14-8.33S51.57,35.15,51.57,39.75Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3780-3",
    "data-name": "Path 3780",
    d: "M51.57,51.37V63c0,2.25-1.86,4.3-4.87,5.81a28.29,28.29,0,0,1-12.27,2.51A28.29,28.29,0,0,1,22.16,68.8c-3-1.51-4.87-3.56-4.87-5.81V51.37c0,2.26,1.85,4.31,4.86,5.81a28.3,28.3,0,0,0,12.28,2.51,28.3,28.3,0,0,0,12.28-2.51C49.72,55.68,51.57,53.63,51.57,51.37Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3781-3",
    "data-name": "Path 3781",
    d: "M51.57,39.75V51.37c0,2.26-1.85,4.31-4.86,5.81a28.3,28.3,0,0,1-12.28,2.51,28.3,28.3,0,0,1-12.28-2.51c-3-1.5-4.86-3.55-4.86-5.81V39.75c0,2.26,1.85,4.31,4.86,5.81a28.3,28.3,0,0,0,12.28,2.51,28.3,28.3,0,0,0,12.28-2.51C49.72,44.06,51.57,42,51.57,39.75Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3782-3",
    "data-name": "Path 3782",
    d: "M51.57,63V74.61c0,2.25-1.86,4.3-4.87,5.81a28.29,28.29,0,0,1-12.27,2.51,28.29,28.29,0,0,1-12.27-2.51c-3-1.51-4.87-3.56-4.87-5.81V63c0,2.25,1.86,4.3,4.87,5.81a28.29,28.29,0,0,0,12.27,2.51A28.29,28.29,0,0,0,46.7,68.8C49.71,67.29,51.57,65.24,51.57,63Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783-3",
    "data-name": "Path 3783",
    d: "M51.57,74.61V86.23c0,4.59-7.67,8.32-17.14,8.32s-17.14-3.73-17.14-8.32V74.61c0,2.25,1.86,4.3,4.87,5.81a28.29,28.29,0,0,0,12.27,2.51A28.29,28.29,0,0,0,46.7,80.42C49.71,78.91,51.57,76.86,51.57,74.61Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1720-3",
    "data-name": "Rectangle 1720",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 31.42)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1721-3",
    "data-name": "Rectangle 1721",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 57.82)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1722-3",
    "data-name": "Rectangle 1722",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 84.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_358-3",
    "data-name": "Line 358",
    x2: 4.85,
    transform: "translate(101.13 90.39)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359-3",
    "data-name": "Line 359",
    x2: 4.85,
    transform: "translate(101.13 96.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_360-3",
    "data-name": "Line 360",
    x2: 4.85,
    transform: "translate(101.13 64)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361-3",
    "data-name": "Line 361",
    x2: 4.85,
    transform: "translate(101.13 69.93)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_362-3",
    "data-name": "Line 362",
    x2: 4.85,
    transform: "translate(101.13 37.6)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363-3",
    "data-name": "Line 363",
    x2: 4.85,
    transform: "translate(101.13 43.54)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_982-3",
    "data-name": "Ellipse 982",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(62.69 15.31)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_983-3",
    "data-name": "Ellipse 983",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(62.69 102.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8930",
    "data-name": "Group 8930",
    transform: "translate(-4399.728 -10054.78) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1707.57, -1435.76)",
    filter: "url(#Rectangle_1742-34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-102",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1890.77 1184.14) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_74._Easy_to_integrate-4",
    "data-name": "74._Easy to integrate",
    transform: "translate(32.765 32.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3778-4",
    "data-name": "Path 3778",
    d: "M34.43,39.74V21.44h68.78v87.12H34.43V94.55",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-9",
    "data-name": "Path 926",
    d: "M59.07,83.33c1.89-.26,2.88-.88,3.16-2.21a5.35,5.35,0,0,1,6-4.66,4.52,4.52,0,0,1,1.31.34,2.59,2.59,0,0,0,3-.9,20.77,20.77,0,0,0,3.14-5.33,2.46,2.46,0,0,0-.69-3.39,5.47,5.47,0,0,1-.04-8.32,2.5,2.5,0,0,0,.73-3.46,21.46,21.46,0,0,0-2.69-4.72,2.48,2.48,0,0,0-3.28-1,5.41,5.41,0,0,1-6.92-3.24,6,6,0,0,1-.28-1.25,2.43,2.43,0,0,0-2-2.25,16.13,16.13,0,0,0-6.88-.13,2.36,2.36,0,0,0-2,1.29V58.28a6.77,6.77,0,0,1,5-2.21,6.9,6.9,0,1,1,0,13.79,7,7,0,0,1-4.94-2.19V82.13a2.48,2.48,0,0,0,1.79,1,19.85,19.85,0,0,0,5.59.2Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779-4",
    "data-name": "Path 3779",
    d: "M51.57,39.75c0,2.26-1.85,4.31-4.86,5.81a28.3,28.3,0,0,1-12.28,2.51,28.3,28.3,0,0,1-12.28-2.51c-3-1.5-4.86-3.55-4.86-5.81,0-4.6,7.67-8.33,17.14-8.33S51.57,35.15,51.57,39.75Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3780-4",
    "data-name": "Path 3780",
    d: "M51.57,51.37V63c0,2.25-1.86,4.3-4.87,5.81a28.29,28.29,0,0,1-12.27,2.51A28.29,28.29,0,0,1,22.16,68.8c-3-1.51-4.87-3.56-4.87-5.81V51.37c0,2.26,1.85,4.31,4.86,5.81a28.3,28.3,0,0,0,12.28,2.51,28.3,28.3,0,0,0,12.28-2.51C49.72,55.68,51.57,53.63,51.57,51.37Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3781-4",
    "data-name": "Path 3781",
    d: "M51.57,39.75V51.37c0,2.26-1.85,4.31-4.86,5.81a28.3,28.3,0,0,1-12.28,2.51,28.3,28.3,0,0,1-12.28-2.51c-3-1.5-4.86-3.55-4.86-5.81V39.75c0,2.26,1.85,4.31,4.86,5.81a28.3,28.3,0,0,0,12.28,2.51,28.3,28.3,0,0,0,12.28-2.51C49.72,44.06,51.57,42,51.57,39.75Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3782-4",
    "data-name": "Path 3782",
    d: "M51.57,63V74.61c0,2.25-1.86,4.3-4.87,5.81a28.29,28.29,0,0,1-12.27,2.51,28.29,28.29,0,0,1-12.27-2.51c-3-1.51-4.87-3.56-4.87-5.81V63c0,2.25,1.86,4.3,4.87,5.81a28.29,28.29,0,0,0,12.27,2.51A28.29,28.29,0,0,0,46.7,68.8C49.71,67.29,51.57,65.24,51.57,63Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783-4",
    "data-name": "Path 3783",
    d: "M51.57,74.61V86.23c0,4.59-7.67,8.32-17.14,8.32s-17.14-3.73-17.14-8.32V74.61c0,2.25,1.86,4.3,4.87,5.81a28.29,28.29,0,0,0,12.27,2.51A28.29,28.29,0,0,0,46.7,80.42C49.71,78.91,51.57,76.86,51.57,74.61Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1720-4",
    "data-name": "Rectangle 1720",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 31.42)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1721-4",
    "data-name": "Rectangle 1721",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 57.82)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1722-4",
    "data-name": "Rectangle 1722",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 84.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_358-4",
    "data-name": "Line 358",
    x2: 4.85,
    transform: "translate(101.13 90.39)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359-4",
    "data-name": "Line 359",
    x2: 4.85,
    transform: "translate(101.13 96.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_360-4",
    "data-name": "Line 360",
    x2: 4.85,
    transform: "translate(101.13 64)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361-4",
    "data-name": "Line 361",
    x2: 4.85,
    transform: "translate(101.13 69.93)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_362-4",
    "data-name": "Line 362",
    x2: 4.85,
    transform: "translate(101.13 37.6)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363-4",
    "data-name": "Line 363",
    x2: 4.85,
    transform: "translate(101.13 43.54)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_982-4",
    "data-name": "Ellipse 982",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(62.69 15.31)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_983-4",
    "data-name": "Ellipse 983",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(62.69 102.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8922",
    "data-name": "Group 8922",
    transform: "translate(-5119.499 -9696.935) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -945, -1689.95)",
    filter: "url(#Rectangle_1742-35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-103",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1171.31 1542.44) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_75._Scalable_Solutions-2",
    "data-name": "75._Scalable Solutions",
    transform: "translate(32.451 33.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3784-2",
    "data-name": "Path 3784",
    d: "M18.21,41.35V24.88H121.7v78.41H18.21V90.67",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3785-2",
    "data-name": "Path 3785",
    d: "M59.8,41.36V24.88h61.9v78.41H59.8V90.67",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-10",
    "data-name": "Path 926",
    d: "M82.33,79c1.56-.21,2.37-.72,2.6-1.82a4.41,4.41,0,0,1,4.9-3.83,3.66,3.66,0,0,1,1.08.28,2.14,2.14,0,0,0,2.44-.74,17.18,17.18,0,0,0,2.58-4.39,2,2,0,0,0-.57-2.79A4.27,4.27,0,0,1,94,63.6a4.46,4.46,0,0,1,1.36-4.72,2.06,2.06,0,0,0,.6-2.85,17.819,17.819,0,0,0-2.21-3.89A2,2,0,0,0,91,51.33a4.45,4.45,0,0,1-5.69-2.67,5.911,5.911,0,0,1-.23-1,2,2,0,0,0-1.62-1.85,13.18,13.18,0,0,0-5.66-.11,2,2,0,0,0-1.65,1.06V58.4a5.58,5.58,0,0,1,4.09-1.82,5.68,5.68,0,1,1-4.09,9.55V78a2,2,0,0,0,1.47.85,15.75,15.75,0,0,0,4.71.15Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3786-2",
    "data-name": "Path 3786",
    d: "M75.23,41.36c0,2-1.67,3.88-4.38,5.23a25.53,25.53,0,0,1-11,2.26,25.53,25.53,0,0,1-11-2.26c-2.71-1.35-4.37-3.2-4.37-5.23,0-4.14,6.9-7.5,15.42-7.5S75.23,37.22,75.23,41.36Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3787-2",
    "data-name": "Path 3787",
    d: "M75.23,51.82V62.27c0,2-1.68,3.87-4.39,5.23a25.37,25.37,0,0,1-11,2.26,25.37,25.37,0,0,1-11-2.26c-2.71-1.36-4.38-3.2-4.38-5.23V51.82c0,2,1.66,3.87,4.37,5.22a25.39,25.39,0,0,0,11,2.26,25.39,25.39,0,0,0,11-2.26C73.56,55.69,75.23,53.85,75.23,51.82Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3788-2",
    "data-name": "Path 3788",
    d: "M75.23,41.36V51.82c0,2-1.67,3.87-4.38,5.22a25.39,25.39,0,0,1-11,2.26,25.39,25.39,0,0,1-11-2.26c-2.71-1.35-4.37-3.19-4.37-5.22V41.36c0,2,1.66,3.88,4.37,5.23a25.53,25.53,0,0,0,11,2.26,25.53,25.53,0,0,0,11-2.26C73.56,45.24,75.23,43.39,75.23,41.36Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3789-2",
    "data-name": "Path 3789",
    d: "M75.23,62.27V72.73c0,2-1.68,3.87-4.39,5.23a25.52,25.52,0,0,1-11,2.26,25.52,25.52,0,0,1-11-2.26c-2.71-1.36-4.38-3.21-4.38-5.23V62.27c0,2,1.67,3.87,4.38,5.23a25.37,25.37,0,0,0,11,2.26,25.37,25.37,0,0,0,11-2.26C73.55,66.14,75.23,64.3,75.23,62.27Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3790-2",
    "data-name": "Path 3790",
    d: "M75.23,72.73V83.19c0,4.13-6.91,7.48-15.43,7.48s-15.42-3.35-15.42-7.48V72.73c0,2,1.67,3.87,4.38,5.23a25.52,25.52,0,0,0,11,2.26,25.52,25.52,0,0,0,11-2.26C73.55,76.6,75.23,74.75,75.23,72.73Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3791-2",
    "data-name": "Path 3791",
    d: "M33.64,41.36c0,2-1.67,3.88-4.38,5.23a25.53,25.53,0,0,1-11,2.26,25.53,25.53,0,0,1-11-2.26c-2.71-1.35-4.37-3.2-4.37-5.23,0-4.14,6.9-7.5,15.42-7.5S33.64,37.22,33.64,41.36Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3792-2",
    "data-name": "Path 3792",
    d: "M33.64,51.82V62.27c0,2-1.68,3.87-4.39,5.23a25.37,25.37,0,0,1-11,2.26,25.37,25.37,0,0,1-11-2.26c-2.71-1.36-4.38-3.2-4.38-5.23V51.82c0,2,1.66,3.87,4.37,5.22A25.39,25.39,0,0,0,18.21,59.3,25.39,25.39,0,0,0,29.26,57C32,55.69,33.64,53.85,33.64,51.82Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3793-2",
    "data-name": "Path 3793",
    d: "M33.64,41.36V51.82c0,2-1.67,3.87-4.38,5.22a25.39,25.39,0,0,1-11,2.26A25.39,25.39,0,0,1,7.16,57c-2.71-1.35-4.37-3.19-4.37-5.22V41.36c0,2,1.66,3.88,4.37,5.23a25.53,25.53,0,0,0,11.05,2.26,25.53,25.53,0,0,0,11.05-2.26C32,45.24,33.64,43.39,33.64,41.36Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3794-2",
    "data-name": "Path 3794",
    d: "M33.64,62.27V72.73c0,2-1.68,3.87-4.39,5.23a25.52,25.52,0,0,1-11,2.26A25.52,25.52,0,0,1,7.17,78c-2.71-1.36-4.38-3.21-4.38-5.23V62.27c0,2,1.67,3.87,4.38,5.23a25.37,25.37,0,0,0,11,2.26,25.37,25.37,0,0,0,11-2.26C32,66.14,33.64,64.3,33.64,62.27Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3795-2",
    "data-name": "Path 3795",
    d: "M33.64,72.73V83.19c0,4.13-6.91,7.48-15.43,7.48S2.79,87.32,2.79,83.19V72.73c0,2,1.67,3.87,4.38,5.23a25.52,25.52,0,0,0,11,2.26,25.52,25.52,0,0,0,11-2.26C32,76.6,33.64,74.75,33.64,72.73Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1725-2",
    "data-name": "Rectangle 1725",
    width: 16.47,
    height: 16.47,
    transform: "translate(112.79 94.17) rotate(90)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1726-2",
    "data-name": "Rectangle 1726",
    width: 16.47,
    height: 16.47,
    transform: "translate(89.04 94.16) rotate(90)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_364-2",
    "data-name": "Line 364",
    y2: 4.36,
    transform: "translate(83.48 100.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_365-2",
    "data-name": "Line 365",
    y2: 4.36,
    transform: "translate(78.14 100.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_366-2",
    "data-name": "Line 366",
    y2: 4.36,
    transform: "translate(107.23 100.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_367-2",
    "data-name": "Line 367",
    y2: 4.36,
    transform: "translate(101.89 100.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_984-2",
    "data-name": "Ellipse 984",
    cx: 5.51,
    cy: 5.51,
    r: 5.51,
    transform: "translate(85.24 19.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_985-2",
    "data-name": "Ellipse 985",
    cx: 5.51,
    cy: 5.51,
    r: 5.51,
    transform: "translate(102.75 19.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3796-2",
    "data-name": "Path 3796",
    d: "M121.7,83.85a5.5,5.5,0,0,1-5.49-5V50.4a5.438,5.438,0,0,1,0-.57,5.52,5.52,0,1,1,11,0V78.84a5.51,5.51,0,0,1-5.51,5.01Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8925",
    "data-name": "Group 8925",
    transform: "translate(-4867.784 -9732.312) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1199.19, -1689.95)",
    filter: "url(#Rectangle_1742-36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-104",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1422.72 1506.61) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_76._Developer-friendly_features-2",
    "data-name": "76._Developer-friendly features",
    transform: "translate(32.765 32.94)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_986-2",
    "data-name": "Ellipse 986",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(95.32 4.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_368-2",
    "data-name": "Line 368",
    y2: 33.21,
    transform: "translate(101.45 16.63)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3797-2",
    "data-name": "Path 3797",
    d: "M21,106.2l13.83,13.83h8.42",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_987-2",
    "data-name": "Ellipse 987",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(43.25 113.9)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_369-2",
    "data-name": "Line 369",
    y1: 20.65,
    transform: "translate(79.06 8.91)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_988-2",
    "data-name": "Ellipse 988",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(72.93 3.49)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3798-2",
    "data-name": "Path 3798",
    d: "M45.52,40.78V10.62H37.66",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_989-2",
    "data-name": "Ellipse 989",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(25.38 4.49)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1729-2",
    "data-name": "Rectangle 1729",
    width: 112.05,
    height: 84.73,
    rx: 3,
    transform: "translate(8.97 22.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1730-2",
    "data-name": "Rectangle 1730",
    width: 112.05,
    height: 84.73,
    rx: 3,
    transform: "translate(8.97 22.64)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_370-2",
    "data-name": "Line 370",
    x2: 112.06,
    transform: "translate(8.97 41)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799-2",
    "data-name": "Path 3799",
    d: "M26.52,31.82a3.71,3.71,0,1,1-3.71-3.71A3.71,3.71,0,0,1,26.52,31.82Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3800-2",
    "data-name": "Path 3800",
    d: "M38.4,31.82a3.72,3.72,0,1,1-3.71-3.71,3.72,3.72,0,0,1,3.71,3.71Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_371-2",
    "data-name": "Line 371",
    x2: 19.3,
    transform: "translate(19.1 54.63)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_372-2",
    "data-name": "Line 372",
    x2: 35.27,
    transform: "translate(19.1 67.67)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_373-2",
    "data-name": "Line 373",
    x2: 35.27,
    transform: "translate(19.1 80.7)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_374-2",
    "data-name": "Line 374",
    x2: 35.27,
    transform: "translate(19.1 93.73)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801-2",
    "data-name": "Path 3801",
    d: "M76.79,92.72l-1-7.26H69.06l-1,7.26h-5.4l6-37.08h7.89l6,37.08Zm-7-12.29H75l-2.65-18.7Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802-2",
    "data-name": "Path 3802",
    d: "M85.37,92.72V55.64H94c5.78,0,8.69,3.07,8.69,9.16v3.66c0,6.09-2.91,9.16-8.69,9.16H91.2v15.1ZM91.2,72.33H94c1.91,0,2.86-1,2.86-3.5v-4.4c0-2.54-1-3.49-2.86-3.49H91.2Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803-2",
    "data-name": "Path 3803",
    d: "M105.76,92.72V55.64h5.83V92.72Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804-2",
    "data-name": "Path 3804",
    d: "M69.8,109.1v10.91H85.75",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_990-2",
    "data-name": "Ellipse 990",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(76.97 113.88)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_991-2",
    "data-name": "Ellipse 991",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(102.55 113.88)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8928",
    "data-name": "Group 8928",
    transform: "translate(-4616.066 -9767.688) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1453.38, -1689.95)",
    filter: "url(#Rectangle_1742-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-105",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1674.36 1471.74) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_12._Digital_Signage-6",
    "data-name": "12._Digital Signage",
    transform: "translate(40 32.487)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711-6",
    "data-name": "Rectangle 1711",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712-6",
    "data-name": "Rectangle 1712",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350-6",
    "data-name": "Line 350",
    x2: 85.52,
    transform: "translate(2.86 18.02)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762-6",
    "data-name": "Path 3762",
    d: "M16.25,11a2.83,2.83,0,1,1-.825-2.008A2.84,2.84,0,0,1,16.25,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763-6",
    "data-name": "Path 3763",
    d: "M25.31,11a2.83,2.83,0,1,1-.825-2.008A2.83,2.83,0,0,1,25.31,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764-6",
    "data-name": "Path 3764",
    d: "M80.65,11a2.83,2.83,0,0,1-2.83,2.83H58.48a2.83,2.83,0,1,1,0-5.66H77.82A2.83,2.83,0,0,1,80.65,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351-6",
    "data-name": "Line 351",
    x2: 14.73,
    transform: "translate(10.58 28.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352-6",
    "data-name": "Line 352",
    x2: 28.45,
    transform: "translate(10.58 38.38)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353-6",
    "data-name": "Line 353",
    x2: 28.45,
    transform: "translate(10.58 48.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354-6",
    "data-name": "Line 354",
    x2: 28.45,
    transform: "translate(10.58 58.27)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713-6",
    "data-name": "Rectangle 1713",
    width: 29.84,
    height: 29.84,
    transform: "translate(50.81 28.43)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715-6",
    "data-name": "Rectangle 1715",
    width: 45.28,
    height: 67.63,
    transform: "translate(67.01 28.74)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716-6",
    "data-name": "Rectangle 1716",
    width: 45.28,
    height: 7.5,
    transform: "translate(67.01 118.18)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717-6",
    "data-name": "Rectangle 1717",
    width: 10.84,
    height: 21.81,
    transform: "translate(84.23 96.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765-6",
    "data-name": "Path 3765",
    d: "M89.61,76.09a13.53,13.53,0,1,1,13.57-13.51A13.53,13.53,0,0,1,89.61,76.09Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766-6",
    "data-name": "Path 3766",
    d: "M86.27,62.55v-4a1,1,0,0,1,.45-1,.93.93,0,0,1,1,.13l6.4,4c.78.49.77,1.17,0,1.65l-6.4,4c-.33.2-.71.4-1,.11a1.53,1.53,0,0,1-.44-.93C86.24,65.23,86.27,63.89,86.27,62.55Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8931",
    "data-name": "Group 8931",
    transform: "translate(-4364.351 -9803.064) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1707.57, -1689.95)",
    filter: "url(#Rectangle_1742-38)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-106",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1926.15 1435.85) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8893-5",
    "data-name": "Group 8893",
    transform: "translate(28.678 33.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691-5",
    "data-name": "Path 3691",
    d: "M122.642,91.188a20.076,20.076,0,0,0-25.8-19.266,22.878,22.878,0,0,0-40.8-5.863,10.413,10.413,0,0,0-15.76,8.947v.821a17.836,17.836,0,0,0,1.044,35.3v.082H104.56v-.082a20.1,20.1,0,0,0,18.082-19.935Z",
    transform: "translate(-3.032 -2.068)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1670-5",
    "data-name": "Rectangle 1670",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692-5",
    "data-name": "Path 3692",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671-5",
    "data-name": "Rectangle 1671",
    width: 7.88,
    height: 12.125,
    transform: "translate(6.473 48.161)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672-5",
    "data-name": "Rectangle 1672",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693-5",
    "data-name": "Path 3693",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673-5",
    "data-name": "Rectangle 1673",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674-5",
    "data-name": "Rectangle 1674",
    width: 22.796,
    height: 14.212,
    transform: "translate(114.778 46.072)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675-5",
    "data-name": "Rectangle 1675",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694-5",
    "data-name": "Path 3694",
    d: "M117.384,55.162a3,3,0,1,1-3-3,3,3,0,0,1,3,3Z",
    transform: "translate(11.795 -2.721)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676-5",
    "data-name": "Rectangle 1676",
    width: 42.825,
    height: 35.754,
    transform: "translate(49.498 93.237)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677-5",
    "data-name": "Rectangle 1677",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678-5",
    "data-name": "Rectangle 1678",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679-5",
    "data-name": "Rectangle 1679",
    width: 38.943,
    height: 6.004,
    transform: "translate(51.443 24.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680-5",
    "data-name": "Rectangle 1680",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681-5",
    "data-name": "Rectangle 1681",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294-5",
    "data-name": "Line 294",
    y2: 17.355,
    transform: "translate(70.91 36.469)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695-5",
    "data-name": "Path 3695",
    d: "M115.461,61.41v6.52L105.13,78.5",
    transform: "translate(10.715 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696-5",
    "data-name": "Path 3696",
    d: "M15.22,61.41v6.52L29.808,82.858",
    transform: "translate(-4.807 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697-5",
    "data-name": "Path 3697",
    d: "M81.083,102.009a17.59,17.59,0,0,0-24.883,0",
    transform: "translate(2.267 4.993)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698-5",
    "data-name": "Path 3698",
    d: "M76.88,106.03a12.383,12.383,0,0,0-17.59,0",
    transform: "translate(2.802 5.945)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699-5",
    "data-name": "Path 3699",
    d: "M71.934,109.763a6.3,6.3,0,0,0-8.924,0",
    transform: "translate(3.443 6.904)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700-5",
    "data-name": "Path 3700",
    d: "M69.083,113.269a1.982,1.982,0,1,1-1.976-1.83A1.982,1.982,0,0,1,69.083,113.269Z",
    transform: "translate(3.809 7.512)",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-24",
    "data-name": "Group 8903",
    transform: "translate(-4316.576 -11098.188) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1935.13, -414.08)",
    filter: "url(#Rectangle_1742-39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-107",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1974.17 140.76) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8893-6",
    "data-name": "Group 8893",
    transform: "translate(29.241 33.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691-6",
    "data-name": "Path 3691",
    d: "M122.642,91.188a20.076,20.076,0,0,0-25.8-19.266,22.878,22.878,0,0,0-40.8-5.863,10.413,10.413,0,0,0-15.76,8.947v.821a17.836,17.836,0,0,0,1.044,35.3v.082H104.56v-.082a20.1,20.1,0,0,0,18.082-19.935Z",
    transform: "translate(-3.032 -2.068)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1670-6",
    "data-name": "Rectangle 1670",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692-6",
    "data-name": "Path 3692",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671-6",
    "data-name": "Rectangle 1671",
    width: 7.88,
    height: 12.125,
    transform: "translate(6.473 48.161)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672-6",
    "data-name": "Rectangle 1672",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693-6",
    "data-name": "Path 3693",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673-6",
    "data-name": "Rectangle 1673",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674-6",
    "data-name": "Rectangle 1674",
    width: 22.796,
    height: 14.212,
    transform: "translate(114.778 46.072)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675-6",
    "data-name": "Rectangle 1675",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694-6",
    "data-name": "Path 3694",
    d: "M117.384,55.162a3,3,0,1,1-3-3,3,3,0,0,1,3,3Z",
    transform: "translate(11.795 -2.721)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676-6",
    "data-name": "Rectangle 1676",
    width: 42.825,
    height: 35.754,
    transform: "translate(49.498 93.237)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677-6",
    "data-name": "Rectangle 1677",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678-6",
    "data-name": "Rectangle 1678",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679-6",
    "data-name": "Rectangle 1679",
    width: 38.943,
    height: 6.004,
    transform: "translate(51.443 24.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680-6",
    "data-name": "Rectangle 1680",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681-6",
    "data-name": "Rectangle 1681",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294-6",
    "data-name": "Line 294",
    y2: 17.355,
    transform: "translate(70.91 36.469)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695-6",
    "data-name": "Path 3695",
    d: "M115.461,61.41v6.52L105.13,78.5",
    transform: "translate(10.715 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696-6",
    "data-name": "Path 3696",
    d: "M15.22,61.41v6.52L29.808,82.858",
    transform: "translate(-4.807 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697-6",
    "data-name": "Path 3697",
    d: "M81.083,102.009a17.59,17.59,0,0,0-24.883,0",
    transform: "translate(2.267 4.993)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698-6",
    "data-name": "Path 3698",
    d: "M76.88,106.03a12.383,12.383,0,0,0-17.59,0",
    transform: "translate(2.802 5.945)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699-6",
    "data-name": "Path 3699",
    d: "M71.934,109.763a6.3,6.3,0,0,0-8.924,0",
    transform: "translate(3.443 6.904)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700-6",
    "data-name": "Path 3700",
    d: "M69.083,113.269a1.982,1.982,0,1,1-1.976-1.83A1.982,1.982,0,0,1,69.083,113.269Z",
    transform: "translate(3.809 7.512)",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-25",
    "data-name": "Group 8903",
    transform: "translate(-4064.86 -11133.563) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2189.32, -414.08)",
    filter: "url(#Rectangle_1742-40)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-108",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2225.7 105.41) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2._Cloud_Solution-3",
    "data-name": "2._Cloud_Solution",
    transform: "translate(33.006 33.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3701-3",
    "data-name": "Path 3701",
    d: "M120.19,55.26A23.6,23.6,0,0,0,89.93,32.63,26.88,26.88,0,0,0,42,25.71,12.24,12.24,0,0,0,23.51,36.22c0,.33,0,.65,0,1a21,21,0,0,0,1.2,41.57v.09H99v-.11a23.61,23.61,0,0,0,21.19-23.51Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1683-3",
    "data-name": "Rectangle 1683",
    width: 49.59,
    height: 75.46,
    rx: 4.54,
    transform: "translate(38.2 49.54)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684-3",
    "data-name": "Rectangle 1684",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 58.11)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1685-3",
    "data-name": "Rectangle 1685",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 74.28)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1686-3",
    "data-name": "Rectangle 1686",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 90.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687-3",
    "data-name": "Rectangle 1687",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 106.63)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702-3",
    "data-name": "Path 3702",
    d: "M124.2,9.91a16.77,16.77,0,0,0-23.71,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3703-3",
    "data-name": "Path 3703",
    d: "M120.7,14.65a11.82,11.82,0,0,0-16.71,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3704-3",
    "data-name": "Path 3704",
    d: "M116.6,19.12a6,6,0,0,0-8.51,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3705-3",
    "data-name": "Path 3705",
    d: "M114.23,23a1.89,1.89,0,1,1-1.88-1.88A1.89,1.89,0,0,1,114.23,23Z",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-26",
    "data-name": "Group 8903",
    transform: "translate(-3813.142 -11168.94) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2443.51, -414.08)",
    filter: "url(#Rectangle_1742-41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-109",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2477.23 70.06) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_5._Smart_Metering-3",
    "data-name": "5._Smart_Metering",
    transform: "translate(32.28 33.126)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1691-3",
    "data-name": "Rectangle 1691",
    width: 82.05,
    height: 84.73,
    rx: 3,
    transform: "translate(9.58 8.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1692-3",
    "data-name": "Rectangle 1692",
    width: 82.05,
    height: 84.73,
    rx: 3,
    transform: "translate(9.58 8.94)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_315-3",
    "data-name": "Line 315",
    x2: 82.05,
    transform: "translate(9.58 27.3)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722-3",
    "data-name": "Path 3722",
    d: "M27.13,18.12a3.71,3.71,0,1,1-3.71-3.71,3.71,3.71,0,0,1,3.71,3.71Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723-3",
    "data-name": "Path 3723",
    d: "M39,18.12a3.71,3.71,0,1,1-3.71-3.71A3.71,3.71,0,0,1,39,18.12Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724-3",
    "data-name": "Path 3724",
    d: "M81.51,18.12a3.71,3.71,0,0,1-3.71,3.71H62.46a3.71,3.71,0,0,1,0-7.42H77.8A3.71,3.71,0,0,1,81.51,18.12Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_316-3",
    "data-name": "Line 316",
    x2: 19.29,
    transform: "translate(19.71 40.94)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317-3",
    "data-name": "Line 317",
    x2: 37.27,
    transform: "translate(19.71 53.97)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318-3",
    "data-name": "Line 318",
    x2: 37.27,
    transform: "translate(19.71 67)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319-3",
    "data-name": "Line 319",
    x2: 37.27,
    transform: "translate(19.71 80.03)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1693-3",
    "data-name": "Rectangle 1693",
    width: 5.82,
    height: 8.86,
    transform: "translate(52.26 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1694-3",
    "data-name": "Rectangle 1694",
    width: 5.82,
    height: 8.86,
    transform: "translate(52.26 73.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1695-3",
    "data-name": "Rectangle 1695",
    width: 49.47,
    height: 52.84,
    transform: "translate(64.52 53.56)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1696-3",
    "data-name": "Rectangle 1696",
    width: 33.84,
    height: 13.1,
    transform: "translate(72.33 86.86)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1697-3",
    "data-name": "Rectangle 1697",
    width: 62.33,
    height: 56.21,
    transform: "translate(58.08 37.39)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1698-3",
    "data-name": "Rectangle 1698",
    width: 48.52,
    height: 42.39,
    transform: "translate(64.99 44.3)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_973-3",
    "data-name": "Ellipse 973",
    cx: 4.53,
    cy: 4.53,
    r: 4.53,
    transform: "translate(74.42 70.92)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_974-3",
    "data-name": "Ellipse 974",
    cx: 4.53,
    cy: 4.53,
    r: 4.53,
    transform: "translate(95.02 70.92)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1699-3",
    "data-name": "Rectangle 1699",
    width: 33.84,
    height: 9.15,
    transform: "translate(72.33 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_320-3",
    "data-name": "Line 320",
    y2: 9.14,
    transform: "translate(80.79 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321-3",
    "data-name": "Line 321",
    y2: 9.14,
    transform: "translate(89.25 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322-3",
    "data-name": "Line 322",
    y2: 9.14,
    transform: "translate(97.71 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725-3",
    "data-name": "Path 3725",
    d: "M41.18,120.85c-1,.12-1.5-.58-2.08-1.19a4.73,4.73,0,0,0-5.74-1.06,5.17,5.17,0,0,0-1.69,1.46,2.21,2.21,0,0,1-3,.71A18.12,18.12,0,0,1,24,118a2.09,2.09,0,0,1-.69-2.75,4.8,4.8,0,0,0-3.76-6.68,2.14,2.14,0,0,1-2.11-2,14.54,14.54,0,0,1,.13-6.09,2.16,2.16,0,0,1,2-1.76,4.76,4.76,0,0,0,4-6.36,2.2,2.2,0,0,1,.89-2.93A17.65,17.65,0,0,1,28.57,87a2.24,2.24,0,0,1,3.08.65,4.79,4.79,0,0,0,5.09,1.46A4.69,4.69,0,0,0,39,87.63,2.21,2.21,0,0,1,42,87a18.57,18.57,0,0,1,4.74,2.8,2.23,2.23,0,0,1,.78,2.61c-.94,3.22.58,5.75,3.85,6.44,1.18.25,1.74,1.12,2,2.81a16.28,16.28,0,0,1-.17,5.07,2.2,2.2,0,0,1-2,2,4.82,4.82,0,0,0-3.79,6.55,2,2,0,0,1-.7,2.61,17.9,17.9,0,0,1-4.79,2.86,2.2,2.2,0,0,1-.74.1ZM35.3,109.94a6.2,6.2,0,1,0-6.1-6,6.11,6.11,0,0,0,6.1,6Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_975-3",
    "data-name": "Ellipse 975",
    cx: 7.4,
    cy: 7.4,
    r: 7.4,
    transform: "translate(26.802 109.998) rotate(-80.78)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726-3",
    "data-name": "Path 3726",
    d: "M104.08,12.13l-3.89,7.3,6.06.07-3.03,7.39",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-27",
    "data-name": "Group 8903",
    transform: "translate(-3561.427 -11204.316) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2697.7, -414.08)",
    filter: "url(#Rectangle_1742-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-110",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2728.76 34.71) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_9._Railways-3",
    "data-name": "9._Railways",
    transform: "translate(32.771 31.637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1708-3",
    "data-name": "Rectangle 1708",
    width: 80.23,
    height: 60.67,
    rx: 3,
    transform: "translate(44.1 7.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1709-3",
    "data-name": "Rectangle 1709",
    width: 80.23,
    height: 60.67,
    rx: 3,
    transform: "translate(44.1 7.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_341-3",
    "data-name": "Line 341",
    x2: 80.23,
    transform: "translate(44.1 20.58)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748-3",
    "data-name": "Path 3748",
    d: "M56.66,14A2.66,2.66,0,1,1,54,11.35,2.66,2.66,0,0,1,56.66,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749-3",
    "data-name": "Path 3749",
    d: "M65.16,14a2.66,2.66,0,1,1-2.65-2.65A2.66,2.66,0,0,1,65.16,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750-3",
    "data-name": "Path 3750",
    d: "M117.08,14a2.66,2.66,0,0,1-2.66,2.66H96.28a2.66,2.66,0,1,1,0-5.31h18.14A2.66,2.66,0,0,1,117.08,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_342-3",
    "data-name": "Line 342",
    x2: 13.81,
    transform: "translate(51.35 30.34)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343-3",
    "data-name": "Line 343",
    x2: 26.69,
    transform: "translate(51.35 39.67)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_344-3",
    "data-name": "Line 344",
    x2: 26.69,
    transform: "translate(51.35 49)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_345-3",
    "data-name": "Line 345",
    x2: 26.69,
    transform: "translate(51.35 58.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710-3",
    "data-name": "Rectangle 1710",
    width: 27.99,
    height: 27.99,
    transform: "translate(89.09 30.34)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751-3",
    "data-name": "Path 3751",
    d: "M106.51,104.38a5.82,5.82,0,0,1-5.82,5.82h-69a5.82,5.82,0,0,1-5.82-5.82V41.16A11.64,11.64,0,0,1,37.46,29.52H94.87a11.64,11.64,0,0,1,11.64,11.64Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752-3",
    "data-name": "Path 3752",
    d: "M31.95,125l6.35-14.8H94.03l6.36,14.8",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_346-3",
    "data-name": "Line 346",
    x2: 62.08,
    transform: "translate(35.13 118.22)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753-3",
    "data-name": "Path 3753",
    d: "M42.11,44.72H90.23a5.18,5.18,0,0,1,5.18,5.18V60.83a2.59,2.59,0,0,1-2.59,2.59H39.52a2.59,2.59,0,0,1-2.59-2.59V49.89A5.18,5.18,0,0,1,42.11,44.72Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_347-3",
    "data-name": "Line 347",
    x2: 43.39,
    transform: "translate(44.47 59.93)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348-3",
    "data-name": "Line 348",
    x2: 12.12,
    transform: "translate(60.11 91.27)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754-3",
    "data-name": "Path 3754",
    d: "M50.5,91.27a6.79,6.79,0,1,1-6.79-6.78,6.79,6.79,0,0,1,6.79,6.78Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755-3",
    "data-name": "Path 3755",
    d: "M95.4,91.27a6.78,6.78,0,1,1-6.78-6.78A6.78,6.78,0,0,1,95.4,91.27Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756-3",
    "data-name": "Path 3756",
    d: "M50.5,91.27a6.79,6.79,0,1,1-6.79-6.78,6.79,6.79,0,0,1,6.79,6.78Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757-3",
    "data-name": "Path 3757",
    d: "M95.4,91.27a6.78,6.78,0,1,1-6.78-6.78A6.78,6.78,0,0,1,95.4,91.27Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758-3",
    "data-name": "Path 3758",
    d: "M29.44,13.68a17.33,17.33,0,0,0-24.54,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759-3",
    "data-name": "Path 3759",
    d: "M26.08,18.56a12.58,12.58,0,0,0-17.82,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760-3",
    "data-name": "Path 3760",
    d: "M22.73,23.25a7.85,7.85,0,0,0-11.12,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761-3",
    "data-name": "Path 3761",
    d: "M19.81,27.8a2.64,2.64,0,1,1-2.64-2.64,2.64,2.64,0,0,1,2.64,2.64Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349-3",
    "data-name": "Line 349",
    y2: 18.7,
    transform: "translate(66.17 44.72)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-28",
    "data-name": "Group 8903",
    transform: "translate(-4281.199 -10846.471) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1935.13, -668.27)",
    filter: "url(#Rectangle_1745)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1745-2",
    "data-name": "Rectangle 1745",
    width: 226.143,
    height: 226.143,
    rx: 14,
    transform: "translate(1992.24 379.28) rotate(-8)",
    fill: "#0561fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3._E-Mobility-3",
    "data-name": "3._E-Mobility",
    transform: "translate(32.1 32.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3706-3",
    "data-name": "Path 3706",
    d: "M49.39,83.21l27.26,8.32,3.14,5.65v13.2H14.16V83.21Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_970-3",
    "data-name": "Ellipse 970",
    cx: 34.99,
    cy: 34.99,
    r: 34.99,
    transform: "translate(47.42 10.24)",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3707-3",
    "data-name": "Path 3707",
    d: "M99,39.06a1.12,1.12,0,0,0-1-.57H83.32l2.47-18.83a1.126,1.126,0,0,0-2.06-.74L65.84,50.25a1.12,1.12,0,0,0,.37,1.55,1.18,1.18,0,0,0,.59.16H81.28l-2,18.87a1.12,1.12,0,0,0,2.07.69L99,40.19a1.11,1.11,0,0,0,0-1.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3708-3",
    "data-name": "Path 3708",
    d: "M99,39.06a1.12,1.12,0,0,0-1-.57H83.32l2.47-18.83a1.126,1.126,0,0,0-2.06-.74L65.84,50.25a1.12,1.12,0,0,0,.37,1.55,1.18,1.18,0,0,0,.59.16H81.28l-2,18.87a1.12,1.12,0,0,0,2.07.69L99,40.19a1.11,1.11,0,0,0,0-1.13Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3709-3",
    "data-name": "Path 3709",
    d: "M49.39,83.21s19.94,5.32,24.7,7.4a9.81,9.81,0,0,1,5.7,6.16v13.61H71.1",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3710-3",
    "data-name": "Path 3710",
    d: "M14.16,110.38H49.25",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3711-3",
    "data-name": "Path 3711",
    d: "M14.14,71.08A73.81,73.81,0,0,1,33.8,75.46a84,84,0,0,1,15.59,7.75H14.16",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_295-3",
    "data-name": "Line 295",
    x2: 8.51,
    transform: "translate(19.1 90.61)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3712-3",
    "data-name": "Path 3712",
    d: "M71.22,108.72a11.28,11.28,0,0,1-.12,1.66,11.05,11.05,0,0,1-21.85,0,11.281,11.281,0,0,1-.12-1.66,11.045,11.045,0,1,1,22.09,0Z",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3713-3",
    "data-name": "Path 3713",
    d: "M65.3,108.72a6.488,6.488,0,0,1,0,.77,5.13,5.13,0,0,1-10.14,0,4.9,4.9,0,0,1-.06-.77,5.13,5.13,0,0,1,10.25,0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-29",
    "data-name": "Group 8903",
    transform: "translate(-4029.484 -10881.847) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2189.32, -668.27)",
    filter: "url(#Rectangle_1742-43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-111",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2261.05 356.94) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4._Solar___Wind-3",
    "data-name": "4._Solar_&_Wind",
    transform: "translate(33.012 32.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3714-3",
    "data-name": "Path 3714",
    d: "M94.29,61.43A21,21,0,1,1,113.6,32.31",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3715-3",
    "data-name": "Path 3715",
    d: "M107.64,30.54l6,2.14,2.03-5.7",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3716-3",
    "data-name": "Path 3716",
    d: "M97.46,40.47a3.17,3.17,0,1,1-2.6-3.124A3.16,3.16,0,0,1,97.46,40.47Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_971-3",
    "data-name": "Ellipse 971",
    cx: 3.28,
    cy: 16.13,
    rx: 3.28,
    ry: 16.13,
    transform: "translate(91.01 5.06)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3717-3",
    "data-name": "Path 3717",
    d: "M75.94,47.28a40.74,40.74,0,0,1,15.61-5.22A40.51,40.51,0,0,1,79.22,53a40.31,40.31,0,0,1-15.6,5.22A40.72,40.72,0,0,1,75.94,47.28Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3718-3",
    "data-name": "Path 3718",
    d: "M109.35,53A40.51,40.51,0,0,1,97,42.06a41.25,41.25,0,0,1,28,16.12A40.31,40.31,0,0,1,109.35,53Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3719-3",
    "data-name": "Path 3719",
    d: "M97,124.93H91.63l1-81.74a3.14,3.14,0,0,0,3.24,0Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3747-3",
    "data-name": "Path 3747",
    d: "M119.91,0H0",
    transform: "translate(5.04 124.93)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3720-3",
    "data-name": "Path 3720",
    d: "M68.92,112.82H45.05l9.92-18.68H78.84Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_297-3",
    "data-name": "Line 297",
    y1: 18.68,
    x2: 9.93,
    transform: "translate(60.96 94.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_298-3",
    "data-name": "Line 298",
    y1: 18.68,
    x2: 9.92,
    transform: "translate(53.01 94.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_299-3",
    "data-name": "Line 299",
    x1: 23.88,
    transform: "translate(48.35 106.6)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_300-3",
    "data-name": "Line 300",
    x1: 23.87,
    transform: "translate(51.68 100.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1688-3",
    "data-name": "Rectangle 1688",
    width: 4.94,
    height: 12.1,
    transform: "translate(59.48 112.82)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_301-3",
    "data-name": "Line 301",
    y2: 4.98,
    transform: "translate(21.49 34.15)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_302-3",
    "data-name": "Line 302",
    y2: 4.97,
    transform: "translate(21.49 5.07)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_303-3",
    "data-name": "Line 303",
    x2: 2.85,
    y2: 4.08,
    transform: "translate(28.41 31.97)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_304-3",
    "data-name": "Line 304",
    x2: 2.85,
    y2: 4.07,
    transform: "translate(11.73 8.15)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_305-3",
    "data-name": "Line 305",
    x2: 4.68,
    y2: 1.7,
    transform: "translate(32.82 26.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_306-3",
    "data-name": "Line 306",
    x2: 4.68,
    y2: 1.7,
    transform: "translate(5.49 16.27)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_307-3",
    "data-name": "Line 307",
    y1: 1.29,
    x2: 4.81,
    transform: "translate(33.14 17.69)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_308-3",
    "data-name": "Line 308",
    y1: 1.29,
    x2: 4.81,
    transform: "translate(5.04 25.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_309-3",
    "data-name": "Line 309",
    y1: 3.81,
    x2: 3.2,
    transform: "translate(29.24 9.05)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_310-3",
    "data-name": "Line 310",
    y1: 3.82,
    x2: 3.2,
    transform: "translate(10.55 31.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_972-3",
    "data-name": "Ellipse 972",
    cx: 7.74,
    cy: 7.74,
    r: 7.74,
    transform: "translate(12.185 27.856) rotate(-76.72)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3721-3",
    "data-name": "Path 3721",
    d: "M35.55,112.82H11.68L21.6,94.14H45.47Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_311-3",
    "data-name": "Line 311",
    y1: 18.68,
    x2: 9.92,
    transform: "translate(27.59 94.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_312-3",
    "data-name": "Line 312",
    y1: 18.68,
    x2: 9.92,
    transform: "translate(19.63 94.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_313-3",
    "data-name": "Line 313",
    x1: 23.87,
    transform: "translate(14.98 106.6)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_314-3",
    "data-name": "Line 314",
    x1: 23.87,
    transform: "translate(18.31 100.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1689-3",
    "data-name": "Rectangle 1689",
    width: 4.94,
    height: 12.1,
    transform: "translate(26.1 112.82)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-30",
    "data-name": "Group 8903",
    transform: "translate(-3795.053 -10930.251) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2428.2, -652.96)",
    filter: "url(#Rectangle_1742-44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-112",
    "data-name": "Rectangle 1742",
    width: 226.143,
    height: 226.143,
    rx: 14,
    transform: "translate(2495.45 308.67) rotate(-8)",
    fill: "#0561fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8893-7",
    "data-name": "Group 8893",
    transform: "translate(33.168 39.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691-7",
    "data-name": "Path 3691",
    d: "M137.85,96.706a23.219,23.219,0,0,0-29.837-22.283A26.46,26.46,0,0,0,60.83,67.642,12.043,12.043,0,0,0,42.6,77.99c0,.326,0,.637,0,.949a20.628,20.628,0,0,0,1.207,40.822v.095h73.128v-.095A23.246,23.246,0,0,0,137.85,96.706Z",
    transform: "translate(0.486 6.367)",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1670-7",
    "data-name": "Rectangle 1670",
    width: 24.1,
    height: 21.727,
    transform: "translate(0 47.997)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692-7",
    "data-name": "Path 3692",
    d: "M30.44,48.57H6.34L18.4,36.5Z",
    transform: "translate(-6.34 -0.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671-7",
    "data-name": "Rectangle 1671",
    width: 9.114,
    height: 14.023,
    transform: "translate(7.486 55.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672-7",
    "data-name": "Rectangle 1672",
    width: 24.1,
    height: 21.727,
    transform: "translate(0 47.997)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693-7",
    "data-name": "Path 3693",
    d: "M30.44,48.57H6.34L18.4,36.5Z",
    transform: "translate(-6.34 -0.56)",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673-7",
    "data-name": "Rectangle 1673",
    width: 26.365,
    height: 43.806,
    transform: "translate(132.748 25.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674-7",
    "data-name": "Rectangle 1674",
    width: 26.365,
    height: 16.437,
    transform: "translate(132.748 53.285)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675-7",
    "data-name": "Rectangle 1675",
    width: 26.365,
    height: 43.806,
    transform: "translate(132.748 25.918)",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694-7",
    "data-name": "Path 3694",
    d: "M118.324,55.632a3.472,3.472,0,1,1-3.472-3.472,3.472,3.472,0,0,1,3.472,3.472Z",
    transform: "translate(31.079 5.019)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676-7",
    "data-name": "Rectangle 1676",
    width: 49.529,
    height: 41.351,
    transform: "translate(57.247 107.835)",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677-7",
    "data-name": "Rectangle 1677",
    width: 23.395,
    height: 6.944,
    transform: "translate(70.321 35.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678-7",
    "data-name": "Rectangle 1678",
    width: 45.04,
    height: 35.235,
    transform: "translate(59.497 0)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679-7",
    "data-name": "Rectangle 1679",
    width: 45.04,
    height: 6.944,
    transform: "translate(59.497 28.278)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680-7",
    "data-name": "Rectangle 1680",
    width: 45.04,
    height: 35.235,
    transform: "translate(59.497 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681-7",
    "data-name": "Rectangle 1681",
    width: 23.395,
    height: 6.944,
    transform: "translate(70.321 35.236)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294-7",
    "data-name": "Line 294",
    y2: 20.072,
    transform: "translate(82.012 42.178)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695-7",
    "data-name": "Path 3695",
    d: "M117.078,61.41v7.541L105.13,81.17",
    transform: "translate(28.852 8.314)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696-7",
    "data-name": "Path 3696",
    d: "M15.22,61.41v7.541L32.091,86.215",
    transform: "translate(-3.177 8.314)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697-7",
    "data-name": "Path 3697",
    d: "M84.979,102.816a20.343,20.343,0,0,0-28.779,0",
    transform: "translate(11.421 20.938)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698-7",
    "data-name": "Path 3698",
    d: "M79.633,106.6a14.322,14.322,0,0,0-20.343,0",
    transform: "translate(12.523 22.902)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699-7",
    "data-name": "Path 3699",
    d: "M73.331,110.053a7.283,7.283,0,0,0-10.321,0",
    transform: "translate(13.847 24.879)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700-7",
    "data-name": "Path 3700",
    d: "M69.7,113.556a2.292,2.292,0,1,1-2.285-2.116A2.292,2.292,0,0,1,69.7,113.556Z",
    transform: "translate(14.601 26.136)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-31",
    "data-name": "Group 8903",
    transform: "translate(-3526.05 -10952.6) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2697.7, -668.27)",
    filter: "url(#Rectangle_1742-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-113",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2764.11 286.24) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_32._IP_Core-FPGA-3",
    "data-name": "32._IP Core-FPGA",
    transform: "translate(32.381 32.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3689-3",
    "data-name": "Path 3689",
    d: "M19.86,19.86v90.28h90.28V19.86ZM94.94,94.93H35.06V35.07H94.94Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1667-3",
    "data-name": "Rectangle 1667",
    width: 90.27,
    height: 90.27,
    transform: "translate(19.86 19.86)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_270-3",
    "data-name": "Line 270",
    y1: 12.57,
    transform: "translate(36.59 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_271-3",
    "data-name": "Line 271",
    y1: 12.57,
    transform: "translate(50.79 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_272-3",
    "data-name": "Line 272",
    y1: 12.57,
    transform: "translate(65 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_273-3",
    "data-name": "Line 273",
    y1: 12.57,
    transform: "translate(79.21 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_274-3",
    "data-name": "Line 274",
    y1: 12.57,
    transform: "translate(93.41 7.29)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_275-3",
    "data-name": "Line 275",
    y1: 12.57,
    transform: "translate(36.59 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_276-3",
    "data-name": "Line 276",
    y1: 12.57,
    transform: "translate(50.79 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_277-3",
    "data-name": "Line 277",
    y1: 12.57,
    transform: "translate(65 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_278-3",
    "data-name": "Line 278",
    y1: 12.57,
    transform: "translate(79.21 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_279-3",
    "data-name": "Line 279",
    y1: 12.57,
    transform: "translate(93.41 110.14)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_280-3",
    "data-name": "Line 280",
    x2: 12.57,
    transform: "translate(110.14 36.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_281-3",
    "data-name": "Line 281",
    x2: 12.57,
    transform: "translate(110.14 50.79)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282-3",
    "data-name": "Line 282",
    x2: 12.57,
    transform: "translate(110.14 65)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283-3",
    "data-name": "Line 283",
    x2: 12.57,
    transform: "translate(110.14 79.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284-3",
    "data-name": "Line 284",
    x2: 12.57,
    transform: "translate(110.14 93.41)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_285-3",
    "data-name": "Line 285",
    x2: 12.57,
    transform: "translate(7.29 36.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_286-3",
    "data-name": "Line 286",
    x2: 12.57,
    transform: "translate(7.29 50.79)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_287-3",
    "data-name": "Line 287",
    x2: 12.57,
    transform: "translate(7.29 65)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_288-3",
    "data-name": "Line 288",
    x2: 12.57,
    transform: "translate(7.29 79.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_289-3",
    "data-name": "Line 289",
    x2: 12.57,
    transform: "translate(7.29 93.41)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1668-3",
    "data-name": "Rectangle 1668",
    width: 59.87,
    height: 59.87,
    transform: "translate(35.06 35.06)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_290-3",
    "data-name": "Line 290",
    y2: 17.13,
    transform: "translate(49.2 77.81)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_967-3",
    "data-name": "Ellipse 967",
    cx: 6.39,
    cy: 6.39,
    r: 6.39,
    transform: "translate(42.81 71.42)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3690-3",
    "data-name": "Path 3690",
    d: "M76.47,65H57.19V51.82H35.06",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_291-3",
    "data-name": "Line 291",
    y2: 32.53,
    transform: "translate(76.47 35.06)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_292-3",
    "data-name": "Line 292",
    y2: 27.35,
    transform: "translate(76.47 67.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_293-3",
    "data-name": "Line 293",
    x1: 18.47,
    transform: "translate(76.47 84.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_968-3",
    "data-name": "Ellipse 968",
    cx: 6.39,
    cy: 6.39,
    r: 6.39,
    transform: "translate(50.8 45.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_969-3",
    "data-name": "Ellipse 969",
    cx: 6.39,
    cy: 6.39,
    r: 6.39,
    transform: "translate(70.08 58.61)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-32",
    "data-name": "Group 8903",
    transform: "translate(-4245.823 -10594.755) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1935.13, -922.46)",
    filter: "url(#Rectangle_1742-46)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-114",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2044.87 643.82) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7._Home_Automation-6",
    "data-name": "7._Home_Automation",
    transform: "translate(33.091 32.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3727-6",
    "data-name": "Path 3727",
    d: "M109.71,75.32V125H85.95V75.32h.11l2.72,2.73h8.43l-2.73-2.73Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3728-6",
    "data-name": "Path 3728",
    d: "M44.1,75.32V125H20.34V75.32H35.59l-2.71,2.73H41.3l2.71-2.73Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701-6",
    "data-name": "Rectangle 1701",
    width: 9.51,
    height: 9.51,
    transform: "translate(93.07 95.4)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702-6",
    "data-name": "Rectangle 1702",
    width: 9.51,
    height: 9.51,
    transform: "translate(27.47 95.4)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3729-6",
    "data-name": "Path 3729",
    d: "M85.95,75.21V125H44.1V75.22l6.01-6.05,3.56-3.59L65.02,54.23,76.34,65.57l3.58,3.59Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3730-6",
    "data-name": "Path 3730",
    d: "M69.75,78.65H60.23V73.89A4.76,4.76,0,0,1,65,69.13h0a4.76,4.76,0,0,1,4.76,4.76Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1703-6",
    "data-name": "Rectangle 1703",
    width: 19.18,
    height: 31.68,
    transform: "translate(55.4 93.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323-6",
    "data-name": "Line 323",
    x2: 111.7,
    transform: "translate(9.15 125)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731-6",
    "data-name": "Path 3731",
    d: "M115.85,75.32H94.48l-6.17-6.19h.02L69.89,50.67H91.24l18.44,18.46h.02v.03Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3732-6",
    "data-name": "Path 3732",
    d: "M41.69,69.13h.05l-6.15,6.19H14.13l6.19-6.19L38.76,50.67H60.15Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733-6",
    "data-name": "Path 3733",
    d: "M109.71,69.13v.02l-.02-.02Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324-6",
    "data-name": "Line 324",
    x1: 0.01,
    transform: "translate(109.7 75.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734-6",
    "data-name": "Path 3734",
    d: "M97.21,78.05H88.78l-2.72-2.73-.11-.11-6.03-6.05-3.58-3.59L65.02,54.23,53.67,65.58l-3.56,3.59L44.1,75.22l-.09.1L41.3,78.05H32.88l2.71-2.73,6.15-6.19,7.71-7.76L65.02,45.81,80.56,61.35l7.75,7.78,6.17,6.19Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325-6",
    "data-name": "Line 325",
    y2: 1.96,
    transform: "translate(60.09 108.18)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_326-6",
    "data-name": "Line 326",
    x1: 21.35,
    transform: "translate(30.57 58.89)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327-6",
    "data-name": "Line 327",
    x1: 21.35,
    transform: "translate(22.29 67.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328-6",
    "data-name": "Line 328",
    x2: 21.35,
    transform: "translate(78.02 58.89)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329-6",
    "data-name": "Line 329",
    x2: 21.35,
    transform: "translate(86.3 67.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735-6",
    "data-name": "Path 3735",
    d: "M83,12.46a25.49,25.49,0,0,0-36,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736-6",
    "data-name": "Path 3736",
    d: "M78.08,17.4a18.49,18.49,0,0,0-26.18,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737-6",
    "data-name": "Path 3737",
    d: "M73.15,22.32a11.54,11.54,0,0,0-16.32,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738-6",
    "data-name": "Path 3738",
    d: "M68.87,28.53A3.88,3.88,0,1,1,65,24.66,3.88,3.88,0,0,1,68.87,28.53Z",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8933",
    "data-name": "Group 8933",
    transform: "translate(-4171.54 -10086.85) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1938, -1435.76)",
    filter: "url(#Rectangle_1742-47)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-115",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2119.16 1151.72) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7._Home_Automation-7",
    "data-name": "7._Home_Automation",
    transform: "translate(33.091 32.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3727-7",
    "data-name": "Path 3727",
    d: "M109.71,75.32V125H85.95V75.32h.11l2.72,2.73h8.43l-2.73-2.73Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3728-7",
    "data-name": "Path 3728",
    d: "M44.1,75.32V125H20.34V75.32H35.59l-2.71,2.73H41.3l2.71-2.73Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701-7",
    "data-name": "Rectangle 1701",
    width: 9.51,
    height: 9.51,
    transform: "translate(93.07 95.4)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702-7",
    "data-name": "Rectangle 1702",
    width: 9.51,
    height: 9.51,
    transform: "translate(27.47 95.4)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3729-7",
    "data-name": "Path 3729",
    d: "M85.95,75.21V125H44.1V75.22l6.01-6.05,3.56-3.59L65.02,54.23,76.34,65.57l3.58,3.59Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3730-7",
    "data-name": "Path 3730",
    d: "M69.75,78.65H60.23V73.89A4.76,4.76,0,0,1,65,69.13h0a4.76,4.76,0,0,1,4.76,4.76Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1703-7",
    "data-name": "Rectangle 1703",
    width: 19.18,
    height: 31.68,
    transform: "translate(55.4 93.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_323-7",
    "data-name": "Line 323",
    x2: 111.7,
    transform: "translate(9.15 125)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731-7",
    "data-name": "Path 3731",
    d: "M115.85,75.32H94.48l-6.17-6.19h.02L69.89,50.67H91.24l18.44,18.46h.02v.03Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3732-7",
    "data-name": "Path 3732",
    d: "M41.69,69.13h.05l-6.15,6.19H14.13l6.19-6.19L38.76,50.67H60.15Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733-7",
    "data-name": "Path 3733",
    d: "M109.71,69.13v.02l-.02-.02Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324-7",
    "data-name": "Line 324",
    x1: 0.01,
    transform: "translate(109.7 75.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734-7",
    "data-name": "Path 3734",
    d: "M97.21,78.05H88.78l-2.72-2.73-.11-.11-6.03-6.05-3.58-3.59L65.02,54.23,53.67,65.58l-3.56,3.59L44.1,75.22l-.09.1L41.3,78.05H32.88l2.71-2.73,6.15-6.19,7.71-7.76L65.02,45.81,80.56,61.35l7.75,7.78,6.17,6.19Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325-7",
    "data-name": "Line 325",
    y2: 1.96,
    transform: "translate(60.09 108.18)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_326-7",
    "data-name": "Line 326",
    x1: 21.35,
    transform: "translate(30.57 58.89)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_327-7",
    "data-name": "Line 327",
    x1: 21.35,
    transform: "translate(22.29 67.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_328-7",
    "data-name": "Line 328",
    x2: 21.35,
    transform: "translate(78.02 58.89)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_329-7",
    "data-name": "Line 329",
    x2: 21.35,
    transform: "translate(86.3 67.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735-7",
    "data-name": "Path 3735",
    d: "M83,12.46a25.49,25.49,0,0,0-36,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736-7",
    "data-name": "Path 3736",
    d: "M78.08,17.4a18.49,18.49,0,0,0-26.18,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737-7",
    "data-name": "Path 3737",
    d: "M73.15,22.32a11.54,11.54,0,0,0-16.32,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738-7",
    "data-name": "Path 3738",
    d: "M68.87,28.53A3.88,3.88,0,1,1,65,24.66,3.88,3.88,0,0,1,68.87,28.53Z",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-33",
    "data-name": "Group 8903",
    transform: "translate(-3994.107 -10630.131) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2189.32, -922.46)",
    filter: "url(#Rectangle_1742-48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-116",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2296.4 608.47) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_12._Digital_Signage-7",
    "data-name": "12._Digital Signage",
    transform: "translate(40.192 32.677)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711-7",
    "data-name": "Rectangle 1711",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712-7",
    "data-name": "Rectangle 1712",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350-7",
    "data-name": "Line 350",
    x2: 85.52,
    transform: "translate(2.86 18.02)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762-7",
    "data-name": "Path 3762",
    d: "M16.25,11a2.83,2.83,0,1,1-.825-2.008A2.84,2.84,0,0,1,16.25,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763-7",
    "data-name": "Path 3763",
    d: "M25.31,11a2.83,2.83,0,1,1-.825-2.008A2.83,2.83,0,0,1,25.31,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764-7",
    "data-name": "Path 3764",
    d: "M80.65,11a2.83,2.83,0,0,1-2.83,2.83H58.48a2.83,2.83,0,1,1,0-5.66H77.82A2.83,2.83,0,0,1,80.65,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351-7",
    "data-name": "Line 351",
    x2: 14.73,
    transform: "translate(10.58 28.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352-7",
    "data-name": "Line 352",
    x2: 28.45,
    transform: "translate(10.58 38.38)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353-7",
    "data-name": "Line 353",
    x2: 28.45,
    transform: "translate(10.58 48.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354-7",
    "data-name": "Line 354",
    x2: 28.45,
    transform: "translate(10.58 58.27)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713-7",
    "data-name": "Rectangle 1713",
    width: 29.84,
    height: 29.84,
    transform: "translate(50.81 28.43)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715-7",
    "data-name": "Rectangle 1715",
    width: 45.28,
    height: 67.63,
    transform: "translate(67.01 28.74)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716-7",
    "data-name": "Rectangle 1716",
    width: 45.28,
    height: 7.5,
    transform: "translate(67.01 118.18)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717-7",
    "data-name": "Rectangle 1717",
    width: 10.84,
    height: 21.81,
    transform: "translate(84.23 96.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765-7",
    "data-name": "Path 3765",
    d: "M89.61,76.09a13.53,13.53,0,1,1,13.57-13.51A13.53,13.53,0,0,1,89.61,76.09Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766-7",
    "data-name": "Path 3766",
    d: "M86.27,62.55v-4a1,1,0,0,1,.45-1,.93.93,0,0,1,1,.13l6.4,4c.78.49.77,1.17,0,1.65l-6.4,4c-.33.2-.71.4-1,.11a1.53,1.53,0,0,1-.44-.93C86.24,65.23,86.27,63.89,86.27,62.55Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8936",
    "data-name": "Group 8936",
    transform: "translate(-3919.824 -10122.226) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2192.19, -1435.76)",
    filter: "url(#Rectangle_1742-49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-117",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2370.68 1116.37) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_12._Digital_Signage-8",
    "data-name": "12._Digital Signage",
    transform: "translate(40.192 32.677)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711-8",
    "data-name": "Rectangle 1711",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712-8",
    "data-name": "Rectangle 1712",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350-8",
    "data-name": "Line 350",
    x2: 85.52,
    transform: "translate(2.86 18.02)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762-8",
    "data-name": "Path 3762",
    d: "M16.25,11a2.83,2.83,0,1,1-.825-2.008A2.84,2.84,0,0,1,16.25,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763-8",
    "data-name": "Path 3763",
    d: "M25.31,11a2.83,2.83,0,1,1-.825-2.008A2.83,2.83,0,0,1,25.31,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764-8",
    "data-name": "Path 3764",
    d: "M80.65,11a2.83,2.83,0,0,1-2.83,2.83H58.48a2.83,2.83,0,1,1,0-5.66H77.82A2.83,2.83,0,0,1,80.65,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351-8",
    "data-name": "Line 351",
    x2: 14.73,
    transform: "translate(10.58 28.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352-8",
    "data-name": "Line 352",
    x2: 28.45,
    transform: "translate(10.58 38.38)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353-8",
    "data-name": "Line 353",
    x2: 28.45,
    transform: "translate(10.58 48.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354-8",
    "data-name": "Line 354",
    x2: 28.45,
    transform: "translate(10.58 58.27)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713-8",
    "data-name": "Rectangle 1713",
    width: 29.84,
    height: 29.84,
    transform: "translate(50.81 28.43)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715-8",
    "data-name": "Rectangle 1715",
    width: 45.28,
    height: 67.63,
    transform: "translate(67.01 28.74)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716-8",
    "data-name": "Rectangle 1716",
    width: 45.28,
    height: 7.5,
    transform: "translate(67.01 118.18)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717-8",
    "data-name": "Rectangle 1717",
    width: 10.84,
    height: 21.81,
    transform: "translate(84.23 96.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765-8",
    "data-name": "Path 3765",
    d: "M89.61,76.09a13.53,13.53,0,1,1,13.57-13.51A13.53,13.53,0,0,1,89.61,76.09Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766-8",
    "data-name": "Path 3766",
    d: "M86.27,62.55v-4a1,1,0,0,1,.45-1,.93.93,0,0,1,1,.13l6.4,4c.78.49.77,1.17,0,1.65l-6.4,4c-.33.2-.71.4-1,.11a1.53,1.53,0,0,1-.44-.93C86.24,65.23,86.27,63.89,86.27,62.55Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-34",
    "data-name": "Group 8903",
    transform: "translate(-3742.39 -10665.508) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2443.51, -922.46)",
    filter: "url(#Rectangle_1742-50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-118",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2547.93 573.12) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_73._APIs-SDK_for_real-time_tracking-5",
    "data-name": "73._APIs-SDK for real-time tracking",
    transform: "translate(32.95 32.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3767-5",
    "data-name": "Path 3767",
    d: "M37.08,96.63l18.09,18.09H66.19",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355-5",
    "data-name": "Line 355",
    y1: 20.64,
    transform: "translate(19.04 49.71)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768-5",
    "data-name": "Path 3768",
    d: "M35.91,52.88V22.71H28.05",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769-5",
    "data-name": "Path 3769",
    d: "M83.2,96.63v10.91H99.16",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-11",
    "data-name": "Path 926",
    d: "M100.08,46.93c.22-2.56-.33-4-2-4.77a7.13,7.13,0,0,1-4.39-9.08,6.8,6.8,0,0,1,.82-1.64,3.39,3.39,0,0,0-.32-4.1,28.22,28.22,0,0,0-6.06-5.64,3.3,3.3,0,0,0-4.63-.05,7,7,0,0,1-3.83,1.46,7.22,7.22,0,0,1-7-3.79,3.33,3.33,0,0,0-4.3-1.94,26.67,26.67,0,0,0-6.93,2.15,3.33,3.33,0,0,0-2.25,4A7.19,7.19,0,0,1,53,31.62a7.44,7.44,0,0,1-1.7,0,3.26,3.26,0,0,0-3.5,1.93,22,22,0,0,0-2.16,8.94,3.23,3.23,0,0,0,2.45,3.64,7.21,7.21,0,0,1,3.38,11,3.14,3.14,0,0,0,.13,4.26,26.89,26.89,0,0,0,6.07,5.64,3.33,3.33,0,0,0,4.6-.03,7.77,7.77,0,0,1,2.95-1.59,7.12,7.12,0,0,1,8.12,3.42c.65,1.08,1.19,2.27,2.67,2.42a3.52,3.52,0,0,0,1.17.08,26.8,26.8,0,0,0,8-2.69A3.07,3.07,0,0,0,87,65a7.26,7.26,0,0,1,6-8.34,6.91,6.91,0,0,1,1.7-.08,3.34,3.34,0,0,0,3.54-2.27A26,26,0,0,0,100.08,46.93ZM70.82,53.29a7.639,7.639,0,1,1,0,.02Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770-5",
    "data-name": "Path 3770",
    d: "M111,77.16A19.47,19.47,0,0,0,86,58.48a22.17,22.17,0,0,0-39.54-5.71,10.1,10.1,0,0,0-15.28,8.67c0,.27,0,.54,0,.8a17.3,17.3,0,0,0,1,34.31v.08H93.43v-.1A19.47,19.47,0,0,0,111,77.16Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_976-5",
    "data-name": "Ellipse 976",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(15.76 16.58)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_977-5",
    "data-name": "Ellipse 977",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(12.91 44.58)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_978-5",
    "data-name": "Ellipse 978",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(64.62 108.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_979-5",
    "data-name": "Ellipse 979",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(90.37 101.41)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_980-5",
    "data-name": "Ellipse 980",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(104.83 30.36)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_981-5",
    "data-name": "Ellipse 981",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(94.58 9.15)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_356-5",
    "data-name": "Line 356",
    y2: 33.21,
    transform: "translate(110.96 42.62)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771-5",
    "data-name": "Path 3771",
    d: "M33.13,82h-5l-.85,2.41h-2L29.54,72.6h2.25L36,84.43H34Zm-.55-1.58L30.66,75l-1.93,5.49Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772-5",
    "data-name": "Path 3772",
    d: "M45.69,77.84a3.23,3.23,0,0,1-1.36,1.3,5.09,5.09,0,0,1-2.4.5H39.79v4.79H37.85V72.62h4.08a5.06,5.06,0,0,1,2.31.47,3.34,3.34,0,0,1,1.41,1.26,3.48,3.48,0,0,1,.46,1.79A3.62,3.62,0,0,1,45.69,77.84Zm-2.11-.29a1.82,1.82,0,0,0,.54-1.41c0-1.3-.73-1.94-2.19-1.94H39.79v3.86h2.14a2.33,2.33,0,0,0,1.65-.51Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773-5",
    "data-name": "Path 3773",
    d: "M49.9,72.62V84.43H48V72.62Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3774-5",
    "data-name": "Path 3774",
    d: "M53.87,84.18a3.49,3.49,0,0,1-1.38-1.08,2.8,2.8,0,0,1-.55-1.54h2a1.33,1.33,0,0,0,.57,1,2,2,0,0,0,1.3.4,2.17,2.17,0,0,0,1.26-.31,1,1,0,0,0,.45-.81.82.82,0,0,0-.5-.78,8.811,8.811,0,0,0-1.59-.56,17.249,17.249,0,0,1-1.71-.56,3.06,3.06,0,0,1-1.15-.84,2.18,2.18,0,0,1-.48-1.48,2.25,2.25,0,0,1,.44-1.36,2.87,2.87,0,0,1,1.26-1,4.7,4.7,0,0,1,1.9-.36,3.9,3.9,0,0,1,2.57.81,2.89,2.89,0,0,1,1,2.2H57.38a1.35,1.35,0,0,0-.51-1,1.89,1.89,0,0,0-1.24-.38,2,2,0,0,0-1.17.29.9.9,0,0,0-.41.77.83.83,0,0,0,.27.63,2,2,0,0,0,.66.4l1.16.36a13.061,13.061,0,0,1,1.67.55,3,3,0,0,1,1.13.83,2.15,2.15,0,0,1,.5,1.44A2.45,2.45,0,0,1,59,83.24a3,3,0,0,1-1.25,1,4.81,4.81,0,0,1-1.9.35,4.67,4.67,0,0,1-1.98-.41Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775-5",
    "data-name": "Path 3775",
    d: "M72.5,84.17A3.54,3.54,0,0,1,71,83a3,3,0,0,1-.55-1.79h2.08a1.88,1.88,0,0,0,.6,1.26,2.15,2.15,0,0,0,1.51.5,2.31,2.31,0,0,0,1.57-.49,1.58,1.58,0,0,0,.56-1.25,1.37,1.37,0,0,0-.35-1,2.33,2.33,0,0,0-.87-.58,11.84,11.84,0,0,0-1.44-.44,14.24,14.24,0,0,1-1.88-.62,3.14,3.14,0,0,1-1.23-1,2.86,2.86,0,0,1-.51-1.77A3.14,3.14,0,0,1,71,74.06a3.22,3.22,0,0,1,1.43-1.18,5.22,5.22,0,0,1,2.13-.41,4.44,4.44,0,0,1,2.81.86,3.16,3.16,0,0,1,1.22,2.36H76.46a1.54,1.54,0,0,0-.62-1.1,2.24,2.24,0,0,0-1.48-.46,2.1,2.1,0,0,0-1.36.42,1.5,1.5,0,0,0-.53,1.23,1.24,1.24,0,0,0,.33.89,2.24,2.24,0,0,0,.85.55,12.09,12.09,0,0,0,1.39.45,14.749,14.749,0,0,1,1.92.64,3.28,3.28,0,0,1,1.26,1,2.92,2.92,0,0,1,.52,1.8,3.16,3.16,0,0,1-.49,1.7,3.47,3.47,0,0,1-1.41,1.29,4.71,4.71,0,0,1-2.19.48,5.49,5.49,0,0,1-2.15-.41Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3776-5",
    "data-name": "Path 3776",
    d: "M88.22,73.35a5.17,5.17,0,0,1,2.19,2.08,6.2,6.2,0,0,1,.78,3.16,6.06,6.06,0,0,1-.78,3.13,5.09,5.09,0,0,1-2.19,2,7.41,7.41,0,0,1-3.32.7H81V72.63h3.9A7.28,7.28,0,0,1,88.22,73.35Zm-.13,8.41a4.32,4.32,0,0,0,1.1-3.17,4.45,4.45,0,0,0-1.1-3.22,4.22,4.22,0,0,0-3.19-1.16H83v8.67h1.9a4.32,4.32,0,0,0,3.19-1.12Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777-5",
    "data-name": "Path 3777",
    d: "M99.64,84.46l-4.59-5.29v5.29H93.11V72.63h1.94V78l4.6-5.4h2.44l-5.15,5.92,5.23,5.91Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357-5",
    "data-name": "Line 357",
    y2: 14.17,
    transform: "translate(65 71.44)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8939",
    "data-name": "Group 8939",
    transform: "translate(-3668.106 -10157.603) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2446.38, -1435.76)",
    filter: "url(#Rectangle_1742-51)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-119",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2622.21 1081.02) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_73._APIs-SDK_for_real-time_tracking-6",
    "data-name": "73._APIs-SDK for real-time tracking",
    transform: "translate(32.95 32.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3767-6",
    "data-name": "Path 3767",
    d: "M37.08,96.63l18.09,18.09H66.19",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355-6",
    "data-name": "Line 355",
    y1: 20.64,
    transform: "translate(19.04 49.71)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768-6",
    "data-name": "Path 3768",
    d: "M35.91,52.88V22.71H28.05",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769-6",
    "data-name": "Path 3769",
    d: "M83.2,96.63v10.91H99.16",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-12",
    "data-name": "Path 926",
    d: "M100.08,46.93c.22-2.56-.33-4-2-4.77a7.13,7.13,0,0,1-4.39-9.08,6.8,6.8,0,0,1,.82-1.64,3.39,3.39,0,0,0-.32-4.1,28.22,28.22,0,0,0-6.06-5.64,3.3,3.3,0,0,0-4.63-.05,7,7,0,0,1-3.83,1.46,7.22,7.22,0,0,1-7-3.79,3.33,3.33,0,0,0-4.3-1.94,26.67,26.67,0,0,0-6.93,2.15,3.33,3.33,0,0,0-2.25,4A7.19,7.19,0,0,1,53,31.62a7.44,7.44,0,0,1-1.7,0,3.26,3.26,0,0,0-3.5,1.93,22,22,0,0,0-2.16,8.94,3.23,3.23,0,0,0,2.45,3.64,7.21,7.21,0,0,1,3.38,11,3.14,3.14,0,0,0,.13,4.26,26.89,26.89,0,0,0,6.07,5.64,3.33,3.33,0,0,0,4.6-.03,7.77,7.77,0,0,1,2.95-1.59,7.12,7.12,0,0,1,8.12,3.42c.65,1.08,1.19,2.27,2.67,2.42a3.52,3.52,0,0,0,1.17.08,26.8,26.8,0,0,0,8-2.69A3.07,3.07,0,0,0,87,65a7.26,7.26,0,0,1,6-8.34,6.91,6.91,0,0,1,1.7-.08,3.34,3.34,0,0,0,3.54-2.27A26,26,0,0,0,100.08,46.93ZM70.82,53.29a7.639,7.639,0,1,1,0,.02Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770-6",
    "data-name": "Path 3770",
    d: "M111,77.16A19.47,19.47,0,0,0,86,58.48a22.17,22.17,0,0,0-39.54-5.71,10.1,10.1,0,0,0-15.28,8.67c0,.27,0,.54,0,.8a17.3,17.3,0,0,0,1,34.31v.08H93.43v-.1A19.47,19.47,0,0,0,111,77.16Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_976-6",
    "data-name": "Ellipse 976",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(15.76 16.58)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_977-6",
    "data-name": "Ellipse 977",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(12.91 44.58)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_978-6",
    "data-name": "Ellipse 978",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(64.62 108.59)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_979-6",
    "data-name": "Ellipse 979",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(90.37 101.41)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_980-6",
    "data-name": "Ellipse 980",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(104.83 30.36)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_981-6",
    "data-name": "Ellipse 981",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(94.58 9.15)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_356-6",
    "data-name": "Line 356",
    y2: 33.21,
    transform: "translate(110.96 42.62)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771-6",
    "data-name": "Path 3771",
    d: "M33.13,82h-5l-.85,2.41h-2L29.54,72.6h2.25L36,84.43H34Zm-.55-1.58L30.66,75l-1.93,5.49Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772-6",
    "data-name": "Path 3772",
    d: "M45.69,77.84a3.23,3.23,0,0,1-1.36,1.3,5.09,5.09,0,0,1-2.4.5H39.79v4.79H37.85V72.62h4.08a5.06,5.06,0,0,1,2.31.47,3.34,3.34,0,0,1,1.41,1.26,3.48,3.48,0,0,1,.46,1.79A3.62,3.62,0,0,1,45.69,77.84Zm-2.11-.29a1.82,1.82,0,0,0,.54-1.41c0-1.3-.73-1.94-2.19-1.94H39.79v3.86h2.14a2.33,2.33,0,0,0,1.65-.51Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773-6",
    "data-name": "Path 3773",
    d: "M49.9,72.62V84.43H48V72.62Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3774-6",
    "data-name": "Path 3774",
    d: "M53.87,84.18a3.49,3.49,0,0,1-1.38-1.08,2.8,2.8,0,0,1-.55-1.54h2a1.33,1.33,0,0,0,.57,1,2,2,0,0,0,1.3.4,2.17,2.17,0,0,0,1.26-.31,1,1,0,0,0,.45-.81.82.82,0,0,0-.5-.78,8.811,8.811,0,0,0-1.59-.56,17.249,17.249,0,0,1-1.71-.56,3.06,3.06,0,0,1-1.15-.84,2.18,2.18,0,0,1-.48-1.48,2.25,2.25,0,0,1,.44-1.36,2.87,2.87,0,0,1,1.26-1,4.7,4.7,0,0,1,1.9-.36,3.9,3.9,0,0,1,2.57.81,2.89,2.89,0,0,1,1,2.2H57.38a1.35,1.35,0,0,0-.51-1,1.89,1.89,0,0,0-1.24-.38,2,2,0,0,0-1.17.29.9.9,0,0,0-.41.77.83.83,0,0,0,.27.63,2,2,0,0,0,.66.4l1.16.36a13.061,13.061,0,0,1,1.67.55,3,3,0,0,1,1.13.83,2.15,2.15,0,0,1,.5,1.44A2.45,2.45,0,0,1,59,83.24a3,3,0,0,1-1.25,1,4.81,4.81,0,0,1-1.9.35,4.67,4.67,0,0,1-1.98-.41Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775-6",
    "data-name": "Path 3775",
    d: "M72.5,84.17A3.54,3.54,0,0,1,71,83a3,3,0,0,1-.55-1.79h2.08a1.88,1.88,0,0,0,.6,1.26,2.15,2.15,0,0,0,1.51.5,2.31,2.31,0,0,0,1.57-.49,1.58,1.58,0,0,0,.56-1.25,1.37,1.37,0,0,0-.35-1,2.33,2.33,0,0,0-.87-.58,11.84,11.84,0,0,0-1.44-.44,14.24,14.24,0,0,1-1.88-.62,3.14,3.14,0,0,1-1.23-1,2.86,2.86,0,0,1-.51-1.77A3.14,3.14,0,0,1,71,74.06a3.22,3.22,0,0,1,1.43-1.18,5.22,5.22,0,0,1,2.13-.41,4.44,4.44,0,0,1,2.81.86,3.16,3.16,0,0,1,1.22,2.36H76.46a1.54,1.54,0,0,0-.62-1.1,2.24,2.24,0,0,0-1.48-.46,2.1,2.1,0,0,0-1.36.42,1.5,1.5,0,0,0-.53,1.23,1.24,1.24,0,0,0,.33.89,2.24,2.24,0,0,0,.85.55,12.09,12.09,0,0,0,1.39.45,14.749,14.749,0,0,1,1.92.64,3.28,3.28,0,0,1,1.26,1,2.92,2.92,0,0,1,.52,1.8,3.16,3.16,0,0,1-.49,1.7,3.47,3.47,0,0,1-1.41,1.29,4.71,4.71,0,0,1-2.19.48,5.49,5.49,0,0,1-2.15-.41Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3776-6",
    "data-name": "Path 3776",
    d: "M88.22,73.35a5.17,5.17,0,0,1,2.19,2.08,6.2,6.2,0,0,1,.78,3.16,6.06,6.06,0,0,1-.78,3.13,5.09,5.09,0,0,1-2.19,2,7.41,7.41,0,0,1-3.32.7H81V72.63h3.9A7.28,7.28,0,0,1,88.22,73.35Zm-.13,8.41a4.32,4.32,0,0,0,1.1-3.17,4.45,4.45,0,0,0-1.1-3.22,4.22,4.22,0,0,0-3.19-1.16H83v8.67h1.9a4.32,4.32,0,0,0,3.19-1.12Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777-6",
    "data-name": "Path 3777",
    d: "M99.64,84.46l-4.59-5.29v5.29H93.11V72.63h1.94V78l4.6-5.4h2.44l-5.15,5.92,5.23,5.91Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357-6",
    "data-name": "Line 357",
    y2: 14.17,
    transform: "translate(65 71.44)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-35",
    "data-name": "Group 8903",
    transform: "translate(-3490.674 -10700.884) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2697.7, -922.46)",
    filter: "url(#Rectangle_1742-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-120",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2799.83 538.03) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_74._Easy_to_integrate-5",
    "data-name": "74._Easy to integrate",
    transform: "translate(32.765 32.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3778-5",
    "data-name": "Path 3778",
    d: "M34.43,39.74V21.44h68.78v87.12H34.43V94.55",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-13",
    "data-name": "Path 926",
    d: "M59.07,83.33c1.89-.26,2.88-.88,3.16-2.21a5.35,5.35,0,0,1,6-4.66,4.52,4.52,0,0,1,1.31.34,2.59,2.59,0,0,0,3-.9,20.77,20.77,0,0,0,3.14-5.33,2.46,2.46,0,0,0-.69-3.39,5.47,5.47,0,0,1-.04-8.32,2.5,2.5,0,0,0,.73-3.46,21.46,21.46,0,0,0-2.69-4.72,2.48,2.48,0,0,0-3.28-1,5.41,5.41,0,0,1-6.92-3.24,6,6,0,0,1-.28-1.25,2.43,2.43,0,0,0-2-2.25,16.13,16.13,0,0,0-6.88-.13,2.36,2.36,0,0,0-2,1.29V58.28a6.77,6.77,0,0,1,5-2.21,6.9,6.9,0,1,1,0,13.79,7,7,0,0,1-4.94-2.19V82.13a2.48,2.48,0,0,0,1.79,1,19.85,19.85,0,0,0,5.59.2Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779-5",
    "data-name": "Path 3779",
    d: "M51.57,39.75c0,2.26-1.85,4.31-4.86,5.81a28.3,28.3,0,0,1-12.28,2.51,28.3,28.3,0,0,1-12.28-2.51c-3-1.5-4.86-3.55-4.86-5.81,0-4.6,7.67-8.33,17.14-8.33S51.57,35.15,51.57,39.75Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3780-5",
    "data-name": "Path 3780",
    d: "M51.57,51.37V63c0,2.25-1.86,4.3-4.87,5.81a28.29,28.29,0,0,1-12.27,2.51A28.29,28.29,0,0,1,22.16,68.8c-3-1.51-4.87-3.56-4.87-5.81V51.37c0,2.26,1.85,4.31,4.86,5.81a28.3,28.3,0,0,0,12.28,2.51,28.3,28.3,0,0,0,12.28-2.51C49.72,55.68,51.57,53.63,51.57,51.37Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3781-5",
    "data-name": "Path 3781",
    d: "M51.57,39.75V51.37c0,2.26-1.85,4.31-4.86,5.81a28.3,28.3,0,0,1-12.28,2.51,28.3,28.3,0,0,1-12.28-2.51c-3-1.5-4.86-3.55-4.86-5.81V39.75c0,2.26,1.85,4.31,4.86,5.81a28.3,28.3,0,0,0,12.28,2.51,28.3,28.3,0,0,0,12.28-2.51C49.72,44.06,51.57,42,51.57,39.75Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3782-5",
    "data-name": "Path 3782",
    d: "M51.57,63V74.61c0,2.25-1.86,4.3-4.87,5.81a28.29,28.29,0,0,1-12.27,2.51,28.29,28.29,0,0,1-12.27-2.51c-3-1.51-4.87-3.56-4.87-5.81V63c0,2.25,1.86,4.3,4.87,5.81a28.29,28.29,0,0,0,12.27,2.51A28.29,28.29,0,0,0,46.7,68.8C49.71,67.29,51.57,65.24,51.57,63Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783-5",
    "data-name": "Path 3783",
    d: "M51.57,74.61V86.23c0,4.59-7.67,8.32-17.14,8.32s-17.14-3.73-17.14-8.32V74.61c0,2.25,1.86,4.3,4.87,5.81a28.29,28.29,0,0,0,12.27,2.51A28.29,28.29,0,0,0,46.7,80.42C49.71,78.91,51.57,76.86,51.57,74.61Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1720-5",
    "data-name": "Rectangle 1720",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 31.42)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1721-5",
    "data-name": "Rectangle 1721",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 57.82)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1722-5",
    "data-name": "Rectangle 1722",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 84.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_358-5",
    "data-name": "Line 358",
    x2: 4.85,
    transform: "translate(101.13 90.39)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359-5",
    "data-name": "Line 359",
    x2: 4.85,
    transform: "translate(101.13 96.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_360-5",
    "data-name": "Line 360",
    x2: 4.85,
    transform: "translate(101.13 64)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361-5",
    "data-name": "Line 361",
    x2: 4.85,
    transform: "translate(101.13 69.93)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_362-5",
    "data-name": "Line 362",
    x2: 4.85,
    transform: "translate(101.13 37.6)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363-5",
    "data-name": "Line 363",
    x2: 4.85,
    transform: "translate(101.13 43.54)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_982-5",
    "data-name": "Ellipse 982",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(62.69 15.31)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_983-5",
    "data-name": "Ellipse 983",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(62.69 102.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8942",
    "data-name": "Group 8942",
    transform: "translate(-3416.391 -10192.979) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2700.57, -1435.76)",
    filter: "url(#Rectangle_1742-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-121",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2874.11 1045.94) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_74._Easy_to_integrate-6",
    "data-name": "74._Easy to integrate",
    transform: "translate(32.765 32.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3778-6",
    "data-name": "Path 3778",
    d: "M34.43,39.74V21.44h68.78v87.12H34.43V94.55",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-14",
    "data-name": "Path 926",
    d: "M59.07,83.33c1.89-.26,2.88-.88,3.16-2.21a5.35,5.35,0,0,1,6-4.66,4.52,4.52,0,0,1,1.31.34,2.59,2.59,0,0,0,3-.9,20.77,20.77,0,0,0,3.14-5.33,2.46,2.46,0,0,0-.69-3.39,5.47,5.47,0,0,1-.04-8.32,2.5,2.5,0,0,0,.73-3.46,21.46,21.46,0,0,0-2.69-4.72,2.48,2.48,0,0,0-3.28-1,5.41,5.41,0,0,1-6.92-3.24,6,6,0,0,1-.28-1.25,2.43,2.43,0,0,0-2-2.25,16.13,16.13,0,0,0-6.88-.13,2.36,2.36,0,0,0-2,1.29V58.28a6.77,6.77,0,0,1,5-2.21,6.9,6.9,0,1,1,0,13.79,7,7,0,0,1-4.94-2.19V82.13a2.48,2.48,0,0,0,1.79,1,19.85,19.85,0,0,0,5.59.2Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779-6",
    "data-name": "Path 3779",
    d: "M51.57,39.75c0,2.26-1.85,4.31-4.86,5.81a28.3,28.3,0,0,1-12.28,2.51,28.3,28.3,0,0,1-12.28-2.51c-3-1.5-4.86-3.55-4.86-5.81,0-4.6,7.67-8.33,17.14-8.33S51.57,35.15,51.57,39.75Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3780-6",
    "data-name": "Path 3780",
    d: "M51.57,51.37V63c0,2.25-1.86,4.3-4.87,5.81a28.29,28.29,0,0,1-12.27,2.51A28.29,28.29,0,0,1,22.16,68.8c-3-1.51-4.87-3.56-4.87-5.81V51.37c0,2.26,1.85,4.31,4.86,5.81a28.3,28.3,0,0,0,12.28,2.51,28.3,28.3,0,0,0,12.28-2.51C49.72,55.68,51.57,53.63,51.57,51.37Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3781-6",
    "data-name": "Path 3781",
    d: "M51.57,39.75V51.37c0,2.26-1.85,4.31-4.86,5.81a28.3,28.3,0,0,1-12.28,2.51,28.3,28.3,0,0,1-12.28-2.51c-3-1.5-4.86-3.55-4.86-5.81V39.75c0,2.26,1.85,4.31,4.86,5.81a28.3,28.3,0,0,0,12.28,2.51,28.3,28.3,0,0,0,12.28-2.51C49.72,44.06,51.57,42,51.57,39.75Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3782-6",
    "data-name": "Path 3782",
    d: "M51.57,63V74.61c0,2.25-1.86,4.3-4.87,5.81a28.29,28.29,0,0,1-12.27,2.51,28.29,28.29,0,0,1-12.27-2.51c-3-1.51-4.87-3.56-4.87-5.81V63c0,2.25,1.86,4.3,4.87,5.81a28.29,28.29,0,0,0,12.27,2.51A28.29,28.29,0,0,0,46.7,68.8C49.71,67.29,51.57,65.24,51.57,63Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783-6",
    "data-name": "Path 3783",
    d: "M51.57,74.61V86.23c0,4.59-7.67,8.32-17.14,8.32s-17.14-3.73-17.14-8.32V74.61c0,2.25,1.86,4.3,4.87,5.81a28.29,28.29,0,0,0,12.27,2.51A28.29,28.29,0,0,0,46.7,80.42C49.71,78.91,51.57,76.86,51.57,74.61Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1720-6",
    "data-name": "Rectangle 1720",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 31.42)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1721-6",
    "data-name": "Rectangle 1721",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 57.82)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1722-6",
    "data-name": "Rectangle 1722",
    width: 18.3,
    height: 18.3,
    transform: "translate(94.41 84.21)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_358-6",
    "data-name": "Line 358",
    x2: 4.85,
    transform: "translate(101.13 90.39)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359-6",
    "data-name": "Line 359",
    x2: 4.85,
    transform: "translate(101.13 96.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_360-6",
    "data-name": "Line 360",
    x2: 4.85,
    transform: "translate(101.13 64)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361-6",
    "data-name": "Line 361",
    x2: 4.85,
    transform: "translate(101.13 69.93)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_362-6",
    "data-name": "Line 362",
    x2: 4.85,
    transform: "translate(101.13 37.6)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363-6",
    "data-name": "Line 363",
    x2: 4.85,
    transform: "translate(101.13 43.54)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_982-6",
    "data-name": "Ellipse 982",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(62.69 15.31)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_983-6",
    "data-name": "Ellipse 983",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(62.69 102.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8934",
    "data-name": "Group 8934",
    transform: "translate(-4136.163 -9835.134) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1938, -1689.95)",
    filter: "url(#Rectangle_1742-54)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-122",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2154.64 1404.24) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_75._Scalable_Solutions-3",
    "data-name": "75._Scalable Solutions",
    transform: "translate(32.451 33.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3784-3",
    "data-name": "Path 3784",
    d: "M18.21,41.35V24.88H121.7v78.41H18.21V90.67",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3785-3",
    "data-name": "Path 3785",
    d: "M59.8,41.36V24.88h61.9v78.41H59.8V90.67",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926-15",
    "data-name": "Path 926",
    d: "M82.33,79c1.56-.21,2.37-.72,2.6-1.82a4.41,4.41,0,0,1,4.9-3.83,3.66,3.66,0,0,1,1.08.28,2.14,2.14,0,0,0,2.44-.74,17.18,17.18,0,0,0,2.58-4.39,2,2,0,0,0-.57-2.79A4.27,4.27,0,0,1,94,63.6a4.46,4.46,0,0,1,1.36-4.72,2.06,2.06,0,0,0,.6-2.85,17.819,17.819,0,0,0-2.21-3.89A2,2,0,0,0,91,51.33a4.45,4.45,0,0,1-5.69-2.67,5.911,5.911,0,0,1-.23-1,2,2,0,0,0-1.62-1.85,13.18,13.18,0,0,0-5.66-.11,2,2,0,0,0-1.65,1.06V58.4a5.58,5.58,0,0,1,4.09-1.82,5.68,5.68,0,1,1-4.09,9.55V78a2,2,0,0,0,1.47.85,15.75,15.75,0,0,0,4.71.15Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3786-3",
    "data-name": "Path 3786",
    d: "M75.23,41.36c0,2-1.67,3.88-4.38,5.23a25.53,25.53,0,0,1-11,2.26,25.53,25.53,0,0,1-11-2.26c-2.71-1.35-4.37-3.2-4.37-5.23,0-4.14,6.9-7.5,15.42-7.5S75.23,37.22,75.23,41.36Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3787-3",
    "data-name": "Path 3787",
    d: "M75.23,51.82V62.27c0,2-1.68,3.87-4.39,5.23a25.37,25.37,0,0,1-11,2.26,25.37,25.37,0,0,1-11-2.26c-2.71-1.36-4.38-3.2-4.38-5.23V51.82c0,2,1.66,3.87,4.37,5.22a25.39,25.39,0,0,0,11,2.26,25.39,25.39,0,0,0,11-2.26C73.56,55.69,75.23,53.85,75.23,51.82Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3788-3",
    "data-name": "Path 3788",
    d: "M75.23,41.36V51.82c0,2-1.67,3.87-4.38,5.22a25.39,25.39,0,0,1-11,2.26,25.39,25.39,0,0,1-11-2.26c-2.71-1.35-4.37-3.19-4.37-5.22V41.36c0,2,1.66,3.88,4.37,5.23a25.53,25.53,0,0,0,11,2.26,25.53,25.53,0,0,0,11-2.26C73.56,45.24,75.23,43.39,75.23,41.36Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3789-3",
    "data-name": "Path 3789",
    d: "M75.23,62.27V72.73c0,2-1.68,3.87-4.39,5.23a25.52,25.52,0,0,1-11,2.26,25.52,25.52,0,0,1-11-2.26c-2.71-1.36-4.38-3.21-4.38-5.23V62.27c0,2,1.67,3.87,4.38,5.23a25.37,25.37,0,0,0,11,2.26,25.37,25.37,0,0,0,11-2.26C73.55,66.14,75.23,64.3,75.23,62.27Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3790-3",
    "data-name": "Path 3790",
    d: "M75.23,72.73V83.19c0,4.13-6.91,7.48-15.43,7.48s-15.42-3.35-15.42-7.48V72.73c0,2,1.67,3.87,4.38,5.23a25.52,25.52,0,0,0,11,2.26,25.52,25.52,0,0,0,11-2.26C73.55,76.6,75.23,74.75,75.23,72.73Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3791-3",
    "data-name": "Path 3791",
    d: "M33.64,41.36c0,2-1.67,3.88-4.38,5.23a25.53,25.53,0,0,1-11,2.26,25.53,25.53,0,0,1-11-2.26c-2.71-1.35-4.37-3.2-4.37-5.23,0-4.14,6.9-7.5,15.42-7.5S33.64,37.22,33.64,41.36Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3792-3",
    "data-name": "Path 3792",
    d: "M33.64,51.82V62.27c0,2-1.68,3.87-4.39,5.23a25.37,25.37,0,0,1-11,2.26,25.37,25.37,0,0,1-11-2.26c-2.71-1.36-4.38-3.2-4.38-5.23V51.82c0,2,1.66,3.87,4.37,5.22A25.39,25.39,0,0,0,18.21,59.3,25.39,25.39,0,0,0,29.26,57C32,55.69,33.64,53.85,33.64,51.82Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3793-3",
    "data-name": "Path 3793",
    d: "M33.64,41.36V51.82c0,2-1.67,3.87-4.38,5.22a25.39,25.39,0,0,1-11,2.26A25.39,25.39,0,0,1,7.16,57c-2.71-1.35-4.37-3.19-4.37-5.22V41.36c0,2,1.66,3.88,4.37,5.23a25.53,25.53,0,0,0,11.05,2.26,25.53,25.53,0,0,0,11.05-2.26C32,45.24,33.64,43.39,33.64,41.36Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3794-3",
    "data-name": "Path 3794",
    d: "M33.64,62.27V72.73c0,2-1.68,3.87-4.39,5.23a25.52,25.52,0,0,1-11,2.26A25.52,25.52,0,0,1,7.17,78c-2.71-1.36-4.38-3.21-4.38-5.23V62.27c0,2,1.67,3.87,4.38,5.23a25.37,25.37,0,0,0,11,2.26,25.37,25.37,0,0,0,11-2.26C32,66.14,33.64,64.3,33.64,62.27Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3795-3",
    "data-name": "Path 3795",
    d: "M33.64,72.73V83.19c0,4.13-6.91,7.48-15.43,7.48S2.79,87.32,2.79,83.19V72.73c0,2,1.67,3.87,4.38,5.23a25.52,25.52,0,0,0,11,2.26,25.52,25.52,0,0,0,11-2.26C32,76.6,33.64,74.75,33.64,72.73Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1725-3",
    "data-name": "Rectangle 1725",
    width: 16.47,
    height: 16.47,
    transform: "translate(112.79 94.17) rotate(90)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1726-3",
    "data-name": "Rectangle 1726",
    width: 16.47,
    height: 16.47,
    transform: "translate(89.04 94.16) rotate(90)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_364-3",
    "data-name": "Line 364",
    y2: 4.36,
    transform: "translate(83.48 100.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_365-3",
    "data-name": "Line 365",
    y2: 4.36,
    transform: "translate(78.14 100.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_366-3",
    "data-name": "Line 366",
    y2: 4.36,
    transform: "translate(107.23 100.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_367-3",
    "data-name": "Line 367",
    y2: 4.36,
    transform: "translate(101.89 100.22)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_984-3",
    "data-name": "Ellipse 984",
    cx: 5.51,
    cy: 5.51,
    r: 5.51,
    transform: "translate(85.24 19.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_985-3",
    "data-name": "Ellipse 985",
    cx: 5.51,
    cy: 5.51,
    r: 5.51,
    transform: "translate(102.75 19.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3796-3",
    "data-name": "Path 3796",
    d: "M121.7,83.85a5.5,5.5,0,0,1-5.49-5V50.4a5.438,5.438,0,0,1,0-.57,5.52,5.52,0,1,1,11,0V78.84a5.51,5.51,0,0,1-5.51,5.01Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8937",
    "data-name": "Group 8937",
    transform: "translate(-3884.448 -9870.51) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2192.19, -1689.95)",
    filter: "url(#Rectangle_1742-55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-123",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2406.05 1368.41) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_76._Developer-friendly_features-3",
    "data-name": "76._Developer-friendly features",
    transform: "translate(32.765 32.94)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_986-3",
    "data-name": "Ellipse 986",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(95.32 4.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_368-3",
    "data-name": "Line 368",
    y2: 33.21,
    transform: "translate(101.45 16.63)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3797-3",
    "data-name": "Path 3797",
    d: "M21,106.2l13.83,13.83h8.42",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_987-3",
    "data-name": "Ellipse 987",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(43.25 113.9)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_369-3",
    "data-name": "Line 369",
    y1: 20.65,
    transform: "translate(79.06 8.91)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_988-3",
    "data-name": "Ellipse 988",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(72.93 3.49)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3798-3",
    "data-name": "Path 3798",
    d: "M45.52,40.78V10.62H37.66",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_989-3",
    "data-name": "Ellipse 989",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(25.38 4.49)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1729-3",
    "data-name": "Rectangle 1729",
    width: 112.05,
    height: 84.73,
    rx: 3,
    transform: "translate(8.97 22.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1730-3",
    "data-name": "Rectangle 1730",
    width: 112.05,
    height: 84.73,
    rx: 3,
    transform: "translate(8.97 22.64)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_370-3",
    "data-name": "Line 370",
    x2: 112.06,
    transform: "translate(8.97 41)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799-3",
    "data-name": "Path 3799",
    d: "M26.52,31.82a3.71,3.71,0,1,1-3.71-3.71A3.71,3.71,0,0,1,26.52,31.82Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3800-3",
    "data-name": "Path 3800",
    d: "M38.4,31.82a3.72,3.72,0,1,1-3.71-3.71,3.72,3.72,0,0,1,3.71,3.71Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_371-3",
    "data-name": "Line 371",
    x2: 19.3,
    transform: "translate(19.1 54.63)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_372-3",
    "data-name": "Line 372",
    x2: 35.27,
    transform: "translate(19.1 67.67)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_373-3",
    "data-name": "Line 373",
    x2: 35.27,
    transform: "translate(19.1 80.7)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_374-3",
    "data-name": "Line 374",
    x2: 35.27,
    transform: "translate(19.1 93.73)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801-3",
    "data-name": "Path 3801",
    d: "M76.79,92.72l-1-7.26H69.06l-1,7.26h-5.4l6-37.08h7.89l6,37.08Zm-7-12.29H75l-2.65-18.7Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802-3",
    "data-name": "Path 3802",
    d: "M85.37,92.72V55.64H94c5.78,0,8.69,3.07,8.69,9.16v3.66c0,6.09-2.91,9.16-8.69,9.16H91.2v15.1ZM91.2,72.33H94c1.91,0,2.86-1,2.86-3.5v-4.4c0-2.54-1-3.49-2.86-3.49H91.2Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803-3",
    "data-name": "Path 3803",
    d: "M105.76,92.72V55.64h5.83V92.72Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804-3",
    "data-name": "Path 3804",
    d: "M69.8,109.1v10.91H85.75",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_990-3",
    "data-name": "Ellipse 990",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(76.97 113.88)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_991-3",
    "data-name": "Ellipse 991",
    cx: 6.13,
    cy: 6.13,
    r: 6.13,
    transform: "translate(102.55 113.88)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8940",
    "data-name": "Group 8940",
    transform: "translate(-3632.729 -9905.887) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2446.38, -1689.95)",
    filter: "url(#Rectangle_1742-56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-124",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2657.7 1333.54) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_12._Digital_Signage-9",
    "data-name": "12._Digital Signage",
    transform: "translate(40 32.487)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711-9",
    "data-name": "Rectangle 1711",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712-9",
    "data-name": "Rectangle 1712",
    width: 85.52,
    height: 64.67,
    rx: 3,
    transform: "translate(2.86 4.01)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_350-9",
    "data-name": "Line 350",
    x2: 85.52,
    transform: "translate(2.86 18.02)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762-9",
    "data-name": "Path 3762",
    d: "M16.25,11a2.83,2.83,0,1,1-.825-2.008A2.84,2.84,0,0,1,16.25,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763-9",
    "data-name": "Path 3763",
    d: "M25.31,11a2.83,2.83,0,1,1-.825-2.008A2.83,2.83,0,0,1,25.31,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764-9",
    "data-name": "Path 3764",
    d: "M80.65,11a2.83,2.83,0,0,1-2.83,2.83H58.48a2.83,2.83,0,1,1,0-5.66H77.82A2.83,2.83,0,0,1,80.65,11Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_351-9",
    "data-name": "Line 351",
    x2: 14.73,
    transform: "translate(10.58 28.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_352-9",
    "data-name": "Line 352",
    x2: 28.45,
    transform: "translate(10.58 38.38)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_353-9",
    "data-name": "Line 353",
    x2: 28.45,
    transform: "translate(10.58 48.32)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_354-9",
    "data-name": "Line 354",
    x2: 28.45,
    transform: "translate(10.58 58.27)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713-9",
    "data-name": "Rectangle 1713",
    width: 29.84,
    height: 29.84,
    transform: "translate(50.81 28.43)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715-9",
    "data-name": "Rectangle 1715",
    width: 45.28,
    height: 67.63,
    transform: "translate(67.01 28.74)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716-9",
    "data-name": "Rectangle 1716",
    width: 45.28,
    height: 7.5,
    transform: "translate(67.01 118.18)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717-9",
    "data-name": "Rectangle 1717",
    width: 10.84,
    height: 21.81,
    transform: "translate(84.23 96.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765-9",
    "data-name": "Path 3765",
    d: "M89.61,76.09a13.53,13.53,0,1,1,13.57-13.51A13.53,13.53,0,0,1,89.61,76.09Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766-9",
    "data-name": "Path 3766",
    d: "M86.27,62.55v-4a1,1,0,0,1,.45-1,.93.93,0,0,1,1,.13l6.4,4c.78.49.77,1.17,0,1.65l-6.4,4c-.33.2-.71.4-1,.11a1.53,1.53,0,0,1-.44-.93C86.24,65.23,86.27,63.89,86.27,62.55Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8943",
    "data-name": "Group 8943",
    transform: "translate(-3381.014 -9941.263) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2700.57, -1689.95)",
    filter: "url(#Rectangle_1742-57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-125",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2909.49 1297.66) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8893-8",
    "data-name": "Group 8893",
    transform: "translate(28.678 33.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691-8",
    "data-name": "Path 3691",
    d: "M122.642,91.188a20.076,20.076,0,0,0-25.8-19.266,22.878,22.878,0,0,0-40.8-5.863,10.413,10.413,0,0,0-15.76,8.947v.821a17.836,17.836,0,0,0,1.044,35.3v.082H104.56v-.082a20.1,20.1,0,0,0,18.082-19.935Z",
    transform: "translate(-3.032 -2.068)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1670-8",
    "data-name": "Rectangle 1670",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692-8",
    "data-name": "Path 3692",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671-8",
    "data-name": "Rectangle 1671",
    width: 7.88,
    height: 12.125,
    transform: "translate(6.473 48.161)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672-8",
    "data-name": "Rectangle 1672",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693-8",
    "data-name": "Path 3693",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673-8",
    "data-name": "Rectangle 1673",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674-8",
    "data-name": "Rectangle 1674",
    width: 22.796,
    height: 14.212,
    transform: "translate(114.778 46.072)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675-8",
    "data-name": "Rectangle 1675",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694-8",
    "data-name": "Path 3694",
    d: "M117.384,55.162a3,3,0,1,1-3-3,3,3,0,0,1,3,3Z",
    transform: "translate(11.795 -2.721)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676-8",
    "data-name": "Rectangle 1676",
    width: 42.825,
    height: 35.754,
    transform: "translate(49.498 93.237)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677-8",
    "data-name": "Rectangle 1677",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678-8",
    "data-name": "Rectangle 1678",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679-8",
    "data-name": "Rectangle 1679",
    width: 38.943,
    height: 6.004,
    transform: "translate(51.443 24.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680-8",
    "data-name": "Rectangle 1680",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681-8",
    "data-name": "Rectangle 1681",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294-8",
    "data-name": "Line 294",
    y2: 17.355,
    transform: "translate(70.91 36.469)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695-8",
    "data-name": "Path 3695",
    d: "M115.461,61.41v6.52L105.13,78.5",
    transform: "translate(10.715 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696-8",
    "data-name": "Path 3696",
    d: "M15.22,61.41v6.52L29.808,82.858",
    transform: "translate(-4.807 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697-8",
    "data-name": "Path 3697",
    d: "M81.083,102.009a17.59,17.59,0,0,0-24.883,0",
    transform: "translate(2.267 4.993)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698-8",
    "data-name": "Path 3698",
    d: "M76.88,106.03a12.383,12.383,0,0,0-17.59,0",
    transform: "translate(2.802 5.945)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699-8",
    "data-name": "Path 3699",
    d: "M71.934,109.763a6.3,6.3,0,0,0-8.924,0",
    transform: "translate(3.443 6.904)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700-8",
    "data-name": "Path 3700",
    d: "M69.083,113.269a1.982,1.982,0,1,1-1.976-1.83A1.982,1.982,0,0,1,69.083,113.269Z",
    transform: "translate(3.809 7.512)",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-36",
    "data-name": "Group 8903",
    transform: "translate(-6173.642 -10062.544) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, 48, -1181.19)",
    filter: "url(#Rectangle_1742-58)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-126",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(117.11 1176.41) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8893-9",
    "data-name": "Group 8893",
    transform: "translate(29.241 33.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691-9",
    "data-name": "Path 3691",
    d: "M122.642,91.188a20.076,20.076,0,0,0-25.8-19.266,22.878,22.878,0,0,0-40.8-5.863,10.413,10.413,0,0,0-15.76,8.947v.821a17.836,17.836,0,0,0,1.044,35.3v.082H104.56v-.082a20.1,20.1,0,0,0,18.082-19.935Z",
    transform: "translate(-3.032 -2.068)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1670-9",
    "data-name": "Rectangle 1670",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692-9",
    "data-name": "Path 3692",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671-9",
    "data-name": "Rectangle 1671",
    width: 7.88,
    height: 12.125,
    transform: "translate(6.473 48.161)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672-9",
    "data-name": "Rectangle 1672",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693-9",
    "data-name": "Path 3693",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673-9",
    "data-name": "Rectangle 1673",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674-9",
    "data-name": "Rectangle 1674",
    width: 22.796,
    height: 14.212,
    transform: "translate(114.778 46.072)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675-9",
    "data-name": "Rectangle 1675",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694-9",
    "data-name": "Path 3694",
    d: "M117.384,55.162a3,3,0,1,1-3-3,3,3,0,0,1,3,3Z",
    transform: "translate(11.795 -2.721)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676-9",
    "data-name": "Rectangle 1676",
    width: 42.825,
    height: 35.754,
    transform: "translate(49.498 93.237)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677-9",
    "data-name": "Rectangle 1677",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678-9",
    "data-name": "Rectangle 1678",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679-9",
    "data-name": "Rectangle 1679",
    width: 38.943,
    height: 6.004,
    transform: "translate(51.443 24.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680-9",
    "data-name": "Rectangle 1680",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681-9",
    "data-name": "Rectangle 1681",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294-9",
    "data-name": "Line 294",
    y2: 17.355,
    transform: "translate(70.91 36.469)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695-9",
    "data-name": "Path 3695",
    d: "M115.461,61.41v6.52L105.13,78.5",
    transform: "translate(10.715 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696-9",
    "data-name": "Path 3696",
    d: "M15.22,61.41v6.52L29.808,82.858",
    transform: "translate(-4.807 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697-9",
    "data-name": "Path 3697",
    d: "M81.083,102.009a17.59,17.59,0,0,0-24.883,0",
    transform: "translate(2.267 4.993)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698-9",
    "data-name": "Path 3698",
    d: "M76.88,106.03a12.383,12.383,0,0,0-17.59,0",
    transform: "translate(2.802 5.945)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699-9",
    "data-name": "Path 3699",
    d: "M71.934,109.763a6.3,6.3,0,0,0-8.924,0",
    transform: "translate(3.443 6.904)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700-9",
    "data-name": "Path 3700",
    d: "M69.083,113.269a1.982,1.982,0,1,1-1.976-1.83A1.982,1.982,0,0,1,69.083,113.269Z",
    transform: "translate(3.809 7.512)",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-37",
    "data-name": "Group 8903",
    transform: "translate(-5921.926 -10097.92) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -206.19, -1181.19)",
    filter: "url(#Rectangle_1742-59)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-127",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(368.64 1141.06) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2._Cloud_Solution-4",
    "data-name": "2._Cloud_Solution",
    transform: "translate(33.006 33.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3701-4",
    "data-name": "Path 3701",
    d: "M120.19,55.26A23.6,23.6,0,0,0,89.93,32.63,26.88,26.88,0,0,0,42,25.71,12.24,12.24,0,0,0,23.51,36.22c0,.33,0,.65,0,1a21,21,0,0,0,1.2,41.57v.09H99v-.11a23.61,23.61,0,0,0,21.19-23.51Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1683-4",
    "data-name": "Rectangle 1683",
    width: 49.59,
    height: 75.46,
    rx: 4.54,
    transform: "translate(38.2 49.54)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684-4",
    "data-name": "Rectangle 1684",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 58.11)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1685-4",
    "data-name": "Rectangle 1685",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 74.28)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1686-4",
    "data-name": "Rectangle 1686",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 90.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687-4",
    "data-name": "Rectangle 1687",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 106.63)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702-4",
    "data-name": "Path 3702",
    d: "M124.2,9.91a16.77,16.77,0,0,0-23.71,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3703-4",
    "data-name": "Path 3703",
    d: "M120.7,14.65a11.82,11.82,0,0,0-16.71,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3704-4",
    "data-name": "Path 3704",
    d: "M116.6,19.12a6,6,0,0,0-8.51,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3705-4",
    "data-name": "Path 3705",
    d: "M114.23,23a1.89,1.89,0,1,1-1.88-1.88A1.89,1.89,0,0,1,114.23,23Z",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-38",
    "data-name": "Group 8903",
    transform: "translate(-5670.208 -10133.297) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -460.38, -1181.19)",
    filter: "url(#Rectangle_1742-60)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-128",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(620.16 1105.71) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_5._Smart_Metering-4",
    "data-name": "5._Smart_Metering",
    transform: "translate(32.28 33.126)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1691-4",
    "data-name": "Rectangle 1691",
    width: 82.05,
    height: 84.73,
    rx: 3,
    transform: "translate(9.58 8.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1692-4",
    "data-name": "Rectangle 1692",
    width: 82.05,
    height: 84.73,
    rx: 3,
    transform: "translate(9.58 8.94)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_315-4",
    "data-name": "Line 315",
    x2: 82.05,
    transform: "translate(9.58 27.3)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722-4",
    "data-name": "Path 3722",
    d: "M27.13,18.12a3.71,3.71,0,1,1-3.71-3.71,3.71,3.71,0,0,1,3.71,3.71Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723-4",
    "data-name": "Path 3723",
    d: "M39,18.12a3.71,3.71,0,1,1-3.71-3.71A3.71,3.71,0,0,1,39,18.12Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724-4",
    "data-name": "Path 3724",
    d: "M81.51,18.12a3.71,3.71,0,0,1-3.71,3.71H62.46a3.71,3.71,0,0,1,0-7.42H77.8A3.71,3.71,0,0,1,81.51,18.12Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_316-4",
    "data-name": "Line 316",
    x2: 19.29,
    transform: "translate(19.71 40.94)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317-4",
    "data-name": "Line 317",
    x2: 37.27,
    transform: "translate(19.71 53.97)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318-4",
    "data-name": "Line 318",
    x2: 37.27,
    transform: "translate(19.71 67)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319-4",
    "data-name": "Line 319",
    x2: 37.27,
    transform: "translate(19.71 80.03)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1693-4",
    "data-name": "Rectangle 1693",
    width: 5.82,
    height: 8.86,
    transform: "translate(52.26 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1694-4",
    "data-name": "Rectangle 1694",
    width: 5.82,
    height: 8.86,
    transform: "translate(52.26 73.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1695-4",
    "data-name": "Rectangle 1695",
    width: 49.47,
    height: 52.84,
    transform: "translate(64.52 53.56)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1696-4",
    "data-name": "Rectangle 1696",
    width: 33.84,
    height: 13.1,
    transform: "translate(72.33 86.86)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1697-4",
    "data-name": "Rectangle 1697",
    width: 62.33,
    height: 56.21,
    transform: "translate(58.08 37.39)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1698-4",
    "data-name": "Rectangle 1698",
    width: 48.52,
    height: 42.39,
    transform: "translate(64.99 44.3)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_973-4",
    "data-name": "Ellipse 973",
    cx: 4.53,
    cy: 4.53,
    r: 4.53,
    transform: "translate(74.42 70.92)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_974-4",
    "data-name": "Ellipse 974",
    cx: 4.53,
    cy: 4.53,
    r: 4.53,
    transform: "translate(95.02 70.92)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1699-4",
    "data-name": "Rectangle 1699",
    width: 33.84,
    height: 9.15,
    transform: "translate(72.33 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_320-4",
    "data-name": "Line 320",
    y2: 9.14,
    transform: "translate(80.79 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321-4",
    "data-name": "Line 321",
    y2: 9.14,
    transform: "translate(89.25 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322-4",
    "data-name": "Line 322",
    y2: 9.14,
    transform: "translate(97.71 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725-4",
    "data-name": "Path 3725",
    d: "M41.18,120.85c-1,.12-1.5-.58-2.08-1.19a4.73,4.73,0,0,0-5.74-1.06,5.17,5.17,0,0,0-1.69,1.46,2.21,2.21,0,0,1-3,.71A18.12,18.12,0,0,1,24,118a2.09,2.09,0,0,1-.69-2.75,4.8,4.8,0,0,0-3.76-6.68,2.14,2.14,0,0,1-2.11-2,14.54,14.54,0,0,1,.13-6.09,2.16,2.16,0,0,1,2-1.76,4.76,4.76,0,0,0,4-6.36,2.2,2.2,0,0,1,.89-2.93A17.65,17.65,0,0,1,28.57,87a2.24,2.24,0,0,1,3.08.65,4.79,4.79,0,0,0,5.09,1.46A4.69,4.69,0,0,0,39,87.63,2.21,2.21,0,0,1,42,87a18.57,18.57,0,0,1,4.74,2.8,2.23,2.23,0,0,1,.78,2.61c-.94,3.22.58,5.75,3.85,6.44,1.18.25,1.74,1.12,2,2.81a16.28,16.28,0,0,1-.17,5.07,2.2,2.2,0,0,1-2,2,4.82,4.82,0,0,0-3.79,6.55,2,2,0,0,1-.7,2.61,17.9,17.9,0,0,1-4.79,2.86,2.2,2.2,0,0,1-.74.1ZM35.3,109.94a6.2,6.2,0,1,0-6.1-6,6.11,6.11,0,0,0,6.1,6Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_975-4",
    "data-name": "Ellipse 975",
    cx: 7.4,
    cy: 7.4,
    r: 7.4,
    transform: "translate(26.802 109.998) rotate(-80.78)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726-4",
    "data-name": "Path 3726",
    d: "M104.08,12.13l-3.89,7.3,6.06.07-3.03,7.39",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-39",
    "data-name": "Group 8903",
    transform: "translate(-5418.492 -10168.673) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -714.57, -1181.19)",
    filter: "url(#Rectangle_1742-61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-129",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(871.69 1070.36) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_9._Railways-4",
    "data-name": "9._Railways",
    transform: "translate(32.771 31.637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1708-4",
    "data-name": "Rectangle 1708",
    width: 80.23,
    height: 60.67,
    rx: 3,
    transform: "translate(44.1 7.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1709-4",
    "data-name": "Rectangle 1709",
    width: 80.23,
    height: 60.67,
    rx: 3,
    transform: "translate(44.1 7.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_341-4",
    "data-name": "Line 341",
    x2: 80.23,
    transform: "translate(44.1 20.58)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748-4",
    "data-name": "Path 3748",
    d: "M56.66,14A2.66,2.66,0,1,1,54,11.35,2.66,2.66,0,0,1,56.66,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749-4",
    "data-name": "Path 3749",
    d: "M65.16,14a2.66,2.66,0,1,1-2.65-2.65A2.66,2.66,0,0,1,65.16,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750-4",
    "data-name": "Path 3750",
    d: "M117.08,14a2.66,2.66,0,0,1-2.66,2.66H96.28a2.66,2.66,0,1,1,0-5.31h18.14A2.66,2.66,0,0,1,117.08,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_342-4",
    "data-name": "Line 342",
    x2: 13.81,
    transform: "translate(51.35 30.34)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343-4",
    "data-name": "Line 343",
    x2: 26.69,
    transform: "translate(51.35 39.67)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_344-4",
    "data-name": "Line 344",
    x2: 26.69,
    transform: "translate(51.35 49)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_345-4",
    "data-name": "Line 345",
    x2: 26.69,
    transform: "translate(51.35 58.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710-4",
    "data-name": "Rectangle 1710",
    width: 27.99,
    height: 27.99,
    transform: "translate(89.09 30.34)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751-4",
    "data-name": "Path 3751",
    d: "M106.51,104.38a5.82,5.82,0,0,1-5.82,5.82h-69a5.82,5.82,0,0,1-5.82-5.82V41.16A11.64,11.64,0,0,1,37.46,29.52H94.87a11.64,11.64,0,0,1,11.64,11.64Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752-4",
    "data-name": "Path 3752",
    d: "M31.95,125l6.35-14.8H94.03l6.36,14.8",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_346-4",
    "data-name": "Line 346",
    x2: 62.08,
    transform: "translate(35.13 118.22)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753-4",
    "data-name": "Path 3753",
    d: "M42.11,44.72H90.23a5.18,5.18,0,0,1,5.18,5.18V60.83a2.59,2.59,0,0,1-2.59,2.59H39.52a2.59,2.59,0,0,1-2.59-2.59V49.89A5.18,5.18,0,0,1,42.11,44.72Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_347-4",
    "data-name": "Line 347",
    x2: 43.39,
    transform: "translate(44.47 59.93)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348-4",
    "data-name": "Line 348",
    x2: 12.12,
    transform: "translate(60.11 91.27)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754-4",
    "data-name": "Path 3754",
    d: "M50.5,91.27a6.79,6.79,0,1,1-6.79-6.78,6.79,6.79,0,0,1,6.79,6.78Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755-4",
    "data-name": "Path 3755",
    d: "M95.4,91.27a6.78,6.78,0,1,1-6.78-6.78A6.78,6.78,0,0,1,95.4,91.27Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756-4",
    "data-name": "Path 3756",
    d: "M50.5,91.27a6.79,6.79,0,1,1-6.79-6.78,6.79,6.79,0,0,1,6.79,6.78Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757-4",
    "data-name": "Path 3757",
    d: "M95.4,91.27a6.78,6.78,0,1,1-6.78-6.78A6.78,6.78,0,0,1,95.4,91.27Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758-4",
    "data-name": "Path 3758",
    d: "M29.44,13.68a17.33,17.33,0,0,0-24.54,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759-4",
    "data-name": "Path 3759",
    d: "M26.08,18.56a12.58,12.58,0,0,0-17.82,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760-4",
    "data-name": "Path 3760",
    d: "M22.73,23.25a7.85,7.85,0,0,0-11.12,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761-4",
    "data-name": "Path 3761",
    d: "M19.81,27.8a2.64,2.64,0,1,1-2.64-2.64,2.64,2.64,0,0,1,2.64,2.64Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349-4",
    "data-name": "Line 349",
    y2: 18.7,
    transform: "translate(66.17 44.72)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-40",
    "data-name": "Group 8903",
    transform: "translate(-5190.305 -10200.742) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -945, -1181.19)",
    filter: "url(#Rectangle_1742-62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-130",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1100.44 1038.21) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8893-10",
    "data-name": "Group 8893",
    transform: "translate(29.241 33.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691-10",
    "data-name": "Path 3691",
    d: "M122.642,91.188a20.076,20.076,0,0,0-25.8-19.266,22.878,22.878,0,0,0-40.8-5.863,10.413,10.413,0,0,0-15.76,8.947v.821a17.836,17.836,0,0,0,1.044,35.3v.082H104.56v-.082a20.1,20.1,0,0,0,18.082-19.935Z",
    transform: "translate(-3.032 -2.068)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1670-10",
    "data-name": "Rectangle 1670",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692-10",
    "data-name": "Path 3692",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671-10",
    "data-name": "Rectangle 1671",
    width: 7.88,
    height: 12.125,
    transform: "translate(6.473 48.161)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672-10",
    "data-name": "Rectangle 1672",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693-10",
    "data-name": "Path 3693",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673-10",
    "data-name": "Rectangle 1673",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674-10",
    "data-name": "Rectangle 1674",
    width: 22.796,
    height: 14.212,
    transform: "translate(114.778 46.072)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675-10",
    "data-name": "Rectangle 1675",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694-10",
    "data-name": "Path 3694",
    d: "M117.384,55.162a3,3,0,1,1-3-3,3,3,0,0,1,3,3Z",
    transform: "translate(11.795 -2.721)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676-10",
    "data-name": "Rectangle 1676",
    width: 42.825,
    height: 35.754,
    transform: "translate(49.498 93.237)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677-10",
    "data-name": "Rectangle 1677",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678-10",
    "data-name": "Rectangle 1678",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679-10",
    "data-name": "Rectangle 1679",
    width: 38.943,
    height: 6.004,
    transform: "translate(51.443 24.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680-10",
    "data-name": "Rectangle 1680",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681-10",
    "data-name": "Rectangle 1681",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294-10",
    "data-name": "Line 294",
    y2: 17.355,
    transform: "translate(70.91 36.469)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695-10",
    "data-name": "Path 3695",
    d: "M115.461,61.41v6.52L105.13,78.5",
    transform: "translate(10.715 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696-10",
    "data-name": "Path 3696",
    d: "M15.22,61.41v6.52L29.808,82.858",
    transform: "translate(-4.807 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697-10",
    "data-name": "Path 3697",
    d: "M81.083,102.009a17.59,17.59,0,0,0-24.883,0",
    transform: "translate(2.267 4.993)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698-10",
    "data-name": "Path 3698",
    d: "M76.88,106.03a12.383,12.383,0,0,0-17.59,0",
    transform: "translate(2.802 5.945)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699-10",
    "data-name": "Path 3699",
    d: "M71.934,109.763a6.3,6.3,0,0,0-8.924,0",
    transform: "translate(3.443 6.904)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700-10",
    "data-name": "Path 3700",
    d: "M69.083,113.269a1.982,1.982,0,1,1-1.976-1.83A1.982,1.982,0,0,1,69.083,113.269Z",
    transform: "translate(3.809 7.512)",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-41",
    "data-name": "Group 8903",
    transform: "translate(-4938.59 -10236.119) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1199.19, -1181.19)",
    filter: "url(#Rectangle_1742-63)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-131",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1351.97 1002.86) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2._Cloud_Solution-5",
    "data-name": "2._Cloud_Solution",
    transform: "translate(33.006 33.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3701-5",
    "data-name": "Path 3701",
    d: "M120.19,55.26A23.6,23.6,0,0,0,89.93,32.63,26.88,26.88,0,0,0,42,25.71,12.24,12.24,0,0,0,23.51,36.22c0,.33,0,.65,0,1a21,21,0,0,0,1.2,41.57v.09H99v-.11a23.61,23.61,0,0,0,21.19-23.51Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1683-5",
    "data-name": "Rectangle 1683",
    width: 49.59,
    height: 75.46,
    rx: 4.54,
    transform: "translate(38.2 49.54)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684-5",
    "data-name": "Rectangle 1684",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 58.11)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1685-5",
    "data-name": "Rectangle 1685",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 74.28)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1686-5",
    "data-name": "Rectangle 1686",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 90.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687-5",
    "data-name": "Rectangle 1687",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 106.63)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702-5",
    "data-name": "Path 3702",
    d: "M124.2,9.91a16.77,16.77,0,0,0-23.71,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3703-5",
    "data-name": "Path 3703",
    d: "M120.7,14.65a11.82,11.82,0,0,0-16.71,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3704-5",
    "data-name": "Path 3704",
    d: "M116.6,19.12a6,6,0,0,0-8.51,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3705-5",
    "data-name": "Path 3705",
    d: "M114.23,23a1.89,1.89,0,1,1-1.88-1.88A1.89,1.89,0,0,1,114.23,23Z",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-42",
    "data-name": "Group 8903",
    transform: "translate(-4686.872 -10271.495) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1453.38, -1181.19)",
    filter: "url(#Rectangle_1742-64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-132",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(1603.5 967.51) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_5._Smart_Metering-5",
    "data-name": "5._Smart_Metering",
    transform: "translate(32.28 33.126)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1691-5",
    "data-name": "Rectangle 1691",
    width: 82.05,
    height: 84.73,
    rx: 3,
    transform: "translate(9.58 8.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1692-5",
    "data-name": "Rectangle 1692",
    width: 82.05,
    height: 84.73,
    rx: 3,
    transform: "translate(9.58 8.94)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_315-5",
    "data-name": "Line 315",
    x2: 82.05,
    transform: "translate(9.58 27.3)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722-5",
    "data-name": "Path 3722",
    d: "M27.13,18.12a3.71,3.71,0,1,1-3.71-3.71,3.71,3.71,0,0,1,3.71,3.71Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723-5",
    "data-name": "Path 3723",
    d: "M39,18.12a3.71,3.71,0,1,1-3.71-3.71A3.71,3.71,0,0,1,39,18.12Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724-5",
    "data-name": "Path 3724",
    d: "M81.51,18.12a3.71,3.71,0,0,1-3.71,3.71H62.46a3.71,3.71,0,0,1,0-7.42H77.8A3.71,3.71,0,0,1,81.51,18.12Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_316-5",
    "data-name": "Line 316",
    x2: 19.29,
    transform: "translate(19.71 40.94)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317-5",
    "data-name": "Line 317",
    x2: 37.27,
    transform: "translate(19.71 53.97)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318-5",
    "data-name": "Line 318",
    x2: 37.27,
    transform: "translate(19.71 67)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319-5",
    "data-name": "Line 319",
    x2: 37.27,
    transform: "translate(19.71 80.03)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1693-5",
    "data-name": "Rectangle 1693",
    width: 5.82,
    height: 8.86,
    transform: "translate(52.26 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1694-5",
    "data-name": "Rectangle 1694",
    width: 5.82,
    height: 8.86,
    transform: "translate(52.26 73.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1695-5",
    "data-name": "Rectangle 1695",
    width: 49.47,
    height: 52.84,
    transform: "translate(64.52 53.56)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1696-5",
    "data-name": "Rectangle 1696",
    width: 33.84,
    height: 13.1,
    transform: "translate(72.33 86.86)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1697-5",
    "data-name": "Rectangle 1697",
    width: 62.33,
    height: 56.21,
    transform: "translate(58.08 37.39)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1698-5",
    "data-name": "Rectangle 1698",
    width: 48.52,
    height: 42.39,
    transform: "translate(64.99 44.3)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_973-5",
    "data-name": "Ellipse 973",
    cx: 4.53,
    cy: 4.53,
    r: 4.53,
    transform: "translate(74.42 70.92)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_974-5",
    "data-name": "Ellipse 974",
    cx: 4.53,
    cy: 4.53,
    r: 4.53,
    transform: "translate(95.02 70.92)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1699-5",
    "data-name": "Rectangle 1699",
    width: 33.84,
    height: 9.15,
    transform: "translate(72.33 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_320-5",
    "data-name": "Line 320",
    y2: 9.14,
    transform: "translate(80.79 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321-5",
    "data-name": "Line 321",
    y2: 9.14,
    transform: "translate(89.25 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322-5",
    "data-name": "Line 322",
    y2: 9.14,
    transform: "translate(97.71 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725-5",
    "data-name": "Path 3725",
    d: "M41.18,120.85c-1,.12-1.5-.58-2.08-1.19a4.73,4.73,0,0,0-5.74-1.06,5.17,5.17,0,0,0-1.69,1.46,2.21,2.21,0,0,1-3,.71A18.12,18.12,0,0,1,24,118a2.09,2.09,0,0,1-.69-2.75,4.8,4.8,0,0,0-3.76-6.68,2.14,2.14,0,0,1-2.11-2,14.54,14.54,0,0,1,.13-6.09,2.16,2.16,0,0,1,2-1.76,4.76,4.76,0,0,0,4-6.36,2.2,2.2,0,0,1,.89-2.93A17.65,17.65,0,0,1,28.57,87a2.24,2.24,0,0,1,3.08.65,4.79,4.79,0,0,0,5.09,1.46A4.69,4.69,0,0,0,39,87.63,2.21,2.21,0,0,1,42,87a18.57,18.57,0,0,1,4.74,2.8,2.23,2.23,0,0,1,.78,2.61c-.94,3.22.58,5.75,3.85,6.44,1.18.25,1.74,1.12,2,2.81a16.28,16.28,0,0,1-.17,5.07,2.2,2.2,0,0,1-2,2,4.82,4.82,0,0,0-3.79,6.55,2,2,0,0,1-.7,2.61,17.9,17.9,0,0,1-4.79,2.86,2.2,2.2,0,0,1-.74.1ZM35.3,109.94a6.2,6.2,0,1,0-6.1-6,6.11,6.11,0,0,0,6.1,6Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_975-5",
    "data-name": "Ellipse 975",
    cx: 7.4,
    cy: 7.4,
    r: 7.4,
    transform: "translate(26.802 109.998) rotate(-80.78)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726-5",
    "data-name": "Path 3726",
    d: "M104.08,12.13l-3.89,7.3,6.06.07-3.03,7.39",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-43",
    "data-name": "Group 8903",
    transform: "translate(-4435.156 -10306.872) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1707.57, -1181.19)",
    filter: "url(#Rectangle_1743)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1743-2",
    "data-name": "Rectangle 1743",
    width: 226.143,
    height: 226.143,
    rx: 14,
    transform: "translate(1837.69 919.16) rotate(-8)",
    fill: "#0561fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_9._Railways-5",
    "data-name": "9._Railways",
    transform: "translate(32.771 31.637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1708-5",
    "data-name": "Rectangle 1708",
    width: 80.23,
    height: 60.67,
    rx: 3,
    transform: "translate(44.1 7.43)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1709-5",
    "data-name": "Rectangle 1709",
    width: 80.23,
    height: 60.67,
    rx: 3,
    transform: "translate(44.1 7.43)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_341-5",
    "data-name": "Line 341",
    x2: 80.23,
    transform: "translate(44.1 20.58)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748-5",
    "data-name": "Path 3748",
    d: "M56.66,14A2.66,2.66,0,1,1,54,11.35,2.66,2.66,0,0,1,56.66,14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749-5",
    "data-name": "Path 3749",
    d: "M65.16,14a2.66,2.66,0,1,1-2.65-2.65A2.66,2.66,0,0,1,65.16,14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750-5",
    "data-name": "Path 3750",
    d: "M117.08,14a2.66,2.66,0,0,1-2.66,2.66H96.28a2.66,2.66,0,1,1,0-5.31h18.14A2.66,2.66,0,0,1,117.08,14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_342-5",
    "data-name": "Line 342",
    x2: 13.81,
    transform: "translate(51.35 30.34)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343-5",
    "data-name": "Line 343",
    x2: 26.69,
    transform: "translate(51.35 39.67)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_344-5",
    "data-name": "Line 344",
    x2: 26.69,
    transform: "translate(51.35 49)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_345-5",
    "data-name": "Line 345",
    x2: 26.69,
    transform: "translate(51.35 58.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710-5",
    "data-name": "Rectangle 1710",
    width: 27.99,
    height: 27.99,
    transform: "translate(89.09 30.34)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751-5",
    "data-name": "Path 3751",
    d: "M106.51,104.38a5.82,5.82,0,0,1-5.82,5.82h-69a5.82,5.82,0,0,1-5.82-5.82V41.16A11.64,11.64,0,0,1,37.46,29.52H94.87a11.64,11.64,0,0,1,11.64,11.64Z",
    fill: "#0561fc",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752-5",
    "data-name": "Path 3752",
    d: "M31.95,125l6.35-14.8H94.03l6.36,14.8",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_346-5",
    "data-name": "Line 346",
    x2: 62.08,
    transform: "translate(35.13 118.22)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753-5",
    "data-name": "Path 3753",
    d: "M42.11,44.72H90.23a5.18,5.18,0,0,1,5.18,5.18V60.83a2.59,2.59,0,0,1-2.59,2.59H39.52a2.59,2.59,0,0,1-2.59-2.59V49.89A5.18,5.18,0,0,1,42.11,44.72Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_347-5",
    "data-name": "Line 347",
    x2: 43.39,
    transform: "translate(44.47 59.93)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348-5",
    "data-name": "Line 348",
    x2: 12.12,
    transform: "translate(60.11 91.27)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754-5",
    "data-name": "Path 3754",
    d: "M50.5,91.27a6.79,6.79,0,1,1-6.79-6.78,6.79,6.79,0,0,1,6.79,6.78Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755-5",
    "data-name": "Path 3755",
    d: "M95.4,91.27a6.78,6.78,0,1,1-6.78-6.78A6.78,6.78,0,0,1,95.4,91.27Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756-5",
    "data-name": "Path 3756",
    d: "M50.5,91.27a6.79,6.79,0,1,1-6.79-6.78,6.79,6.79,0,0,1,6.79,6.78Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757-5",
    "data-name": "Path 3757",
    d: "M95.4,91.27a6.78,6.78,0,1,1-6.78-6.78A6.78,6.78,0,0,1,95.4,91.27Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758-5",
    "data-name": "Path 3758",
    d: "M29.44,13.68a17.33,17.33,0,0,0-24.54,0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759-5",
    "data-name": "Path 3759",
    d: "M26.08,18.56a12.58,12.58,0,0,0-17.82,0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760-5",
    "data-name": "Path 3760",
    d: "M22.73,23.25a7.85,7.85,0,0,0-11.12,0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761-5",
    "data-name": "Path 3761",
    d: "M19.81,27.8a2.64,2.64,0,1,1-2.64-2.64,2.64,2.64,0,0,1,2.64,2.64Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349-5",
    "data-name": "Line 349",
    y2: 18.7,
    transform: "translate(66.17 44.72)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-44",
    "data-name": "Group 8903",
    transform: "translate(-4206.969 -10338.941) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -1938, -1181.19)",
    filter: "url(#Rectangle_1742-65)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-133",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2083.78 900.01) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8893-11",
    "data-name": "Group 8893",
    transform: "translate(29.241 33.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691-11",
    "data-name": "Path 3691",
    d: "M122.642,91.188a20.076,20.076,0,0,0-25.8-19.266,22.878,22.878,0,0,0-40.8-5.863,10.413,10.413,0,0,0-15.76,8.947v.821a17.836,17.836,0,0,0,1.044,35.3v.082H104.56v-.082a20.1,20.1,0,0,0,18.082-19.935Z",
    transform: "translate(-3.032 -2.068)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1670-11",
    "data-name": "Rectangle 1670",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692-11",
    "data-name": "Path 3692",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1671-11",
    "data-name": "Rectangle 1671",
    width: 7.88,
    height: 12.125,
    transform: "translate(6.473 48.161)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1672-11",
    "data-name": "Rectangle 1672",
    width: 20.838,
    height: 18.786,
    transform: "translate(0 41.499)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693-11",
    "data-name": "Path 3693",
    d: "M27.178,46.936H6.34L16.765,36.5Z",
    transform: "translate(-6.34 -5.425)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673-11",
    "data-name": "Rectangle 1673",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674-11",
    "data-name": "Rectangle 1674",
    width: 22.796,
    height: 14.212,
    transform: "translate(114.778 46.072)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675-11",
    "data-name": "Rectangle 1675",
    width: 22.796,
    height: 37.876,
    transform: "translate(114.778 22.41)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694-11",
    "data-name": "Path 3694",
    d: "M117.384,55.162a3,3,0,1,1-3-3,3,3,0,0,1,3,3Z",
    transform: "translate(11.795 -2.721)",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676-11",
    "data-name": "Rectangle 1676",
    width: 42.825,
    height: 35.754,
    transform: "translate(49.498 93.237)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677-11",
    "data-name": "Rectangle 1677",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678-11",
    "data-name": "Rectangle 1678",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679-11",
    "data-name": "Rectangle 1679",
    width: 38.943,
    height: 6.004,
    transform: "translate(51.443 24.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680-11",
    "data-name": "Rectangle 1680",
    width: 38.943,
    height: 30.465,
    transform: "translate(51.443 0)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681-11",
    "data-name": "Rectangle 1681",
    width: 20.228,
    height: 6.004,
    transform: "translate(60.802 30.466)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294-11",
    "data-name": "Line 294",
    y2: 17.355,
    transform: "translate(70.91 36.469)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695-11",
    "data-name": "Path 3695",
    d: "M115.461,61.41v6.52L105.13,78.5",
    transform: "translate(10.715 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696-11",
    "data-name": "Path 3696",
    d: "M15.22,61.41v6.52L29.808,82.858",
    transform: "translate(-4.807 -1.124)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697-11",
    "data-name": "Path 3697",
    d: "M81.083,102.009a17.59,17.59,0,0,0-24.883,0",
    transform: "translate(2.267 4.993)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698-11",
    "data-name": "Path 3698",
    d: "M76.88,106.03a12.383,12.383,0,0,0-17.59,0",
    transform: "translate(2.802 5.945)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699-11",
    "data-name": "Path 3699",
    d: "M71.934,109.763a6.3,6.3,0,0,0-8.924,0",
    transform: "translate(3.443 6.904)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700-11",
    "data-name": "Path 3700",
    d: "M69.083,113.269a1.982,1.982,0,1,1-1.976-1.83A1.982,1.982,0,0,1,69.083,113.269Z",
    transform: "translate(3.809 7.512)",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-45",
    "data-name": "Group 8903",
    transform: "translate(-3955.254 -10374.317) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2192.19, -1181.19)",
    filter: "url(#Rectangle_1742-66)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-134",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2335.31 864.66) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_2._Cloud_Solution-6",
    "data-name": "2._Cloud_Solution",
    transform: "translate(33.006 33.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3701-6",
    "data-name": "Path 3701",
    d: "M120.19,55.26A23.6,23.6,0,0,0,89.93,32.63,26.88,26.88,0,0,0,42,25.71,12.24,12.24,0,0,0,23.51,36.22c0,.33,0,.65,0,1a21,21,0,0,0,1.2,41.57v.09H99v-.11a23.61,23.61,0,0,0,21.19-23.51Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1683-6",
    "data-name": "Rectangle 1683",
    width: 49.59,
    height: 75.46,
    rx: 4.54,
    transform: "translate(38.2 49.54)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684-6",
    "data-name": "Rectangle 1684",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 58.11)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1685-6",
    "data-name": "Rectangle 1685",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 74.28)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1686-6",
    "data-name": "Rectangle 1686",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 90.45)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687-6",
    "data-name": "Rectangle 1687",
    width: 35.79,
    height: 9.81,
    transform: "translate(45.1 106.63)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702-6",
    "data-name": "Path 3702",
    d: "M124.2,9.91a16.77,16.77,0,0,0-23.71,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3703-6",
    "data-name": "Path 3703",
    d: "M120.7,14.65a11.82,11.82,0,0,0-16.71,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3704-6",
    "data-name": "Path 3704",
    d: "M116.6,19.12a6,6,0,0,0-8.51,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3705-6",
    "data-name": "Path 3705",
    d: "M114.23,23a1.89,1.89,0,1,1-1.88-1.88A1.89,1.89,0,0,1,114.23,23Z",
    fill: "#0561fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-46",
    "data-name": "Group 8903",
    transform: "translate(-3703.535 -10409.694) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2446.38, -1181.19)",
    filter: "url(#Rectangle_1742-67)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-135",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2586.84 829.31) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_5._Smart_Metering-6",
    "data-name": "5._Smart_Metering",
    transform: "translate(32.28 33.126)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1691-6",
    "data-name": "Rectangle 1691",
    width: 82.05,
    height: 84.73,
    rx: 3,
    transform: "translate(9.58 8.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1692-6",
    "data-name": "Rectangle 1692",
    width: 82.05,
    height: 84.73,
    rx: 3,
    transform: "translate(9.58 8.94)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_315-6",
    "data-name": "Line 315",
    x2: 82.05,
    transform: "translate(9.58 27.3)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722-6",
    "data-name": "Path 3722",
    d: "M27.13,18.12a3.71,3.71,0,1,1-3.71-3.71,3.71,3.71,0,0,1,3.71,3.71Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723-6",
    "data-name": "Path 3723",
    d: "M39,18.12a3.71,3.71,0,1,1-3.71-3.71A3.71,3.71,0,0,1,39,18.12Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724-6",
    "data-name": "Path 3724",
    d: "M81.51,18.12a3.71,3.71,0,0,1-3.71,3.71H62.46a3.71,3.71,0,0,1,0-7.42H77.8A3.71,3.71,0,0,1,81.51,18.12Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_316-6",
    "data-name": "Line 316",
    x2: 19.29,
    transform: "translate(19.71 40.94)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_317-6",
    "data-name": "Line 317",
    x2: 37.27,
    transform: "translate(19.71 53.97)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_318-6",
    "data-name": "Line 318",
    x2: 37.27,
    transform: "translate(19.71 67)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_319-6",
    "data-name": "Line 319",
    x2: 37.27,
    transform: "translate(19.71 80.03)",
    fill: "none",
    stroke: "#c5e1f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1693-6",
    "data-name": "Rectangle 1693",
    width: 5.82,
    height: 8.86,
    transform: "translate(52.26 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1694-6",
    "data-name": "Rectangle 1694",
    width: 5.82,
    height: 8.86,
    transform: "translate(52.26 73.37)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1695-6",
    "data-name": "Rectangle 1695",
    width: 49.47,
    height: 52.84,
    transform: "translate(64.52 53.56)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1696-6",
    "data-name": "Rectangle 1696",
    width: 33.84,
    height: 13.1,
    transform: "translate(72.33 86.86)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1697-6",
    "data-name": "Rectangle 1697",
    width: 62.33,
    height: 56.21,
    transform: "translate(58.08 37.39)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1698-6",
    "data-name": "Rectangle 1698",
    width: 48.52,
    height: 42.39,
    transform: "translate(64.99 44.3)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_973-6",
    "data-name": "Ellipse 973",
    cx: 4.53,
    cy: 4.53,
    r: 4.53,
    transform: "translate(74.42 70.92)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_974-6",
    "data-name": "Ellipse 974",
    cx: 4.53,
    cy: 4.53,
    r: 4.53,
    transform: "translate(95.02 70.92)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1699-6",
    "data-name": "Rectangle 1699",
    width: 33.84,
    height: 9.15,
    transform: "translate(72.33 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_320-6",
    "data-name": "Line 320",
    y2: 9.14,
    transform: "translate(80.79 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321-6",
    "data-name": "Line 321",
    y2: 9.14,
    transform: "translate(89.25 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322-6",
    "data-name": "Line 322",
    y2: 9.14,
    transform: "translate(97.71 55.43)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725-6",
    "data-name": "Path 3725",
    d: "M41.18,120.85c-1,.12-1.5-.58-2.08-1.19a4.73,4.73,0,0,0-5.74-1.06,5.17,5.17,0,0,0-1.69,1.46,2.21,2.21,0,0,1-3,.71A18.12,18.12,0,0,1,24,118a2.09,2.09,0,0,1-.69-2.75,4.8,4.8,0,0,0-3.76-6.68,2.14,2.14,0,0,1-2.11-2,14.54,14.54,0,0,1,.13-6.09,2.16,2.16,0,0,1,2-1.76,4.76,4.76,0,0,0,4-6.36,2.2,2.2,0,0,1,.89-2.93A17.65,17.65,0,0,1,28.57,87a2.24,2.24,0,0,1,3.08.65,4.79,4.79,0,0,0,5.09,1.46A4.69,4.69,0,0,0,39,87.63,2.21,2.21,0,0,1,42,87a18.57,18.57,0,0,1,4.74,2.8,2.23,2.23,0,0,1,.78,2.61c-.94,3.22.58,5.75,3.85,6.44,1.18.25,1.74,1.12,2,2.81a16.28,16.28,0,0,1-.17,5.07,2.2,2.2,0,0,1-2,2,4.82,4.82,0,0,0-3.79,6.55,2,2,0,0,1-.7,2.61,17.9,17.9,0,0,1-4.79,2.86,2.2,2.2,0,0,1-.74.1ZM35.3,109.94a6.2,6.2,0,1,0-6.1-6,6.11,6.11,0,0,0,6.1,6Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_975-6",
    "data-name": "Ellipse 975",
    cx: 7.4,
    cy: 7.4,
    r: 7.4,
    transform: "translate(26.802 109.998) rotate(-80.78)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726-6",
    "data-name": "Path 3726",
    d: "M104.08,12.13l-3.89,7.3,6.06.07-3.03,7.39",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8903-47",
    "data-name": "Group 8903",
    transform: "translate(-3451.82 -10445.07) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.99, 0.14, -0.14, 0.99, -2700.57, -1181.19)",
    filter: "url(#Rectangle_1742-68)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742-136",
    "data-name": "Rectangle 1742",
    width: 195.531,
    height: 195.531,
    rx: 14,
    transform: "translate(2838.36 793.96) rotate(-8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_9._Railways-6",
    "data-name": "9._Railways",
    transform: "translate(32.771 31.637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1708-6",
    "data-name": "Rectangle 1708",
    width: 80.23,
    height: 60.67,
    rx: 3,
    transform: "translate(44.1 7.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1709-6",
    "data-name": "Rectangle 1709",
    width: 80.23,
    height: 60.67,
    rx: 3,
    transform: "translate(44.1 7.43)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_341-6",
    "data-name": "Line 341",
    x2: 80.23,
    transform: "translate(44.1 20.58)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748-6",
    "data-name": "Path 3748",
    d: "M56.66,14A2.66,2.66,0,1,1,54,11.35,2.66,2.66,0,0,1,56.66,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749-6",
    "data-name": "Path 3749",
    d: "M65.16,14a2.66,2.66,0,1,1-2.65-2.65A2.66,2.66,0,0,1,65.16,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750-6",
    "data-name": "Path 3750",
    d: "M117.08,14a2.66,2.66,0,0,1-2.66,2.66H96.28a2.66,2.66,0,1,1,0-5.31h18.14A2.66,2.66,0,0,1,117.08,14Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_342-6",
    "data-name": "Line 342",
    x2: 13.81,
    transform: "translate(51.35 30.34)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343-6",
    "data-name": "Line 343",
    x2: 26.69,
    transform: "translate(51.35 39.67)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_344-6",
    "data-name": "Line 344",
    x2: 26.69,
    transform: "translate(51.35 49)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_345-6",
    "data-name": "Line 345",
    x2: 26.69,
    transform: "translate(51.35 58.33)",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710-6",
    "data-name": "Rectangle 1710",
    width: 27.99,
    height: 27.99,
    transform: "translate(89.09 30.34)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751-6",
    "data-name": "Path 3751",
    d: "M106.51,104.38a5.82,5.82,0,0,1-5.82,5.82h-69a5.82,5.82,0,0,1-5.82-5.82V41.16A11.64,11.64,0,0,1,37.46,29.52H94.87a11.64,11.64,0,0,1,11.64,11.64Z",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752-6",
    "data-name": "Path 3752",
    d: "M31.95,125l6.35-14.8H94.03l6.36,14.8",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_346-6",
    "data-name": "Line 346",
    x2: 62.08,
    transform: "translate(35.13 118.22)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753-6",
    "data-name": "Path 3753",
    d: "M42.11,44.72H90.23a5.18,5.18,0,0,1,5.18,5.18V60.83a2.59,2.59,0,0,1-2.59,2.59H39.52a2.59,2.59,0,0,1-2.59-2.59V49.89A5.18,5.18,0,0,1,42.11,44.72Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_347-6",
    "data-name": "Line 347",
    x2: 43.39,
    transform: "translate(44.47 59.93)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348-6",
    "data-name": "Line 348",
    x2: 12.12,
    transform: "translate(60.11 91.27)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754-6",
    "data-name": "Path 3754",
    d: "M50.5,91.27a6.79,6.79,0,1,1-6.79-6.78,6.79,6.79,0,0,1,6.79,6.78Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755-6",
    "data-name": "Path 3755",
    d: "M95.4,91.27a6.78,6.78,0,1,1-6.78-6.78A6.78,6.78,0,0,1,95.4,91.27Z",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756-6",
    "data-name": "Path 3756",
    d: "M50.5,91.27a6.79,6.79,0,1,1-6.79-6.78,6.79,6.79,0,0,1,6.79,6.78Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757-6",
    "data-name": "Path 3757",
    d: "M95.4,91.27a6.78,6.78,0,1,1-6.78-6.78A6.78,6.78,0,0,1,95.4,91.27Z",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758-6",
    "data-name": "Path 3758",
    d: "M29.44,13.68a17.33,17.33,0,0,0-24.54,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759-6",
    "data-name": "Path 3759",
    d: "M26.08,18.56a12.58,12.58,0,0,0-17.82,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760-6",
    "data-name": "Path 3760",
    d: "M22.73,23.25a7.85,7.85,0,0,0-11.12,0",
    fill: "none",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761-6",
    "data-name": "Path 3761",
    d: "M19.81,27.8a2.64,2.64,0,1,1-2.64-2.64,2.64,2.64,0,0,1,2.64,2.64Z",
    fill: "#0561fc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_349-6",
    "data-name": "Line 349",
    y2: 18.7,
    transform: "translate(66.17 44.72)",
    fill: "#fff",
    stroke: "#0561fc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollage);
export default __webpack_public_path__ + "static/media/collage.f37d3ae6b7957d21140d54b82174b0ef.svg";
export { ForwardRef as ReactComponent };